import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import {
  fetchProgress,
} from "../../api/assessmentApi";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import TooltipUI from "../TooltipUI";
import TooltipUI2 from "../TooltipUI2";
import TooltipUIViewOnly from "../TooltipUIViewOnly";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  FaGraduationCap,
  FaRegLightbulb,
  FaUser,
  FaComment,
  FaImage,
  FaChartLine,
  FaReact,
  FaRegCompass, 
  FaBolt,
  FaRss, 
  FaEye,
  FaDownload,
  FaEdit,
  FaCertificate,
  FaUserTie,
  FaCompass,
FaChalkboardTeacher,
FaPenSquare, 
FaSyncAlt, 
FaEnvelope,
FaTrash,
FaUserFriends,
FaLock,
FaInfoCircle,
FaChevronRight,
} from "react-icons/fa";
import { FaBurst, FaChessKing, FaCircleNodes } from "react-icons/fa6";
import "./dashboard.css";
import { getAuthHeaders } from "../../api/assessmentApi";
import { fetchRawAnswers } from "../../api/assessmentApi";
import confetti from 'canvas-confetti';
import { Link } from 'react-router-dom';
import SubjectCareerMapModal from "./SubjectCareerMapModal";
import SubjectSuperCurricularMapModal from "./SubjectSuperCurricularMapModal";
import { loadFeedItems, saveFeedItems, saveFetchTime, loadFetchTimes } from './enrichFeedDb';
import {
  getRawAnswers, saveRawAnswers, clearRawAnswers,
  getSubjectReasons, saveSubjectReasons,
  getJobposts, saveJobposts,
  getSuperActivities, saveSuperActivities,
  getChosenTopSubject, saveChosenTopSubject,
  getActivityStatuses, saveActivityStatuses,
  getPortfolioJobs, savePortfolioJobs,
  getInsightsCache, getStrategyCache,
  getVisualizationsCache, saveVisualizationsCache,
  ensureFacetNoteCacheFreshness, 
  getProfileMatchesCache,
  getSubjectFacetsCache, saveSubjectFacetsCache,
} from './dashboardDb';
import { radius, spacing, fontSize, color, gradientBorder, transition } from './dashboardTokens';
import { avatarStyles } from '../../constants/avatarStyles';
import { useModalContext, getCategoryColor } from '../../constants/ModalContext';
import { ensureFreshCacheVersion } from './cacheVersionUtil';
import KnowledgeUploadForm from "../KnowledgeUploadForm"; 
import { exportUserData } from './exportEngine';
import AskAIWorkspace from "./AskAIWorkspace";
import { useUIFeedback } from "../UIFeedback";
// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);



// Debounce utility to prevent rapid API calls
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const inputStyle = {
  width: "100%", boxSizing: "border-box", padding: "10px 14px",
  background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.15)",
  borderRadius: "8px", color: "white", fontSize: "14px", outline: "none",
};


// Shared row used throughout the Manage Account hub — icon, title, subtitle, chevron.
function AccountMenuRow({ icon, title, subtitle, onClick, disabled, danger }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        display: "flex", alignItems: "center", gap: "14px", width: "100%",
        padding: "13px 14px", background: "rgba(255,255,255,0.03)",
        border: `1px solid ${danger ? "rgba(255,102,102,0.25)" : "rgba(255,255,255,0.08)"}`,
        borderRadius: "10px", cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.45 : 1, textAlign: "left", transition: "background 0.15s ease",
      }}
      onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.background = danger ? "rgba(255,102,102,0.08)" : "rgba(255,255,255,0.06)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.03)"; }}
    >
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        width: "36px", height: "36px", borderRadius: "9px", flexShrink: 0,
        background: danger ? "rgba(255,102,102,0.12)" : "rgba(2,139,232,0.12)",
        color: danger ? "#ff6666" : "#36a7f8", fontSize: "15px",
      }}>
        {icon}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: "14.5px", fontWeight: 600, color: danger ? "#ff8080" : "#eee" }}>{title}</div>
        {subtitle && <div style={{ fontSize: "12px", color: "#888", marginTop: "2px" }}>{subtitle}</div>}
      </div>
      <FaChevronRight style={{ color: "#555", fontSize: "12px", flexShrink: 0 }} />
    </button>
  );
}

function RankedScoreRow({ rank, label, score, max = 5, accent, onClick, isSelected }) {
  const pct = Math.min(100, (score / max) * 100);
  return (
    <div
      onClick={onClick}
      className={`dash-rank-row ${isSelected ? 'dash-rank-row-selected' : ''}`}
      style={{
        display: "flex", alignItems: "center", gap: spacing.base,
        padding: "20px 20px",
        borderRadius: radius.sm, cursor: "pointer",
        background: isSelected ? "rgba(54,167,248,0.10)" : "rgba(255,255,255,0.03)",
        border: `1px solid ${isSelected ? accent : color.border}`,
        marginBottom: spacing.xs,
      }}
    >
      <div style={{
        width: "28px", height: "28px", borderRadius: "50%",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontWeight: 700, fontSize: fontSize.sm, flexShrink: 0,
        background: rank >= 1 ? accent : "rgba(255,255,255,0.08)",
        color: rank >= 1 ? "#0b1021" : color.textSecondary,
      }}>
        {rank}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
          <span style={{ fontSize: fontSize.base, fontWeight: 600, color: color.textPrimary }}>{label}</span>
          <span style={{ fontSize: fontSize.sm, color: color.textSecondary }}>Average: {score.toFixed(1)} / {max}</span>
        </div>
        <div style={{ width: "100%", height: "6px", borderRadius: radius.pill, background: "rgba(255,255,255,0.08)", overflow: "hidden" }}>
          <div
            className="dash-rank-fill"
            style={{
              width: `${pct}%`, height: "100%", borderRadius: radius.pill,
              background: `linear-gradient(90deg, ${accent}, ${color.primaryGlow})`,
            }}
          />
        </div>
      </div>

      <div style={{
        fontSize: "14px", color: isSelected ? accent : "transparent",
        transition: transition.fast, flexShrink: 0,
      }}>
        ▸
      </div>
    </div>
  );
}

export default function Dashboard({ userId, isAdmin = false, onLogout, viewingChildId: viewingChildIdProp, childName: childNameProp }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { confirm, showToast } = useUIFeedback();
  const queryParams = new URLSearchParams(location.search);
  const viewingChildId =
  viewingChildIdProp ||
  queryParams.get("viewingChildId") ||
  location.state?.viewingChildId ||
  null;

const viewingChildName =
  childNameProp ||
  decodeURIComponent(queryParams.get("childName") || "") ||
  location.state?.childName ||
  "Student";

  const [role, setRole] = useState(localStorage.getItem("role") || "user");  
  const isParentView = !!viewingChildId;
  const isReadOnlyView = isParentView;
  const effectiveUserId = isParentView ? viewingChildId : userId;
const viewModeBannerText = isParentView ? (
  <div
    className="view-mode-banner-content"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",     // ← key: pushes link to left, rest to right/center
      width: "85%",
      flexWrap: "wrap",
      gap: "6px",
      padding: "0 8px",
    }}
  >
    {/* Far left: Back button */}
    <Link
      to="/my-student"
      className="back-to-mentees-link"
      style={{
        color: "#60a5fa",
        fontWeight: "600",
        fontSize: "0.95rem",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 12px",
        borderRadius: "6px",
        textDecoration: "none",
        transition: "all 0.18s ease",
        whiteSpace: "nowrap",
        backgroundColor: "rgba(96, 165, 250, 0.08)",
        border: "1px solid rgba(96, 165, 250, 0.25)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(96, 165, 250, 0.18)";
        e.currentTarget.style.color = "#93c5fd";
        e.currentTarget.style.borderColor = "rgba(96, 165, 250, 0.5)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(96, 165, 250, 0.08)";
        e.currentTarget.style.color = "#60a5fa";
        e.currentTarget.style.borderColor = "rgba(96, 165, 250, 0.25)";
      }}
    >
      <span style={{ fontSize: "1.15rem", fontWeight: "bold" }}>←</span>
      Back to My Mentees
    </Link>

    {/* Center / right part: icon + text */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flex: 1,                    // takes available space
        justifyContent: "center",   // centers the icon + text
        minWidth: "0",
        textAlign: "center",
      }}
    >
          <span className="banner-icon" style={{ marginLeft: '-210px', fontSize: "1.1rem" }}>
        <FaEye />
      </span>
      <span>
        View-Only Mode — viewing <strong>{viewingChildName}</strong>'s UniReady
        results and associated insights
      </span>
    </div>
  </div>
) : null;
  const [completionStatus, setCompletionStatus] = useState({
    subject: false,
    subjectpart3: false,
  });
  const [scores, setScores] = useState([]);
  const [subjectPart3Scores, setSubjectPart3Scores] = useState([]);
  const [rawAnswers, setRawAnswers] = useState({
    subject: [],
    subjectpart3: [],
  });
  const [loading, setLoading] = useState({
    scores: true,
    subjectPart3Scores: true,
    part3Eligibility: true,
  });
  const [error, setError] = useState({
    scores: null,
    subjectPart3Scores: null,
    part3Eligibility: null,
  });
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail") || "User");
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [activeSidebarItem, setActiveSidebarItem] = useState("uniready");
  const [lastCompletionDates, setLastCompletionDates] = useState({
    subject: null,
    subjectpart3: null,
  });
  const [lastCompletedSessionIds, setLastCompletedSessionIds] = useState({
    subject: null,
    subjectpart3: null,
  });
  const [subjectSessionId, setSubjectSessionId] = useState(null);
  const [subjectpart3SessionId, setSubjectPart3SessionId] = useState(null);
  const [isEligibleForPart3, setIsEligibleForPart3] = useState(false);
  const [tooltipUniReady, setTooltipUniReady] = useState({
    visible: false,
    content: "",
    x: 0,
    y: 0,
  });
  const [tooltipPart3, setTooltipPart3] = useState({
    visible: false,
    content: "",
    x: 0,
    y: 0,
  });
  const [showManageModal, setShowManageModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [password, setPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const [actionError, setActionError] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [pendingAction, setPendingAction] = useState(null);
  const [lastEmailChangeDate, setLastEmailChangeDate] = useState(null);
  const [lastDataDownloadDate, setLastDataDownloadDate] = useState(null);
  const [lastAccountDeletionDate, setLastAccountDeletionDate] = useState(null);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [newWhitelistEmail, setNewWhitelistEmail] = useState('');
  const [emailCount, setEmailCount] = useState(0);
  const [limitReached, setLimitReached] = useState(false);
  const [whitelistError, setWhitelistError] = useState(null);
  const [earliestAdditionDate, setEarliestAdditionDate] = useState(null);
  const [userUsername, setUserUsername] = useState(localStorage.getItem("userUsername") || null);
  const displayName = userUsername || userEmail;
  const [lastUsernameChangeDate, setLastUsernameChangeDate] = useState(null);
  const [newUsername, setNewUsername] = useState("");
  const [usernameError, setUsernameError] = useState(null);
  const [loadingUsername, setLoadingUsername] = useState(false);
  const menuRef = useRef(null);
  const [showChooseSubjectModal, setShowChooseSubjectModal] = useState(false);
  const [availableSubjects, setAvailableSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [subjectSearchTerm, setSubjectSearchTerm] = useState('');
  const [lastSubjectChoiceDate, setLastSubjectChoiceDate] = useState(null);
  const [chosenTopSubject, setChosenTopSubject] = useState(null);
 // ── Subject reasoning (why do you like this subject?) — stored locally only ──
const SUBJECT_REASON_TAGS = [
  "😊 I enjoy it",
  "💪 I'm good at it",
  "🚀 Career goals",
  "🌍 Real-world relevance",
  "🌱 Still exploring",
  "✨ Inspired by others",
];

const [subjectReasons, setSubjectReasons] = useState({}); // { [subject]: { tags: [], text: '', updatedAt } }
const [reasonEditorSubject, setReasonEditorSubject] = useState(null);
const [reasonDraftTags, setReasonDraftTags] = useState([]);
const [reasonDraftText, setReasonDraftText] = useState('');
const [showFirstTimeReasonPrompt, setShowFirstTimeReasonPrompt] = useState(false);
const [reasonPromptIndex, setReasonPromptIndex] = useState(0);

const toggleReasonTag = (tag) => {
  setReasonDraftTags((prev) =>
    prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
  );
};

const openReasonEditor = (subject) => {
  isAnyModalOpenRef.current = true;   // guard against tooltip auto-close
  setIsAnyModalOpen(true);
  const existing = subjectReasons[subject];
  setReasonDraftTags(existing?.tags || []);
  setReasonDraftText(existing?.text || '');
  setReasonEditorSubject(subject);
};

// Pure localStorage — no backend call, no DB cost
const saveSubjectReason = (subject, tags, text) => {
  const entry = { tags, text: text.trim() || null, updatedAt: Date.now() };
  const updated = { ...subjectReasons, [subject]: entry };
  setSubjectReasons(updated);

  saveSubjectReasons(effectiveUserId, updated).catch((err) => {
    console.warn('Could not save subject reason locally:', err.message);
  });
};
  const facetCache = useMemo(() => new Map(), []); // Cache
  const [currentFacetUni, setCurrentFacetUni] = useState(null);
  const [facetDataUni, setFacetDataUni] = useState({ note: '', options: [] });
  const [tooltipContentUni, setTooltipContentUni] = useState(null);
  const [activeTabUni, setActiveTabUni] = useState('A-Levels');
  const [tooltipLoadingUni, setTooltipLoadingUni] = useState(false);
  const [currentFacetPart3, setCurrentFacetPart3] = useState(null);
  const [facetDataPart3, setFacetDataPart3] = useState({ note: '', options: [] });
  const [tooltipContentPart3, setTooltipContentPart3] = useState(null);
  const [activeTabPart3, setActiveTabPart3] = useState('A-Levels');
  const [tooltipLoadingPart3, setTooltipLoadingPart3] = useState(false);
  // AcadFeed preview state — shared cache with EnrichFeed
  const [acadFeedItems, setAcadFeedItems] = useState({}); // { subject: [articles] }
  const [acadFeedLoading, setAcadFeedLoading] = useState(false);
  const [acadFeedFetchedSubjects, setAcadFeedFetchedSubjects] = useState(new Map()); // subject -> last session-check timestamp  const [acadFeedOpenUni, setAcadFeedOpenUni] = useState(false);
  const [acadFeedOpenUni, setAcadFeedOpenUni] = useState(false); 
  const [acadFeedOpenPart3, setAcadFeedOpenPart3] = useState(false);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const chosenSubjectRef = useRef(null);
  const chartRefUni = useRef(null);
  const chartRefPart3 = useRef(null);
  const isAnyModalOpenRef = useRef(false);
  const [showWhatsNextModalUniReady, setShowWhatsNextModalUniReady] = useState(false);
  const [inviteCredits, setInviteCredits] = useState(null);
  const [lastAvatarChangeDate, setLastAvatarChangeDate] = useState(null);
  const [canChangeAvatar, setCanChangeAvatar] = useState(true);
 
const [showInviteModal, setShowInviteModal] = useState(false);
const [inviteEmail, setInviteEmail] = useState('');
const [inviteRelationshipType, setInviteRelationshipType] = useState('parent');
const [inviteError, setInviteError] = useState('');
const [inviteSuccess, setInviteSuccess] = useState('');
const [inviteLoading, setInviteLoading] = useState(false);
const [showConnectionsModal, setShowConnectionsModal] = useState(false);
const [connections, setConnections] = useState([]);
const [connectionsLoading, setConnectionsLoading] = useState(false);
const [connectionsError, setConnectionsError] = useState('');
const [disconnectingId, setDisconnectingId] = useState(null);
const { openModal, openModalName, prewarmDeckSpace } = useModalContext();

const [portfolioXJobs, setPortfolioXJobs] = useState([]);
const [userType, setUserType] = useState(() => {
  return localStorage.getItem("usertype") || "standard";
});
const [isAnyModalOpen, setIsAnyModalOpen] = useState(false);
const modalRef = useRef(null);

const [isScanning, setIsScanning] = useState(false);
const [scanStatus, setScanStatus] = useState("");
const [documents, setDocuments] = useState([]);
const [docsLoading, setDocsLoading] = useState(false);
const [showKnowledgeUploadModal, setShowKnowledgeUploadModal] = useState(false);
const [knowledgeDeviceUrl, setKnowledgeDeviceUrl] = useState(
  localStorage.getItem("knowledge_device_url") || "http://192.168.1.50:8000"
);
const [uploadModalTab, setUploadModalTab] = useState('materials'); // 'materials' | 'sync'
const [isSyncingIntelligence, setIsSyncingIntelligence] = useState(false);
const [syncStage, setSyncStage] = useState('');
const [syncError, setSyncError] = useState(null);
const [syncResult, setSyncResult] = useState(null);
const [syncMode, setSyncMode] = useState('incremental'); // 'incremental' | 'full'
const [lastSyncDate, setLastSyncDate] = useState(
  localStorage.getItem(`edu_intel_last_sync_${effectiveUserId}`) || null
);

const formatSyncDate = (iso) => {
  if (!iso) return 'Never';
  try {
    return new Date(iso).toLocaleString([], {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch { return 'Unknown'; }
};


const handleSyncEducationIntelligence = async () => {
  if (!effectiveUserId || !knowledgeDeviceUrl) return;
  setIsSyncingIntelligence(true);
  setSyncError(null);
  setSyncResult(null);

  try {
    setSyncStage('Gathering your data…');
    const since = syncMode === 'incremental' ? lastSyncDate : null;
    const bundle = await exportUserData(effectiveUserId, { since });

    if (bundle.sections.length === 0) {
      setSyncResult({ recordCount: 0, sectionCount: 0, nothingNew: true });
      setSyncStage('');
      setIsSyncingIntelligence(false);
      return;
    }

    setSyncStage(`Sending ${bundle.sections.length} categories to your device…`);
    const response = await fetch(`${knowledgeDeviceUrl}/api/education-intelligence`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bundle),
    });
    if (!response.ok) throw new Error(`Device responded with status ${response.status}`);

    const totalRecords = bundle.sections.reduce((sum, s) => sum + s.recordCount, 0);
    const now = new Date().toISOString();
    localStorage.setItem(`edu_intel_last_sync_${effectiveUserId}`, now);
    setLastSyncDate(now);
    setSyncResult({ recordCount: totalRecords, sectionCount: bundle.sections.length });
  } catch (err) {
    console.error('Education intelligence sync failed:', err);
    setSyncError(
      err.message?.includes('fetch')
        ? "Couldn't reach your device. Check it's on the same Wi-Fi and try again."
        : err.message || 'Sync failed. Please try again.'
    );
  } finally {
    setSyncStage('');
    setIsSyncingIntelligence(false);
  }
};

const [runtimeInfo, setRuntimeInfo] = useState(null);
const [runtimeInfoLoading, setRuntimeInfoLoading] = useState(false);
const [runtimeInfoError, setRuntimeInfoError] = useState(null);

const [updateCheck, setUpdateCheck] = useState({ status: 'idle', data: null, error: null });
// status: 'idle' | 'checking' | 'up_to_date' | 'available' | 'error'

const [updateInstall, setUpdateInstall] = useState({ status: 'idle', progress: 0, stage: '', error: null });
// status: 'idle' | 'downloading' | 'verifying' | 'installing' | 'done' | 'error'

const updatePollRef = useRef(null);

const fetchRuntimeInfo = useCallback(async () => {
  if (!knowledgeDeviceUrl) return;
  setRuntimeInfoLoading(true);
  setRuntimeInfoError(null);
  try {
    const res = await fetch(`${knowledgeDeviceUrl}/api/runtime/version`);
    if (!res.ok) throw new Error(`Device responded with status ${res.status}`);
    setRuntimeInfo(await res.json());
  } catch (err) {
    setRuntimeInfoError(
      err.message?.includes('fetch') ? "Couldn't reach your device." : err.message || 'Could not load runtime info.'
    );
    setRuntimeInfo(null);
  } finally {
    setRuntimeInfoLoading(false);
  }
}, [knowledgeDeviceUrl]);

// Auto-load current version the moment the Runtime tab is opened — same
// pattern as Materials auto-loading documents on open.
useEffect(() => {
  if (showKnowledgeUploadModal && uploadModalTab === 'runtime' && knowledgeDeviceUrl) {
    fetchRuntimeInfo();
  }
}, [showKnowledgeUploadModal, uploadModalTab, knowledgeDeviceUrl, fetchRuntimeInfo]);

const handleCheckForUpdates = async () => {
  if (!knowledgeDeviceUrl) return;
  setUpdateCheck({ status: 'checking', data: null, error: null });
  try {
    const res = await fetch(`${knowledgeDeviceUrl}/api/runtime/check-update`);
    if (!res.ok) throw new Error(`Device responded with status ${res.status}`);
    const data = await res.json();
    setUpdateCheck({ status: data.available ? 'available' : 'up_to_date', data, error: null });
  } catch (err) {
    setUpdateCheck({
      status: 'error',
      data: null,
      error: err.message?.includes('fetch')
        ? "Couldn't reach your device. Check it's on the same Wi-Fi and try again."
        : err.message || 'Could not check for updates.',
    });
  }
};

const getLevelKeyForScore = (avgScore) => {
  if (avgScore == null || isNaN(avgScore)) return null;
  if (avgScore <= 2.49) return 'low';
  if (avgScore <= 3.49) return 'mid';
  return 'high';
};

const buildFacetNoteData = (generalNote, lowNote, midNote, highNote, avgScore) => {
  const levelKey = getLevelKeyForScore(avgScore);
  const levelNoteRaw =
    levelKey === 'low' ? lowNote :
    levelKey === 'mid' ? midNote :
    levelKey === 'high' ? highNote : null;

  const general = generalNote && generalNote.trim() ? generalNote.trim() : null;
  const level = levelNoteRaw && levelNoteRaw.trim() ? levelNoteRaw.trim() : null;

  if (!general && !level) return null;
  return { general, level, levelKey: level ? levelKey : null };
};

const pollUpdateStatus = useCallback(() => {
  if (updatePollRef.current) clearInterval(updatePollRef.current);
  updatePollRef.current = setInterval(async () => {
    try {
      const res = await fetch(`${knowledgeDeviceUrl}/api/runtime/update-status`);
      if (!res.ok) throw new Error(`Device responded with status ${res.status}`);
      const data = await res.json();
      setUpdateInstall({
        status: data.status, progress: data.progress ?? 0,
        stage: data.message || '', error: data.error || null,
      });
      if (data.status === 'done' || data.status === 'error') {
        clearInterval(updatePollRef.current);
        updatePollRef.current = null;
        if (data.status === 'done') {
          setUpdateCheck({ status: 'up_to_date', data: null, error: null });
          fetchRuntimeInfo(); // refresh the displayed version number
        }
      }
    } catch {
      clearInterval(updatePollRef.current);
      updatePollRef.current = null;
      setUpdateInstall({ status: 'error', progress: 0, stage: '', error: 'Lost connection to your device during the update.' });
    }
  }, 1500);
}, [knowledgeDeviceUrl, fetchRuntimeInfo]);

const handleInstallUpdate = async () => {
  if (!knowledgeDeviceUrl) return;
  setUpdateInstall({ status: 'downloading', progress: 0, stage: 'Starting download…', error: null });
  try {
    const res = await fetch(`${knowledgeDeviceUrl}/api/runtime/update`, { method: 'POST' });
    if (!res.ok) throw new Error(`Device responded with status ${res.status}`);
    pollUpdateStatus();
  } catch (err) {
    setUpdateInstall({
      status: 'error', progress: 0, stage: '',
      error: err.message?.includes('fetch')
        ? "Couldn't reach your device. Check it's on the same Wi-Fi and try again."
        : err.message || 'Could not start the update.',
    });
  }
};

useEffect(() => () => { if (updatePollRef.current) clearInterval(updatePollRef.current); }, []);

const [backupState, setBackupState] = useState({ status: 'idle', message: '' });
const [restoreState, setRestoreState] = useState({ status: 'idle', message: '' });
const [showRestoreConfirm, setShowRestoreConfirm] = useState(false);
const [lastBackupDate, setLastBackupDate] = useState(
  localStorage.getItem(`edu_intel_last_backup_${effectiveUserId}`) || null
);

const handleBackupToDevice = async () => {
  if (!effectiveUserId || !knowledgeDeviceUrl) return;
  setBackupState({ status: 'working', message: 'Preparing backup…' });
  try {
    const { backupUserData } = await import('./exportEngine');
    const backup = await backupUserData(effectiveUserId);
    const tableCount = Object.keys(backup.tables).length;

    if (tableCount === 0) {
      setBackupState({ status: 'done', message: 'Nothing to back up yet.' });
      return;
    }

    setBackupState({ status: 'working', message: `Sending backup of ${tableCount} data types…` });
    const res = await fetch(`${knowledgeDeviceUrl}/api/education-intelligence/backup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(backup),
    });
    if (!res.ok) throw new Error(`Device responded with status ${res.status}`);

    const now = new Date().toISOString();
    localStorage.setItem(`edu_intel_last_backup_${effectiveUserId}`, now);
    setLastBackupDate(now);
    setBackupState({ status: 'done', message: `Backed up ${tableCount} data types to your device.` });
  } catch (err) {
    setBackupState({
      status: 'error',
      message: err.message?.includes('fetch')
        ? "Couldn't reach your device. Check it's on the same Wi-Fi and try again."
        : err.message || 'Backup failed.',
    });
  }
};


const handleRestoreFromDevice = async () => {
  if (!effectiveUserId || !knowledgeDeviceUrl) return;
  setShowRestoreConfirm(false);
  setRestoreState({ status: 'working', message: 'Fetching backup from device…' });
  try {
    const res = await fetch(`${knowledgeDeviceUrl}/api/education-intelligence/backup/${effectiveUserId}`);
    if (res.status === 404) {
      setRestoreState({ status: 'error', message: 'No backup found on this device yet.' });
      return;
    }
    if (!res.ok) throw new Error(`Device responded with status ${res.status}`);
    const backup = await res.json();

    setRestoreState({ status: 'working', message: 'Restoring your data…' });
    const { restoreUserData } = await import('./exportEngine');
    const { restoredCount, tableCount } = await restoreUserData(backup);

    setRestoreState({
      status: 'done',
      message: `Restored ${restoredCount} records across ${tableCount} data types. Reloading…`,
    });
    setTimeout(() => window.location.reload(), 1200); // fresh read of restored Dexie data
  } catch (err) {
    setRestoreState({
      status: 'error',
      message: err.message?.includes('fetch')
        ? "Couldn't reach your device. Check it's on the same Wi-Fi and try again."
        : err.message || 'Restore failed.',
    });
  }
};

const [activityStatuses, setActivityStatuses] = useState({});

useEffect(() => {
  if (!effectiveUserId) { setActivityStatuses({}); return; }
  let cancelled = false;
  (async () => {
    const data = await getActivityStatuses(effectiveUserId);
    if (!cancelled) setActivityStatuses(data);
  })();
  return () => { cancelled = true; };
}, [effectiveUserId]);

useEffect(() => {
  if (activeSidebarItem === "askai") {
    document.body.classList.add("aspireai-active");
  } else {
    document.body.classList.remove("aspireai-active");
  }
  return () => document.body.classList.remove("aspireai-active");
}, [activeSidebarItem]);

useEffect(() => {
  if (activeSidebarItem === "mastery") {
    document.body.classList.add("mastery-active");
  } else {
    document.body.classList.remove("mastery-active");
  }
  return () => document.body.classList.remove("mastery-active");
}, [activeSidebarItem]);


const gradeLevels = [
  "Year 7",  "Year 8",  "Year 9",
  "Year 10", "Year 11", "Year 12", "Year 13",
  "Undergraduate Year 1",
  "Undergraduate Year 2",
  "Undergraduate Year 3",
  "Undergraduate Year 4"
];



const getOptionLink = (optName) => {
  switch (optName) {
    case 'A-Levels':
      return 'https://www.gov.uk/government/collections/gce-as-and-a-level-subject-content';
    case 'IB':
      return 'https://www.ibo.org/programmes/diploma-programme/curriculum/';
    case 'AP':
      return 'https://apstudents.collegeboard.org/courses/';
    default:
      return null;
  }
};

const FACET_CACHE_TTL = 14 * 24 * 60 * 60 * 1000; // 7 days for facet tooltips

const [completedAssessments, setCompletedAssessments] = useState({
  uniready:    false,
  studystyle:  false,
  futureready: false,
});

const [showProgressModal, setShowProgressModal] = useState(false);
const [justCompleted, setJustCompleted] = useState(null); // "uniready" | "studystyle" | "futureready"

const [showAvatarModal, setShowAvatarModal] = useState(false);
const [selectedAvatar, setSelectedAvatar] = useState(null);
const [currentAvatar, setCurrentAvatar] = useState(
  localStorage.getItem(`user_avatar_${userId}`) || "fa-avatar-1"
);

const getAssessmentProgress = () => {
  return [
    { name: "UniReady", completed: completedAssessments.uniready },
    { name: "StudyStyle", completed: completedAssessments.studystyle },
    { name: "FutureReady", completed: completedAssessments.futureready },
  ];
};


const navigateWithViewMode = useCallback((path, extraState = {}, options = {}) => {
  const currentParams = new URLSearchParams(window.location.search);
  const currentChildId = viewingChildIdProp || currentParams.get("viewingChildId") || null;
  const currentChildName = childNameProp ||
    decodeURIComponent(currentParams.get("childName") || "") || "Student";
  if (currentChildId) {
    navigate(
      { pathname: path, search: options.search || `?viewingChildId=${encodeURIComponent(currentChildId)}&childName=${encodeURIComponent(currentChildName)}` },
      { state: { ...extraState, viewingChildId: currentChildId, childName: currentChildName } }
    );
  } else {
    navigate(path, { state: extraState });
  }
}, [navigate, viewingChildIdProp, childNameProp]);

// Utility function to sanitize email input
const sanitizeEmail = (email) => {
  if (!email) return "";
  // Trim whitespace and convert to lowercase
  const cleanedEmail = email.trim().toLowerCase();
  // Basic email validation regex (same as backend for consistency)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // Return cleaned email if valid, otherwise empty string
  return emailRegex.test(cleanedEmail) ? cleanedEmail : "";
};

const TabButton = ({ 
  tab, 
  chartType,           // 'uni' or 'part3'
  currentFacetUni,
  currentFacetPart3,
  topScores,
  topPart3Scores,
  chosenTopSubject,
  userEmail,
  navigate,
  navigateWithViewMode,
}) => {
  const isUni = chartType === 'uni';

  const activeTab    = isUni ? activeTabUni   : activeTabPart3;
  const setActiveTab = isUni ? setActiveTabUni : setActiveTabPart3;
  const currentFacet = isUni ? currentFacetUni : currentFacetPart3;

  const handleClick = (e) => {
    e.stopPropagation();

 if (tab === 'Supercurricular') {
     if (!currentFacet) return;
     openSuperMap(currentFacet);        // ← opens modal instead of navigating
   } else {
      // Normal tab switch — now knows exactly which tooltip it belongs to
      setActiveTab(tab);
    }
  };

  const isSuper = tab === 'Supercurricular';
  return (
    <button
      onClick={handleClick}
      className={`dash-tab-pill ${!isSuper && activeTab === tab ? 'dash-tab-pill-active' : ''}`}
      style={isSuper ? { borderColor: color.accent, color: color.accent } : undefined}
    >
      {isSuper && <FaBolt />}
      {tab}
    </button>
  );
};

// Renders the last-24h feed articles inline inside any tooltip
const renderAcadFeedPanel = (subject) => {
  const items = acadFeedItems[subject] || [];
  const isLoading = acadFeedLoading && !acadFeedFetchedSubjects.has(subject);

  return (
    <div className="invisible-scroll" style={{ maxHeight: '200px', overflowY: 'auto' }}>
      {isLoading ? (
        <p style={{ color: '#aaa', fontStyle: 'italic' }}>Loading latest articles…</p>
      ) : items.length === 0 ? (
        <p style={{ color: '#aaa', fontStyle: 'italic' }}>No recent articles found.</p>
      ) : (
        <>
          {items.map((item, idx) => (
            <div
              key={item.guid || idx}
              style={{
                marginBottom: '10px',
                padding: '8px 10px',
                background: 'rgba(54,167,248,0.08)',
                borderRadius: '8px',
                border: '1px solid rgba(54,167,248,0.25)',
              }}
            >
              <a
              className="acadfeed-panel" 
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                style={{
                  color: '#36a7f8',
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '0.88rem',
                  lineHeight: 1.4,
                  display: 'block',
                  marginBottom: '4px',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
                onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
              >
                {item.title || 'Untitled'}
              </a>
              <div style={{ fontSize: '0.78rem', color: '#888' }}>
                {item.source || ''}{item.pub_date ? ` · ${new Date(item.pub_date).toLocaleDateString('en-GB')}` : ''}
              </div>
            </div>
          ))}
          {/* Click-through to full AcadFeed page */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateWithViewMode('/enrichfeed', {
                preselectedSubject: subject,
                fromDashboard: true,
                sortedScores: topScores || [],
                sortedPart3Scores: topPart3Scores || [],
                chosenTopSubject,
              });
            }}
            style={{
              marginTop: '8px',
              width: '100%',
              padding: '7px',
              background: 'rgba(54,167,248,0.15)',
              border: '1px solid #36a7f8',
              borderRadius: '7px',
              color: '#36a7f8',
              fontWeight: 600,
              fontSize: '0.85rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
            }}
          >
            <FaRss /> View full AcadFeed →
          </button>
        </>
      )}
    </div>
  );
};



// Add this function after other utility functions
const fetchFacetDataUni = useCallback(async (facetName) => {
  if (!facetName) return;
  setCurrentFacetUni(facetName);
  const cacheKey = `facet_${facetName}`;
  const now = Date.now();
  const cachedData = localStorage.getItem(cacheKey);
  if (cachedData) {
    try {
      const parsed = JSON.parse(cachedData);
      if (now - parsed.timestamp < FACET_CACHE_TTL) {
        setFacetDataUni(parsed.data);
        setTooltipContentUni(parsed.data);
        return;
      }
    } catch { localStorage.removeItem(cacheKey); }
  }
  try {
    setTooltipLoadingUni(true);
    const response = await fetch(`/api/questions/facets/${encodeURIComponent(facetName)}`, { headers: { Accept: "application/json" } });
    const data = await response.json();
    const fullData = { note: data?.facet_note || "", options: data?.options || [] };
    setFacetDataUni(fullData);
    setTooltipContentUni(fullData);
    localStorage.setItem(cacheKey, JSON.stringify({ data: fullData, timestamp: now }));
  } catch (error) {
    setFacetDataUni({ note: "", options: [] });
    setTooltipContentUni({ note: "", options: [] });
  } finally {
    setTooltipLoadingUni(false);
  }
}, [FACET_CACHE_TTL]);


const getAISearchLink = (subject) => {
  if (!subject) return "#";
  const query = encodeURIComponent(`${subject} degree future in AI era OR impact of artificial intelligence on ${subject} careers`);
  return `https://www.google.com/search?q=${query}`;
};

const fetchFacetDataPart3 = async (facetName) => {
  if (!facetName) return;
  setCurrentFacetPart3(facetName);
  const cacheKey = `facet_${facetName}`;
  const now = Date.now();
  const cachedData = localStorage.getItem(cacheKey);

  if (cachedData) {
    try {
      const parsed = JSON.parse(cachedData);
      const cacheAge = now - parsed.timestamp;
      if (cacheAge < FACET_CACHE_TTL) {
        setFacetDataPart3(parsed.data);
        setTooltipContentPart3(parsed.data);
        return;
      }
    } catch {
      localStorage.removeItem(cacheKey);
    }
  }

  try {
    setTooltipLoadingPart3(true);
    const response = await fetch(`/api/questions/facets/${encodeURIComponent(facetName)}`, {
      headers: { Accept: 'application/json' },
    });
    const data = await response.json();
    const options = data?.options || [];
    const note = data?.facet_note || '';
    const fullData = { note, options };
    setFacetDataPart3(fullData);
    setTooltipContentPart3(fullData);
    localStorage.setItem(cacheKey, JSON.stringify({ data: fullData, timestamp: now }));
  } catch (error) {
    console.error('Error fetching facet data:', error);
    setFacetDataPart3({ note: '', options: [] });
    setTooltipContentPart3({ note: '', options: [] });
  } finally {
    setTooltipLoadingPart3(false);
  }
};

const openScoreTooltip = useCallback((e, label, kind) => {
  const isUni = kind === 'uni';
  const currentFacet   = isUni ? currentFacetUni   : currentFacetPart3;
  const setTooltip     = isUni ? setTooltipUniReady : setTooltipPart3;
  const setActiveTab   = isUni ? setActiveTabUni    : setActiveTabPart3;
  const setAcadFeedOpen = isUni ? setAcadFeedOpenUni : setAcadFeedOpenPart3;
  const fetchFacetData = isUni ? fetchFacetDataUni   : fetchFacetDataPart3;

  // Same-subject click again → close, matching old chart toggle behaviour
  if (currentFacet === label) {
    setTooltip({ visible: false, content: null, x: 0, y: 0 });
    if (isUni) {
      setCurrentFacetUni(null);
      setFacetDataUni({ note: '', options: [] });
      setTooltipContentUni(null);
    } else {
      setCurrentFacetPart3(null);
      setFacetDataPart3({ note: '', options: [] });
      setTooltipContentPart3(null);
    }
    setActiveTab('A-Levels');
    setAcadFeedOpen(false);
    return;
  }

  setActiveTab('A-Levels');
  setAcadFeedOpen(false);
  fetchFacetData(label);

  // Anchor off the clicked row itself, not a chart canvas
  const rect = e.currentTarget.getBoundingClientRect();
  const tooltipWidth = 550;
  const tooltipHeight = 200;

  let tooltipX = rect.left - 100;
  let tooltipY = 640;

  if (tooltipX + tooltipWidth > window.innerWidth) {
    tooltipX = window.innerWidth - tooltipWidth - 20;
  }
  if (tooltipX < 10) tooltipX = 10;
  if (tooltipY + tooltipHeight > window.innerHeight) {
    tooltipY = rect.top - tooltipHeight - 10; // flip above the row if no room below
  }
  if (tooltipY < 10) tooltipY = 10;

  setTooltip({ visible: true, content: null, x: tooltipX, y: tooltipY });
}, [currentFacetUni, currentFacetPart3]);

const editorRef = useRef(null);

// Helper to invalidate account dates cache (used after important changes)
const invalidateAccountCache = useCallback(() => {
  if (effectiveUserId) {
    localStorage.removeItem(`account_dates_${effectiveUserId}`);
    console.log(`🧹 Account dates cache invalidated for user ${effectiveUserId}`);
  }
}, [effectiveUserId]);

useEffect(() => {
  // Clear the justLoggedIn flag after dashboard loads
  if (localStorage.getItem('justLoggedIn') === 'true') {
    localStorage.removeItem('justLoggedIn');
  }
}, []);

useEffect(() => {
  (async () => {
    await ensureFreshCacheVersion();
  })();
}, []);

useEffect(() => {
  if (!effectiveUserId) return;
  let cancelled = false;
  (async () => {
    try {
      const data = await getSubjectReasons(effectiveUserId);
      if (!cancelled) setSubjectReasons(data);
    } catch (err) {
      console.warn('Could not load subject reasons:', err.message);
    }
  })();
  return () => { cancelled = true; };
}, [effectiveUserId]);

 // ←←← ADD THE IOS FIX HERE (once per page with Chart.js) ←←←
useEffect(() => {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (!isIOS) return;

  let attempts = 0;
  const maxAttempts = 15;

  const getCharts = () => [
    chartRefUni.current?.chart?.canvas,
    chartRefPart3.current?.chart?.canvas,
  ].filter(Boolean);

  const forceRepaint = () => {
    const canvases = getCharts();
    if (canvases.length === 0 && attempts < maxAttempts) {
      attempts++;
      setTimeout(forceRepaint, 150);
      return;
    }

    canvases.forEach((canvas) => {
      if (!canvas) return;

      const parent = canvas.parentNode;
      if (!parent) return;

      // NUCLEAR OPTION #1: Clone + replace node (forces full re-rasterization)
      const clone = canvas.cloneNode(true);
      parent.replaceChild(clone, canvas);

      // NUCLEAR OPTION #2: Multiple aggressive reflow triggers
      canvas.style.cssText += ';transform:translateZ(0.5px);';
      void canvas.offsetHeight;
      canvas.style.cssText += ';transform:none;';
      void canvas.offsetHeight;

      // NUCLEAR OPTION #3: WebKit hardware acceleration hacks
      canvas.style.webkitTransform = 'translateZ(0)';
      canvas.style.transform = 'translateZ(0)';
      void canvas.offsetHeight;

      // Final resize + update
      const chartInstance = chartRefUni.current?.chart || chartRefPart3.current?.chart;
      if (chartInstance) {
        chartInstance.resize();
        chartInstance.update('none');
      }
    });
  };

  // Run aggressively on multiple triggers
  const timers = [
    setTimeout(forceRepaint, 100),
    setTimeout(forceRepaint, 300),
    setTimeout(forceRepaint, 700),
    setTimeout(forceRepaint, 1200),
    setTimeout(forceRepaint, 2000),
  ];

  const handler = () => {
    attempts = 0;
    forceRepaint();
  };

  window.addEventListener('resize', handler);
  window.addEventListener('orientationchange', handler);

  // Also trigger when React finishes rendering charts
  const observer = new MutationObserver((mutations) => {
    if (mutations.some(m => m.addedNodes.length > 0)) {
      setTimeout(forceRepaint, 100);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  return () => {
    timers.forEach(clearTimeout);
    window.removeEventListener('resize', handler);
    window.removeEventListener('orientationchange', handler);
    observer.disconnect();
  };
}, []); // Run once
  
useEffect(() => {
  if (currentFacetUni && facetDataUni.options.length > 0) {
    setTooltipContentUni({
      ...facetDataUni,
      options: facetDataUni.options // Filtered in render
    });
  }
}, [activeTabUni, facetDataUni, currentFacetUni]);

useEffect(() => {
  if (!userId) return;
  const studystyle  = localStorage.getItem(`assessment_completed_studystyle_${userId}`)  === "true";
  const futureready = localStorage.getItem(`assessment_completed_futureready_${userId}`) === "true";
  setCompletedAssessments(prev => ({
    ...prev,
    studystyle:  prev.studystyle  || studystyle,
    futureready: prev.futureready || futureready,
  }));
}, [userId]);

useEffect(() => {
  if (currentFacetPart3 && facetDataPart3.options.length > 0) {
    setTooltipContentPart3({
      ...facetDataPart3,
      options: facetDataPart3.options // Filtered in render
    });
  }
}, [activeTabPart3, facetDataPart3, currentFacetPart3]);

/*useEffect(() => {
  const loadAvatarAndChangeDate = async () => {
    if (!userId) return;

    try {
      const response = await axios.get(`/api/users/user/${userId}`, {
        headers: getAuthHeaders(),
      });

      const { avatar, lastAvatarChangeDate } = response.data;

      if (avatar) {
        setCurrentAvatar(avatar);
        localStorage.setItem(`user_avatar_${userId}`, avatar);
      }

      // ── NEW: handle last avatar change timestamp ──
      if (lastAvatarChangeDate) {
        setLastAvatarChangeDate(lastAvatarChangeDate);
      }

    } catch (err) {
      console.warn("Could not load user profile:", err);
      // fallback to local only
    }
  };

  loadAvatarAndChangeDate();
}, [userId]);*/

const [pendingSubjectDestination, setPendingSubjectDestination] = useState(null);

useEffect(() => {
  if (location.state?.openChooseSubjectModal) {
    setShowChooseSubjectModal(true);
    if (location.state.intendedDestination) {
      setPendingSubjectDestination(location.state.intendedDestination);
    }
    navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: {} });
  }
}, [location.state, navigate]);

useEffect(() => {
  if (!location.state) return;

  let justCompletedType = null;

  // UniReady (this dashboard) — accept both possible flag names
  if (location.state.justSubmittedSubject || location.state.justSubmittedUniReady) {
    justCompletedType = "uniready";
  }
  // StudyStyle (if it navigates back here — unlikely but safe)
  else if (location.state.justSubmittedStudyStyle) {
    justCompletedType = "studystyle";
  }

  if (justCompletedType) {
    console.log(`Completion detected: ${justCompletedType} — showing progress modal`);

    setCompletedAssessments(prev => ({
      ...prev,
      [justCompletedType]: true
    }));

    setJustCompleted(justCompletedType);
    setShowProgressModal(true);

    // Clean navigation state (prevents modal re-appearing on refresh/back)
navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: {} });
  }
}, [location.state, navigate]);


useEffect(() => {
  if (showProgressModal) {
    confetti({
      particleCount: 80,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#00e1ff', '#028be8', '#36a7f8', '#ffd700'],
    });
  }
}, [showProgressModal]);

useEffect(() => {
  if (showChooseSubjectModal) {
    setSubjectSearchTerm('');
    setSelectedSubject('');
    setShowConfirmation(false);
  }
}, [showChooseSubjectModal]);

useEffect(() => {
  if (!userId || isParentView) return;

  // Check if user has already seen and dismissed the avatar modal
  const hasSeenAvatarModal = 
    localStorage.getItem(`has_seen_avatar_modal_${userId}`) === "true";

  // Only auto-show if:
  // - All three assessments are done
  // - User has NOT already seen/dismissed it
  // - Modal is currently closed
  if (
    completedAssessments.uniready &&
    completedAssessments.studystyle &&
    completedAssessments.futureready &&
    !hasSeenAvatarModal &&
    !showAvatarModal
  ) {
    const timer = setTimeout(() => {
      setShowAvatarModal(true);
      // Mark as seen the moment we decide to show it
      localStorage.setItem(`has_seen_avatar_modal_${userId}`, "true");
    }, 1800);

    return () => clearTimeout(timer);
  }
}, [
  userId,
  isParentView,
  completedAssessments.uniready,
  completedAssessments.studystyle,
  completedAssessments.futureready,
  showAvatarModal,
]);




const isSubjectChoiceAllowed = () => {
  if (isAdmin) return true;
  const threeMonthsInMs = 3 * 30 * 24 * 60 * 60 * 1000;
  const now = Date.now();
  if (lastSubjectChoiceDate) {
    const timeSinceLast = now - new Date(lastSubjectChoiceDate).getTime();
    return timeSinceLast >= threeMonthsInMs;
  }
  return true;
};

// Track page views for activeSidebarItem
  useEffect(() => {
    if (window.gtag) {
      let pageTitle;
      switch (activeSidebarItem) {
        case "uniready":
          pageTitle = "UniReady Dashboard";
          break;
        case "enrich":
          pageTitle = "Enrich+ Dashboard";
          break;
        default:
          pageTitle = "Dashboard";
      }
      window.gtag('config', 'G-B8RJQ1KWE4', {
        page_path: `/dashboard/${activeSidebarItem}`,
        page_title: pageTitle,
        user_id: userId, // Optional: Include user ID (ensure GDPR compliance)
      });
    }
  }, [activeSidebarItem, userId]);

  // Remove console.logs in production to reduce bundle size
  if (process.env.NODE_ENV !== "development") {
    console.log = () => {};
  }

  useEffect(() => {
}, [userId]);



 // Initialize session IDs for subject only
useEffect(() => {
  const CACHE_TTL = 30 * 24 * 60 * 60 * 1000; // 30 days

  const initializeSessionIds = async () => {
const initializeAssessment = async (
  type,
  sessionIdKey,
  setSessionId,
  localStorageKey
) => {
  let storedSessionId = localStorage.getItem(localStorageKey);
  let targetSessionId = null;

  // Handle fresh submission
  if (location.state?.[sessionIdKey] && location.state?.[`justSubmitted${type}`]) {
    targetSessionId = location.state[sessionIdKey];
    setSessionId(targetSessionId);
    localStorage.setItem(localStorageKey, targetSessionId);
  }

  if (!userId) return;

  const CACHE_KEY = `progress_${effectiveUserId}_${type}`;

  // FORCE FETCH if:
  // - No local session OR
  // - No cached progress OR
  // - Just submitted OR
  // - Cache exists but user cleared data (we detect by checking both)
  const mustFetchFresh =
    !storedSessionId ||
    !localStorage.getItem(CACHE_KEY) ||
    location.state?.[`justSubmitted${type}`];

  let progress = null;

  try {
    if (!mustFetchFresh && storedSessionId) {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Date.now() - parsed.timestamp < CACHE_TTL) {
          progress = parsed;
        }
      }
    }

    // Fetch fresh if needed (especially important after localStorage clear)
    if (!progress || mustFetchFresh) {
      progress = await fetchProgress(effectiveUserId, {
        assessmentType: type,
        fetchLatest: true,
      });

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ ...progress, timestamp: Date.now() })
      );
    }

    if (progress?.sessionId && !targetSessionId) {
      targetSessionId = progress.sessionId;
      setSessionId(progress.sessionId);
      localStorage.setItem(localStorageKey, progress.sessionId);
    }

    if (progress?.lastCompletionDate) {
      const timeSince = Date.now() - new Date(progress.lastCompletionDate).getTime();
const threeMonthsMs = 3 * 30 * 24 * 60 * 60 * 1000;

      setCompletionStatus((prev) => ({
        ...prev,
[type.toLowerCase()]: timeSince < threeMonthsMs && !isAdmin,
      }));

      setLastCompletionDates((prev) => ({
        ...prev,
        [type.toLowerCase()]: progress.lastCompletionDate,
      }));
    } else {
      setCompletionStatus((prev) => ({
        ...prev,
        [type.toLowerCase()]: false,
      }));
      setLastCompletionDates((prev) => ({
        ...prev,
        [type.toLowerCase()]: null,
      }));
      localStorage.removeItem(localStorageKey);
      setSessionId(null);
    }
  } catch (err) {
    console.error(`Error initializing ${type}:`, err.message);
    // Fail-safe: allow retake if fetch fails
    setCompletionStatus((prev) => ({ ...prev, [type.toLowerCase()]: false }));
    setLastCompletionDates((prev) => ({ ...prev, [type.toLowerCase()]: null }));
  }
};

    await Promise.all([
      initializeAssessment("Subject", "subjectSessionId", setSubjectSessionId, "subjectSessionId"),
      initializeAssessment("SubjectPart3", "subjectpart3SessionId", setSubjectPart3SessionId, "subjectpart3SessionId"),
    ]);
  };

  if (userId) {
    initializeSessionIds();
  }
}, [userId, location.state, navigate, isAdmin]);

useEffect(() => {
  const fetchUserUsername = async () => {
    if (!userId) {
      setUserUsername(null);
      setLoadingUsername(false);
      localStorage.setItem("userUsername", null);
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      setUserUsername(null);
      setLoadingUsername(false);
      localStorage.setItem("userUsername", null);
      return;
    }

    // Check localStorage first and validate cache
    const CACHE_KEY = `user_username_${userId}`;
    const cachedData = localStorage.getItem(CACHE_KEY);
    const CACHE_TTL = 2 * 24 * 60 * 60 * 1000; // 48 hours

    if (cachedData && !lastUsernameChangeDate) {
      try {
        const { username, timestamp } = JSON.parse(cachedData);
        if (Date.now() - timestamp < CACHE_TTL) {
          setUserUsername(username || null);
          setLoadingUsername(false);
          localStorage.setItem("userUsername", username || null);
          return;
        }
      } catch {
        localStorage.removeItem(CACHE_KEY);
      }
    }

    setLoadingUsername(true);
    try {
      const response = await axios.get(`/api/users/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const { username } = response.data;
      const newUsername = username || null;
      setUserUsername(newUsername);
      localStorage.setItem("userUsername", newUsername);
      // Cache username
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ username: newUsername, timestamp: Date.now() })
      );
    } catch (err) {
      console.error("Error fetching user username:", err);
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("userUsername");
        localStorage.removeItem(CACHE_KEY);
        navigate("/login");
      } else {
        setUserUsername(null);
        localStorage.setItem("userUsername", null);
      }
    } finally {
      setLoadingUsername(false);
    }
  };
  fetchUserUsername();
}, [userId, navigate, lastUsernameChangeDate]);



const fetchConnections = async () => {
  const CACHE_KEY = `connections_${userId}`;
  const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

  // Check cache first
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.timestamp < CACHE_TTL) {
        setConnections(parsed.data);
        return;
      }
    }
  } catch {
    localStorage.removeItem(CACHE_KEY);
  }

  // Cache miss or expired — fetch from server
  setConnectionsLoading(true);
  setConnectionsError('');
  try {
    const response = await axios.get('/api/users/relationships/my-connections', {
      headers: getAuthHeaders(),
    });
    const data = response.data.connections || [];
    setConnections(data);

    // Save to cache
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      data,
      timestamp: Date.now(),
    }));
  } catch (err) {
    setConnectionsError(err.response?.data?.error || 'Failed to load connections.');
  } finally {
    setConnectionsLoading(false);
  }
};

const handleDisconnect = async (relationshipId, displayName) => {
  const ok = await confirm(
    `Disconnect from ${displayName}? They will lose access to your profile.`,
    { title: "Disconnect?", confirmLabel: "Disconnect", danger: true }
  );
  if (!ok) return;
  setDisconnectingId(relationshipId);
  try {
    await axios.post(
      `/api/users/relationships/${relationshipId}/reject-or-revoke`,
      {},
      { headers: getAuthHeaders() }
    );
    const updated = connections.filter(c => c.id !== relationshipId);
    setConnections(updated);
    localStorage.removeItem(`connections_${userId}`);
  } catch (err) {
    showToast(err.response?.data?.error || 'Failed to disconnect. Please try again.', "error");
  } finally {
    setDisconnectingId(null);
  }
};

const handleSendInvite = async () => {
    if (!inviteEmail || !sanitizeEmail(inviteEmail)) {
      setInviteError("Please enter a valid email address.");
      localStorage.removeItem(`connections_${userId}`);
      return;
    }

    // Frontend 1-hour resend gate
    const inviteKey = `invite_sent_${userId}_${inviteEmail.trim().toLowerCase()}`;
    const lastSent = localStorage.getItem(inviteKey);
    if (lastSent) {
      const elapsed = Date.now() - parseInt(lastSent, 10);
      const oneHourMs = 60 * 60 * 1000;
      if (elapsed < oneHourMs) {
        const minutesLeft = Math.ceil((oneHourMs - elapsed) / 60000);
        setInviteError(`Invite already sent. You can resend in ${minutesLeft} minute${minutesLeft !== 1 ? 's' : ''}.`);
        return;
      }
    }

    setInviteError('');
    setInviteSuccess('');
    setInviteLoading(true);

    console.log("→ Sending invite payload:", {
      email: inviteEmail.trim().toLowerCase(),
      relationshipType: inviteRelationshipType,
    });

    try {
      const response = await axios.post(
        '/api/users/relationships/invite',
        {
          email: inviteEmail.trim().toLowerCase(),
          relationshipType: inviteRelationshipType,
        },
        { headers: getAuthHeaders() }
      );

        const inviteKey = `invite_sent_${userId}_${inviteEmail.trim().toLowerCase()}`;
      localStorage.setItem(inviteKey, Date.now().toString());

      setInviteSuccess(
        response.data.resent
          ? `Invitation resent to ${inviteEmail}!`
          : `Invitation sent to ${inviteEmail}!`
      );
      setInviteEmail('');
      setInviteRelationshipType('parent');
    } catch (err) {
      console.error('Invite error:', err);
      if (err.response) {
        console.log("→ Server replied:", err.response.data);
        setInviteError(
          err.response.data.error ||
          "Failed to send invitation. Please try again."
        );
      } else {
        setInviteError("Network error — please check your connection.");
      }
    } finally {
      setInviteLoading(false);
    }
  };

const handleAddWhitelistEmail = async () => {
  const sanitizedEmail = sanitizeEmail(newWhitelistEmail);
  if (!sanitizedEmail) {
    setWhitelistError("Please enter a valid email address.");
    return;
  }

  try {
    setWhitelistError(null);
    const isPasswordValid = await verifyPassword();
    if (!isPasswordValid) {
      setPasswordError("Incorrect password.");
      return;
    }

    const response = await axios.post(
      "/api/whitelist/user-email",
      { email: sanitizedEmail },
      { headers: getAuthHeaders() }
    );

    // REFRESH CREDITS FROM SERVER AFTER SUCCESS
    const status = await axios.get('/api/whitelist/user-email-count', {
      headers: getAuthHeaders()
    });

    setEmailCount(status.data.emailCount);
    setInviteCredits(status.data.maxAllowed);   // ← now reflects DB value (e.g., 1)
    setLimitReached(status.data.limitReached);

    setNewWhitelistEmail("");
    setModalAction(null);
    setPassword("");

    showToast(response.data.message || "Invite sent!", "success");
  } catch (err) {
    setWhitelistError(
      err.response?.data?.error || "Failed to send invite."
    );
  }
};

const openInviteModal = async () => {
  // Open Manage Account modal and switch to whitelist tab
  setShowManageModal(true);
  setModalAction('whitelist');

  setNewWhitelistEmail('');
  setWhitelistError(null);

  // 10-minute cache to avoid unnecessary calls
  const cacheKey = `invite_credits_${userId}`;
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      const { credits, limit, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp < 2 * 60 * 60 * 1000) { // 2 hr
        setInviteCredits(credits);
        setLimitReached(limit);
        return;
      }
    } catch (e) {
      localStorage.removeItem(cacheKey);
    }
  }

  // Fetch fresh data only when needed
  try {
    const response = await axios.get('/api/whitelist/user-email-count', {
      headers: getAuthHeaders()
    });

    setInviteCredits(response.data.remainingCredits || response.data.maxAllowed);
    setLimitReached(response.data.limitReached);

    // Cache result
    localStorage.setItem(cacheKey, JSON.stringify({
      credits: response.data.remainingCredits || response.data.maxAllowed,
      limit: response.data.limitReached,
      timestamp: Date.now()
    }));
  } catch (err) {
    console.error('Failed to load invite credits:', err);
    setInviteCredits(0);
    setLimitReached(true);
  }
};



// Fetches a subject's tooltip description (facet_note) independent of
// whether the student was ever scored on it. Reads from the Dexie bulk
// facet-list cache first (the same /api/questions/facets response already
// used to populate "Choose Your Top Subject"), so this almost never needs
// a network call — and never hits the costlier per-facet endpoint at all.
const SUBJECT_FACETS_CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days — matches the subject-list cache

const fetchChosenSubjectFacetNote = async (subject) => {
  if (!subject) return null;

  try {
    const cached = await getSubjectFacetsCache();
    if (cached?.data && Date.now() - cached.timestamp < SUBJECT_FACETS_CACHE_TTL) {
      const match = cached.data.find((f) => f.facet === subject);
      if (match) return match.facet_note || null;
    }
  } catch (e) {
    console.warn('Could not read subject facets cache from Dexie', e);
  }

  // Cache miss or stale — fetch the full facet list once (bulk endpoint,
  // same one already used elsewhere) and cache it in Dexie for next time.
  try {
    const response = await axios.get('/api/questions/facets');
    const allFacets = response.data || [];
    await saveSubjectFacetsCache(allFacets);
    const match = allFacets.find((f) => f.facet === subject);
    return match?.facet_note || null;
  } catch (e) {
    console.warn('Could not fetch subject facets for PDF facet note', e);
    return null;
  }
};

const handleDownloadFullReportFromDashboard = async () => {  await new Promise(resolve => setTimeout(resolve, 400));

  const name = isParentView
    ? viewingChildName
    : (localStorage.getItem("userUsername") ||
       localStorage.getItem("userEmail")?.split("@")[0] ||
       "Student");

  // ── Insights ──
  let insightsFromStorage = '';
  if (isParentView && viewingChildId) {
    const childRow = await getInsightsCache(effectiveUserId, `child_${viewingChildId}`);
    insightsFromStorage = childRow?.insights || '';
    if (!insightsFromStorage) {
      const fallback = await getInsightsCache(effectiveUserId, 'career');
      insightsFromStorage = fallback?.insights || '';
    }
  } else {
    const row = await getInsightsCache(effectiveUserId, 'career');
    insightsFromStorage = row?.insights || '';
  }

  // ── Strategy ──
  let strategyFromStorage = '';
  if (isParentView && viewingChildId) {
     const parentRow = await getStrategyCache(effectiveUserId, 'parent_view');
    strategyFromStorage = parentRow?.strategy || '';
    if (!strategyFromStorage) {
      const fallback = await getStrategyCache(effectiveUserId, 'self');
      strategyFromStorage = fallback?.strategy || '';
    }
  } else {
   const row = await getStrategyCache(effectiveUserId, 'self');
    strategyFromStorage = row?.strategy || '';
  }

  // ── Subject scores from state (already available in Dashboard) ──
  let resolvedSortedScores = sortedScores.length > 0
    ? sortedScores
    : JSON.parse(localStorage.getItem(`sortedScores_${effectiveUserId}`) || '[]');

  let resolvedSortedPart3Scores = sortedPart3Scores.length > 0
    ? sortedPart3Scores
    : JSON.parse(localStorage.getItem(`sortedPart3Scores_${effectiveUserId}`) || '[]');

  // ── Fallback: rebuild from raw answers if still empty ──
 if (resolvedSortedScores.length === 0) {
    try {
      const cachedRow = await getRawAnswers(effectiveUserId, 'Subject');
      if (cachedRow) {
        const partIIAnswers = (cachedRow.data || []).filter(a => a.category === 'Part II');
        const facetMap = partIIAnswers.reduce((acc, a) => {
          const facet = a.facet || 'Unknown';
          if (!acc[facet]) acc[facet] = { scores: [], facetNote: a.facet_note || null };
          acc[facet].scores.push(a.score);
          return acc;
        }, {});
        resolvedSortedScores = Object.entries(facetMap)
          .filter(([_, d]) => d.scores.length > 0)
          .map(([facet, d]) => ({
            _id: facet,
            averageScore: d.scores.reduce((s, v) => s + v, 0) / d.scores.length,
            facetNote: d.facetNote,
          }))
          .sort((a, b) => b.averageScore - a.averageScore);
      }
    } catch (err) { console.warn("Could not recover sortedScores", err); }
  }

  if (resolvedSortedPart3Scores.length === 0) {
    try {
      const cachedRow = await getRawAnswers(effectiveUserId, 'SubjectPart3');
      if (cachedRow) {
        const partIIIAnswers = (cachedRow.data || []).filter(a => a.category === 'Part III');
        const facetMap = partIIIAnswers.reduce((acc, a) => {
          const facet = a.facet || 'Unknown';
          if (!acc[facet]) acc[facet] = { scores: [] };
          acc[facet].scores.push(a.score);
          return acc;
        }, {});
        resolvedSortedPart3Scores = Object.entries(facetMap)
          .filter(([_, d]) => d.scores.length > 0)
          .map(([facet, d]) => ({
            _id: facet,
            averageScore: d.scores.reduce((s, v) => s + v, 0) / d.scores.length,
          }))
          .sort((a, b) => b.averageScore - a.averageScore);
      }
    } catch (err) { console.warn("Could not recover sortedPart3Scores", err); }
  }

  // ── Career visualizations ──
let resolvedCareerVis = null;
const cachedCareerVis = await getVisualizationsCache(effectiveUserId, 'Career');
  if (cachedCareerVis) resolvedCareerVis = cachedCareerVis.data;

// ── Fallback: rebuild from raw Career answers ──
if (!resolvedCareerVis) {
  try {
    const cachedRow = await getRawAnswers(effectiveUserId, 'Career');
    if (cachedRow) {
      const answers = Array.isArray(cachedRow.data) ? cachedRow.data : [];
      if (answers.length > 0) {

     const createRadarData = (filteredAnswers, label, bgColor, borderColor) => {
  const facetMap = filteredAnswers.reduce((acc, a) => {
    const f = a.facet || 'Unknown';
    if (!acc[f]) {
      acc[f] = {
        scores: [],
        facet_note: a.facet_note || null,
        low_note: a.low_note || null,
        mid_note: a.mid_note || null,
        high_note: a.high_note || null,
      };
    }
    acc[f].scores.push(a.score);
    return acc;
  }, {});
  const labels = Object.keys(facetMap);
  const avgByFacet = Object.fromEntries(
    labels.map(f => [f, facetMap[f].scores.reduce((s, v) => s + v, 0) / facetMap[f].scores.length])
  );
  const facetNoteMap = Object.fromEntries(
    labels.map(f => {
      const d = facetMap[f];
      return [f, buildFacetNoteData(d.facet_note, d.low_note, d.mid_note, d.high_note, avgByFacet[f])];
    })
  );
  return {
    labels,
    datasets: [{
      label,
      data: labels.map(f => avgByFacet[f]),
      totalScores: labels.map(f => facetMap[f].scores.reduce((s, v) => s + v, 0)),
      facetNote: labels.map(f => facetNoteMap[f] || null),
      backgroundColor: bgColor,
      borderColor: borderColor,
      borderWidth: 1,
    }],
    facetNote: facetNoteMap,
  };
};


        const careerInterest = answers.filter(a =>
          a.sub_category === 'Career Interests & Personality'
        );
        const valuesWorkPreferences = answers.filter(a =>
          a.sub_category === 'Working Preferences & Values'
        );
        const motivationAnswers = answers.filter(a =>
          a.sub_category === 'Intrinsic vs. Extrinsic Motivation'
        );
        const bigFive = answers.filter(a =>
          a.sub_category === 'Big Five Personality Traits'
        );
        const emotionalIntelligence = answers.filter(a =>
          a.sub_category === 'Emotional Intelligence'
        );

        const intrinsicScores = motivationAnswers.filter(a => a.facet === 'Intrinsic Motivation');
        const extrinsicScores = motivationAnswers.filter(a => a.facet === 'Extrinsic Motivation');
const intrinsicAvg = intrinsicScores.reduce((s, a) => s + a.score, 0) / (intrinsicScores.length || 1);
const extrinsicAvg = extrinsicScores.reduce((s, a) => s + a.score, 0) / (extrinsicScores.length || 1);
const intrinsicNote = buildFacetNoteData(
  intrinsicScores[0]?.facet_note, intrinsicScores[0]?.low_note, intrinsicScores[0]?.mid_note, intrinsicScores[0]?.high_note, intrinsicAvg
);
const extrinsicNote = buildFacetNoteData(
  extrinsicScores[0]?.facet_note, extrinsicScores[0]?.low_note, extrinsicScores[0]?.mid_note, extrinsicScores[0]?.high_note, extrinsicAvg
);

        resolvedCareerVis = {
          careerInterest: createRadarData(
            careerInterest,
            'Career Interest',
            'rgba(75, 192, 192, 0.2)',
            'rgba(75, 192, 192, 1)'
          ),
          valuesWorkPreferences: createRadarData(
            valuesWorkPreferences,
            'Working Preferences & Values',
            'rgba(255, 206, 86, 0.2)',
            'rgba(255, 206, 86, 1)'
          ),
         motivation: {
  labels: ['Intrinsic Motivation', 'Extrinsic Motivation'],
  datasets: [{
    label: 'Motivation Scores',
    data: [intrinsicAvg, extrinsicAvg],
    totalScores: [
      intrinsicScores.reduce((s, a) => s + a.score, 0),
      extrinsicScores.reduce((s, a) => s + a.score, 0),
    ],
    facetNote: [intrinsicNote, extrinsicNote],
    backgroundColor: ['rgba(54, 162, 235, 0.4)', 'rgba(255, 99, 132, 0.4)'],
    borderColor: ['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)'],
    borderWidth: 1,
  }],
  facetNote: {
    'Intrinsic Motivation': intrinsicNote,
    'Extrinsic Motivation': extrinsicNote,
  },
},
          bigFive: createRadarData(
            bigFive,
            'Big Five Personality Traits',
            'rgba(54, 162, 235, 0.2)',
            'rgba(54, 162, 235, 1)'
          ),
          emotionalIntelligence: createRadarData(
            emotionalIntelligence,
            'Emotional Intelligence',
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 99, 132, 1)'
          ),
        };

        console.log("[PDF Dashboard] → Rebuilt careerVisualizations from raw answers");
         if (resolvedCareerVis) {
          await saveVisualizationsCache(effectiveUserId, 'Career', resolvedCareerVis).catch(() => {});
        }
      }
    }
  } catch (err) {
    console.warn("[PDF Dashboard] Could not rebuild career visualizations", err);
  }
}

  // ── StudyStyle visualizations ──
  let recoveredLearningVis = null;
  const cachedLearningVis = await getVisualizationsCache(effectiveUserId, 'Learning');
  if (cachedLearningVis) recoveredLearningVis = cachedLearningVis.data;
if (!recoveredLearningVis) {
  try {
    const cachedRow = await getRawAnswers(effectiveUserId, 'Learning');
    if (cachedRow) {
      const parsed = { data: cachedRow.data };
      if (Array.isArray(parsed.data) && parsed.data.length > 0) {
        const categories = [
          "Sensory Modality Preferences",
          "Social & Environmental Learning Orientation",
          "Self-Regulation & Metacognition",
          "Motivational & Affective Dispositions",
          "Cognitive Style & Thinking Disposition",
        ];
        const keyMap = {
          "Sensory Modality Preferences": "sensoryModalityPreferences",
          "Social & Environmental Learning Orientation": "socialEnvironmentalLearning",
          "Self-Regulation & Metacognition": "selfRegulationMetacognition",
          "Motivational & Affective Dispositions": "motivationalAffectiveDispositions",
          "Cognitive Style & Thinking Disposition": "cognitiveStyleThinkingDisposition",
        };
        recoveredLearningVis = {};
        categories.forEach(cat => {
          const answers = parsed.data.filter(a => a.category === cat);
          if (answers.length === 0) return;
          const facetMap = answers.reduce((acc, a) => {
            const f = a.facet || 'Unknown';
            if (!acc[f]) {
              acc[f] = {
                scores: [],
                facet_note: a.facet_note || null,
                low_note: a.low_note || null,
                mid_note: a.mid_note || null,
                high_note: a.high_note || null,
              };
            }
            acc[f].scores.push(a.score);
            return acc;
          }, {});
          const labels = Object.keys(facetMap);
          const avgByFacet = Object.fromEntries(
            labels.map(f => [f, facetMap[f].scores.reduce((s, v) => s + v, 0) / facetMap[f].scores.length])
          );
          const facetNoteMap = Object.fromEntries(
            labels.map(f => {
              const d = facetMap[f];
              return [f, buildFacetNoteData(d.facet_note, d.low_note, d.mid_note, d.high_note, avgByFacet[f])];
            })
          );
          recoveredLearningVis[keyMap[cat]] = {
            labels,
            datasets: [{
              label: cat,
              data: labels.map(f => avgByFacet[f]),
              totalScores: labels.map(f => facetMap[f].scores.reduce((s, v) => s + v, 0)),
              facetNote: labels.map(f => facetNoteMap[f] || null),
              backgroundColor: 'rgba(75,192,192,0.2)',
              borderColor: 'rgba(75,192,192,1)',
              borderWidth: 1,
            }],
            facetNote: facetNoteMap,
          };
        });
      }
    }
    if (recoveredLearningVis) {
      await saveVisualizationsCache(effectiveUserId, 'Learning', recoveredLearningVis).catch(() => {});
    }
  } catch {}
}

  const cacheUserId = effectiveUserId || userId;

  const chosenTopSubjectFacetNote = await fetchChosenSubjectFacetNote(chosenTopSubject);

  const pdfData = {
    userName: name,
    sortedScores: resolvedSortedScores,
    sortedPart3Scores: resolvedSortedPart3Scores,
    careerVisualizations: resolvedCareerVis,
    learningVisualizations: recoveredLearningVis,
    insights: insightsFromStorage,
    strategy: strategyFromStorage,
    userId: cacheUserId,
    viewingChildId: isParentView ? viewingChildId : null,

    // Both loaded from Dexie (populated by CareerDashboard / StudyStyle)
    careerProfileMatches: {},
    studyProfileMatches: {},
    chosenTopSubject: chosenTopSubject || null,
    chosenTopSubjectReason: chosenTopSubject ? (subjectReasons[chosenTopSubject] || null) : null,
    chosenTopSubjectFacetNote,
  };

  try {
    if (cacheUserId) {
      const [careerRow, studyRow] = await Promise.all([
        getProfileMatchesCache(cacheUserId, 'career'),
        getProfileMatchesCache(cacheUserId, 'study'),
      ]);
      if (careerRow?.matches) {
        pdfData.careerProfileMatches = careerRow.matches;
      }
      if (studyRow?.matches) {
        pdfData.studyProfileMatches = studyRow.matches;
      }
    }
  } catch (e) {
    console.warn('Could not load profile matches for UniReady PDF', e);
  }

  const hasAnyData =
    pdfData.sortedScores.length > 0 ||
    pdfData.sortedPart3Scores.length > 0 ||
    pdfData.careerVisualizations ||
    pdfData.learningVisualizations ||
    pdfData.insights?.trim() ||
    pdfData.strategy?.trim();

  if (!hasAnyData) {
    showToast(
      "No assessment data found. Complete UniReady, StudyStyle, or FutureReady first, then try again.",
      "error", 5000
    );
    return;
  }

  try {
    const { generateFullReport } = await import('../../utils/generateFullReport');
    await generateFullReport(pdfData);
  } catch (err) {
    console.error("PDF generation failed:", err);
    showToast("Failed to create PDF. Please try again.", "error");
  }
};

  // Check eligibility for Part III button
  useEffect(() => {
  const checkPart3Eligibility = async () => {
    if (!effectiveUserId || !lastCompletedSessionIds.subject) {
      setIsEligibleForPart3(false);
      setLoading((prev) => ({ ...prev, part3Eligibility: false }));
      setError((prev) => ({
        ...prev,
        part3Eligibility: "",
      }));
      return;
    }

 let scoresToUse = scores;
    if (location.state?.justSubmittedSubject) {
      const vizEndpoint = isParentView
        ? `/api/assessment/child-visualizations/${effectiveUserId}`
        : `/api/assessment/visualizations/${effectiveUserId}`;

      const response = await axios.get(vizEndpoint, {
        params: { sessionId: lastCompletedSessionIds.subject, assessmentType: "Subject" },
        headers: getAuthHeaders(),
      });
      await saveRawAnswers(effectiveUserId, 'Subject', response.data, lastCompletedSessionIds.subject);
      const visualizations = processRawAnswers(response.data, "Subject");
      scoresToUse = visualizations.partII.scores;
      setScores(scoresToUse);
      setRawAnswers((prev) => ({ ...prev, subject: response.data }));
    } else {
      const CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days — must match fetchSubjectRawAnswers effect
      const cachedRow = await getRawAnswers(effectiveUserId, 'Subject');
      const isCorrectSession = cachedRow?.sessionId === lastCompletedSessionIds.subject;
      if (cachedRow && isCorrectSession) {
        const cacheAge = Date.now() - cachedRow.timestamp;
        if (cacheAge < CACHE_TTL) {
          const visualizations = processRawAnswers(cachedRow.data, "Subject");
          scoresToUse = visualizations.partII.scores;
          setScores(scoresToUse);
        } else {
          await clearRawAnswers(effectiveUserId, 'Subject');
        }
      } else if (cachedRow && !isCorrectSession) {
        // Session moved on since this was cached (retake happened) — treat as stale
        await clearRawAnswers(effectiveUserId, 'Subject');
      }
    }

    try {
      const sortedScores = [...scoresToUse].sort(
        (a, b) => (b.averageScore || 0) - (a.averageScore || 0)
      );

      if (sortedScores.length === 0) {
        throw new Error("No valid scores found.");
      }

      let topFacets = [sortedScores[0]._id];
      if (sortedScores.length > 1) {
        const secondHighestScore = sortedScores[1].averageScore;
        topFacets = topFacets.concat(
          sortedScores
            .slice(1)
            .filter((score) => score.averageScore >= secondHighestScore)
            .map((score) => score._id)
        );
      }

// Put this in place of the old hasPartIIITaxonomy calculation
const hasPartIIITaxonomy = topFacets.some((facet) => {
  const facetScore = scoresToUse.find((score) => score._id === facet);
  if (!facetScore?.taxonomy) return false;

  const taxonomies = Array.isArray(facetScore.taxonomy)
    ? facetScore.taxonomy
    : typeof facetScore.taxonomy === 'string'
      ? [facetScore.taxonomy]
      : [];

  return taxonomies.includes("Part III");
});

      setIsEligibleForPart3(hasPartIIITaxonomy);
      setLoading((prev) => ({ ...prev, part3Eligibility: false }));
      setError((prev) => ({ ...prev, part3Eligibility: null }));
    } catch (err) {
      console.error("checkPart3Eligibility: Error:", err.message);
      setIsEligibleForPart3(false);
      setLoading((prev) => ({ ...prev, part3Eligibility: false }));
      setError((prev) => ({
        ...prev,
        part3Eligibility: `Failed to check Part III eligibility: ${err.message}`,
      }));
    }
  };

  if (
    lastCompletedSessionIds.subject ||
    location.state?.justSubmittedSubject
  ) {
    checkPart3Eligibility();
  } else {
    setIsEligibleForPart3(false);
    setLoading((prev) => ({ ...prev, part3Eligibility: false }));
    setError((prev) => ({ ...prev, part3Eligibility: "" }));
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [userId, lastCompletedSessionIds.subject, location.state?.justSubmittedSubject]);

const isAvatarChangeAllowed = () => {
  if (isAdmin) return true;
  if (!lastAvatarChangeDate) return true;

  try {
    const lastChange = new Date(lastAvatarChangeDate);
    if (isNaN(lastChange.getTime())) return true;

    const twentyFourHoursLater = new Date(lastChange.getTime() + 24 * 60 * 60 * 1000);
    return Date.now() >= twentyFourHoursLater.getTime();
  } catch (err) {
    console.warn("Invalid lastAvatarChangeDate format");
    return true; // fail open
  }
};



 // Handle navigation from assessment completion for subject only
useEffect(() => {
  const handleSubmission = async (type, sessionIdKey, justSubmittedKey) => {
    if (location.state?.[justSubmittedKey] && location.state?.[sessionIdKey]) {
      try {
        const progress = await fetchProgress(effectiveUserId, {
          assessmentType: type,
          sessionId: location.state[sessionIdKey],
        });

        if (progress?.lastCompletionDate) {
          const CACHE_KEY = `progress_${effectiveUserId}_${type}`;
          localStorage.setItem(
            CACHE_KEY,
            JSON.stringify({ ...progress, timestamp: Date.now() })
          );

          const vizEndpoint = isParentView
            ? `/api/assessment/child-visualizations/${effectiveUserId}`
            : `/api/assessment/visualizations/${effectiveUserId}`;

          const answers = await axios.get(vizEndpoint, {
            params: { sessionId: progress.sessionId, assessmentType: type },
            headers: getAuthHeaders(),
          });

if (answers.data.length > 0) {
            await saveRawAnswers(effectiveUserId, type, answers.data, progress.sessionId);

             // Update Part II raw answers cache for SubjectPart3Assessment
            if (type === 'Subject') {
              const partIIAnswers = answers.data.filter((a) => a.category === 'Part II');
              const partIICacheKey = `subjectPart3AssessmentPartIIRawAnswers_${userId}_${progress.sessionId}`;
              localStorage.setItem(
                partIICacheKey,
                JSON.stringify(partIIAnswers)
              );
              console.log('Updated Part II raw answers cache for SubjectPart3:', partIICacheKey);
            }
            
            setLastCompletedSessionIds((prev) => ({
              ...prev,
              [type.toLowerCase()]: location.state[sessionIdKey],
            }));
            setLastCompletionDates((prev) => ({
              ...prev,
              [type.toLowerCase()]: progress.lastCompletionDate || null,
            }));
            setCompletionStatus((prev) => ({
              ...prev,
              [type.toLowerCase()]: true,
            }));
            // Update raw answers state
            setRawAnswers((prev) => ({
              ...prev,
              [type.toLowerCase()]: answers.data,
            }));
          } else {
            localStorage.removeItem(`${type.toLowerCase()}SessionId`);
            if (type === "Subject") setSubjectSessionId(null);
            else if (type === "SubjectPart3") setSubjectPart3SessionId(null);
          }
        }
      } catch (err) {
        console.error(`Error verifying ${type} completion:`, err.message);
        if (err.response?.status === 404) {
          localStorage.removeItem(`${type.toLowerCase()}SessionId`);
          if (type === "Subject") setSubjectSessionId(null);
          else if (type === "SubjectPart3") setSubjectPart3SessionId(null);
        }
      }
    }
  };

  Promise.all([
    location.state?.justSubmittedSubject
      ? handleSubmission("Subject", "subjectSessionId", "justSubmittedSubject").then(() =>
          handleSubjectAssessment()
        )
      : Promise.resolve(),
    location.state?.justSubmittedSubjectPart3
      ? handleSubmission(
          "SubjectPart3",
          "subjectpart3SessionId",
          "justSubmittedSubjectPart3"
        ).then(() => handleSubjectAssessment())
      : Promise.resolve(),
  ]);
}, [location.state, userId]);


// === AUTOMATIC ACCOUNT DATES FETCH WITH LONG CACHE ===
useEffect(() => {
  const fetchAccountDates = async () => {
    if (!effectiveUserId) return;

    const CACHE_KEY = `account_dates_${effectiveUserId}`;
    const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

    // Check cache first
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (Date.now() - parsed.timestamp < CACHE_TTL) {
          applyAccountDates(parsed.data);
          return;
        }
      } catch (e) {
        localStorage.removeItem(CACHE_KEY);
      }
    }

    // Fetch fresh
    try {
      const response = await axios.get(`/api/users/account-dates/${effectiveUserId}`, {
        headers: getAuthHeaders(),
      });

      const data = response.data;

      localStorage.setItem(CACHE_KEY, JSON.stringify({
        data,
        timestamp: Date.now()
      }));

      applyAccountDates(data);
    } catch (err) {
      console.error("Failed to fetch account dates:", err);
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  };

  fetchAccountDates();
}, [effectiveUserId, navigate]);

 // Fetch user email
useEffect(() => {
  const fetchUserEmail = async () => {
    if (!userId) {
      setUserEmail("User");
      setRole("user");
      localStorage.setItem("userEmail", "User");
      localStorage.setItem("role", "user");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      setUserEmail("User");
      setRole("user");
      localStorage.setItem("userEmail", "User");
      localStorage.setItem("role", "user");
      return;
    }

    // Check navigation state for cached user data
    const cachedUserData = location.state?.cachedUserData;
    if (cachedUserData?.app_role) {
      setRole(cachedUserData.app_role);
      setUserEmail(localStorage.getItem("userEmail") || "User"); // Fallback to localStorage for email
      localStorage.setItem("role", cachedUserData.app_role);
      return;
    }

    // Check localStorage first and validate cache
    const CACHE_KEY = `user_data_${userId}`;
    const cachedData = localStorage.getItem(CACHE_KEY);
    const CACHE_TTL = 2 * 24 * 60 * 60 * 1000; // 48 hours

    if (cachedData && !lastEmailChangeDate) {
      try {
        const { email, role, timestamp } = JSON.parse(cachedData);
        if (Date.now() - timestamp < CACHE_TTL) {
          setUserEmail(email || "User");
          setRole(role || "user");
          localStorage.setItem("userEmail", email || "User");
          localStorage.setItem("role", role || "user");
          return;
        }
      } catch {
        localStorage.removeItem(CACHE_KEY);
      }
    }

    try {
      const response = await axios.get(`/api/users/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const { email, role } = response.data;
      const newEmail = email || "User";
      const newRole = role || "user";
      setUserEmail(newEmail);
      setRole(newRole);
      localStorage.setItem("userEmail", newEmail);
      localStorage.setItem("role", newRole);
      // Cache user data
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ email: newEmail, role: newRole, timestamp: Date.now() })
      );
    } catch (err) {
      console.error("Error fetching user data:", err);
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("role");
        localStorage.removeItem(CACHE_KEY);
        navigate("/login");
      } else {
        setUserEmail("User");
        setRole("user");
        localStorage.setItem("userEmail", "User");
        localStorage.setItem("role", "user");
      }
    }
  };
  fetchUserEmail();
}, [userId, navigate, lastEmailChangeDate, location.state]);

useEffect(() => {
  const SUBJECT_FACETS_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days

  const fetchSubjects = async () => {
    // Try the Dexie cache first — shared with the PDF export's chosen-subject
    // note lookup, so whichever loads first populates it for the other.
    try {
      const cached = await getSubjectFacetsCache();
      if (cached?.data && Date.now() - cached.timestamp < SUBJECT_FACETS_TTL) {
        setAvailableSubjects(cached.data.filter(f => f.category === 'Subject'));
        return;
      }
    } catch (e) {
      console.warn('Could not read subject facets cache from Dexie', e);
    }

    try {
      const response = await axios.get('/api/questions/facets');
      const allFacets = response.data || [];
      await saveSubjectFacetsCache(allFacets);
      setAvailableSubjects(allFacets.filter(f => f.category === 'Subject'));
    } catch (err) {
      console.error('Error fetching subjects:', err);
    }
  };
  fetchSubjects();
}, []);

useEffect(() => {
  const fetchChosenTopSubject = async () => {
    if (!effectiveUserId) return;

   const cachedSubject = await getChosenTopSubject(effectiveUserId);
    if (cachedSubject) {
      setChosenTopSubject(cachedSubject);
      return;
    }

    console.log("🟡 No local chosenTopSubject → Fetching from DB");

    try {
      const response = await axios.get(`/api/users/user/${effectiveUserId}`, {
        headers: getAuthHeaders(),
      });

      const subject = response.data?.chosen_top_subject || null;
      setChosenTopSubject(subject);

      if (subject) {
      await saveChosenTopSubject(effectiveUserId, subject);
      }
    } catch (err) {
      console.error("❌ Failed to fetch chosenTopSubject:", err);
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
      setChosenTopSubject(null);
    }
  };

  fetchChosenTopSubject();
}, [effectiveUserId, navigate]);

 

// Load once when component mounts or when effectiveUserId changes
useEffect(() => {
  if (!effectiveUserId) return;

  const loadJobs = async () => {
    const data = await getPortfolioJobs(effectiveUserId);
    setPortfolioXJobs(Array.isArray(data) ? data : []);
  };

  loadJobs();

}, [effectiveUserId]);

  // Update completion status based on location state
 useEffect(() => {
  const newStatus = {
    subject: false,
    subjectpart3: false,
  };
  const newDates = {
    subject: null,
    subjectpart3: null,
  };

  const updateStatus = (type, completionDate) => {
    if (completionDate) {
      try {
        const threeMonthsInMs = 3 * 30 * 24 * 60 * 60 * 1000;
const timeSinceLast = Date.now() - new Date(completionDate).getTime();
if (timeSinceLast < threeMonthsInMs) {
          newStatus[type] = true;
          newDates[type] = completionDate;
        }
      } catch (err) {
        console.error(`Invalid completionDate for ${type}:`, err);
      }
    }
  };

  if (location.state?.justSubmittedSubject && !isAdmin) {
    updateStatus("subject", location.state.completionDate);
  }
  if (location.state?.justSubmittedSubjectPart3 && !isAdmin) {
    updateStatus("subjectpart3", location.state.completionDate);
  }

  setCompletionStatus((prev) => ({ ...prev, ...newStatus }));
  setLastCompletionDates((prev) => ({ ...prev, ...newDates }));
}, [location.state, isAdmin]);

  // Check completion status for assessments
useEffect(() => {
  if (!userId) return;

  const checkCompletion = async (type, key, sessionId) => {
    try {
      const CACHE_KEY = `progress_${effectiveUserId}_${type}`;
      let progress = localStorage.getItem(CACHE_KEY);
      if (progress) {
        try {
          progress = JSON.parse(progress);
        } catch {
          localStorage.removeItem(CACHE_KEY);
          progress = null;
        }
      }

      if (!progress || location.state?.[`justSubmitted${type}`]) {
        progress = await fetchProgress(effectiveUserId, {
          assessmentType: type,
          sessionId: sessionId || undefined,
          fetchLatest: !sessionId,
        });
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ ...progress, timestamp: Date.now() })
        );
      }

      const lastCompletionDate = progress?.lastCompletionDate;
      const fetchedSessionId = progress?.sessionId;

let isFullyCompleted = false;
      if (lastCompletionDate && fetchedSessionId) {
      const cachedAnswerRow = await getRawAnswers(effectiveUserId, type);
        const isCorrectSession = cachedAnswerRow?.sessionId === fetchedSessionId;
        let answers = isCorrectSession ? cachedAnswerRow?.data : null;

        if (!answers || location.state?.[`justSubmitted${type}`]) {
          const response = await axios.get(
            `/api/assessment/visualizations/${effectiveUserId}`,
            {
              params: { sessionId: fetchedSessionId, assessmentType: type },
              headers: getAuthHeaders(),
            }
          );
          answers = response.data;
          await saveRawAnswers(effectiveUserId, type, answers, fetchedSessionId);
        }

        isFullyCompleted = answers.length > 0;
        if (!isFullyCompleted) {
          localStorage.removeItem(`${type.toLowerCase()}SessionId`);
        } else {
          setRawAnswers((prev) => ({
            ...prev,
            [type.toLowerCase()]: answers,
          }));
        }
      }

      let canRetake = true;
      if (isFullyCompleted && !isAdmin) {
        try {
          const threeMonthsInMs = 3 * 30 * 24 * 60 * 60 * 1000;
const timeSinceLast = Date.now() - new Date(lastCompletionDate).getTime();
canRetake = timeSinceLast >= threeMonthsInMs;
        } catch (err) {
          console.error(`Invalid ${type} lastCompletionDate:`, err);
          canRetake = true;
        }
      }

      if (isFullyCompleted && fetchedSessionId) {
        setLastCompletedSessionIds((prev) => ({
          ...prev,
          [key]: fetchedSessionId,
        }));
        if (type === "Subject") {
          setSubjectSessionId(fetchedSessionId);
          localStorage.setItem("subjectSessionId", fetchedSessionId);
        } else if (type === "SubjectPart3") {
          setSubjectPart3SessionId(fetchedSessionId);
          localStorage.setItem("subjectpart3SessionId", fetchedSessionId);
        }
      }

      setCompletionStatus((prev) => ({
        ...prev,
        [key]: !canRetake,
      }));
      setLastCompletionDates((prev) => ({
        ...prev,
        [key]: lastCompletionDate || null,
      }));
    } catch (err) {
      console.error(`Error fetching ${type} progress:`, err.message);
      setCompletionStatus((prev) => ({
        ...prev,
        [key]: false,
      }));
      setLastCompletionDates((prev) => ({
        ...prev,
        [key]: null,
      }));
      setLastCompletedSessionIds((prev) => ({
        ...prev,
        [key]: null,
      }));
    }
  };

  Promise.all([
    checkCompletion("Subject", "subject", subjectSessionId),
    checkCompletion("SubjectPart3", "subjectpart3", subjectpart3SessionId),
  ]).then(() => {
    setLoading((prev) => ({
      ...prev,
      scores: false,
    }));
  });
}, [
  effectiveUserId,
  isAdmin,
  subjectSessionId,
  subjectpart3SessionId,
  location.state,
]);


  const formatDate = (date) => {
    if (!date) return "Unknown date";
    try {
      return new Date(date).toLocaleDateString("en-UK", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "Invalid date";
    }
  };

 // Update fetch effect for Subject raw answers
useEffect(() => {
  const CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days

  const fetchSubjectRawAnswers = debounce(async () => {
    if (!effectiveUserId || !lastCompletedSessionIds.subject) {
      setLoading((prev) => ({ ...prev, subjectVisualizations: false }));
      setError((prev) => ({
        ...prev,
        subjectVisualizations: "",
      }));
      setRawAnswers((prev) => ({ ...prev, subject: [] }));
      setCompletionStatus((prev) => ({ ...prev, subject: false }));
      return;
    }

const cachedRow = await getRawAnswers(effectiveUserId, 'Subject');
    const isCorrectSession = cachedRow?.sessionId === lastCompletedSessionIds.subject;

    if (cachedRow && isCorrectSession && !location.state?.justSubmittedSubject) {
      const cacheAge = Date.now() - cachedRow.timestamp;
      if (cacheAge < CACHE_TTL) {
        setRawAnswers((prev) => ({ ...prev, subject: cachedRow.data }));
        setLoading((prev) => ({ ...prev, subjectVisualizations: false }));
        setError((prev) => ({ ...prev, subjectVisualizations: null }));
        setCompletionStatus((prev) => ({ ...prev, subject: true }));
        return;
      }
      await clearRawAnswers(effectiveUserId, 'Subject');
    } else if (cachedRow && !isCorrectSession) {
      await clearRawAnswers(effectiveUserId, 'Subject');
    }

    try {
      const answers = await fetchRawAnswers(effectiveUserId, lastCompletedSessionIds.subject, "Subject");
      await saveRawAnswers(effectiveUserId, 'Subject', answers, lastCompletedSessionIds.subject);

      setRawAnswers((prev) => ({ ...prev, subject: answers }));
      setLoading((prev) => ({ ...prev, subjectVisualizations: false }));
      setError((prev) => ({ ...prev, subjectVisualizations: null }));
      setCompletionStatus((prev) => ({ ...prev, subject: true }));
    } catch (err) {
      console.error("fetchSubjectRawAnswers: Error:", err.message);
      setError((prev) => ({
        ...prev,
        subjectVisualizations: err.message,
      }));
      setLoading((prev) => ({ ...prev, subjectVisualizations: false }));
      setCompletionStatus((prev) => ({ ...prev, subject: false }));
      if (err.message.includes("Unauthorized")) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  }, 300);

  if (
    (lastCompletionDates.subject || location.state?.justSubmittedSubject) &&
    lastCompletedSessionIds.subject
  ) {
    fetchSubjectRawAnswers();
  } else {
    setLoading((prev) => ({ ...prev, subjectVisualizations: false }));
    setError((prev) => ({
      ...prev,
      subjectVisualizations: "",
    }));
    setRawAnswers((prev) => ({ ...prev, subject: [] }));
    setCompletionStatus((prev) => ({ ...prev, subject: false }));
  }
}, [
  effectiveUserId,
  navigate,
  location.state?.justSubmittedSubject,
  lastCompletionDates.subject,
  lastCompletedSessionIds.subject,
]);

 // Update fetch effect for SubjectPart3 raw answers
useEffect(() => {
  const CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days

  const fetchSubjectPart3RawAnswers = debounce(async () => {
    if (!effectiveUserId || !lastCompletedSessionIds.subjectpart3) {
      setLoading((prev) => ({ ...prev, subjectPart3Visualizations: false }));
      setError((prev) => ({
        ...prev,
        subjectPart3Visualizations: "",
      }));
      setRawAnswers((prev) => ({ ...prev, subjectpart3: [] }));
      return;
    }

 const cachedRow = await getRawAnswers(effectiveUserId, 'SubjectPart3');
    const isCorrectSession = cachedRow?.sessionId === lastCompletedSessionIds.subjectpart3;

    if (cachedRow && isCorrectSession && !location.state?.justSubmittedSubjectPart3) {
      const cacheAge = Date.now() - cachedRow.timestamp;
      if (cacheAge < CACHE_TTL) {
        setRawAnswers((prev) => ({ ...prev, subjectpart3: cachedRow.data }));
        setLoading((prev) => ({ ...prev, subjectPart3Visualizations: false }));
        setError((prev) => ({ ...prev, subjectPart3Visualizations: null }));
        return;
      }
      await clearRawAnswers(effectiveUserId, 'SubjectPart3');
    } else if (cachedRow && !isCorrectSession) {
      await clearRawAnswers(effectiveUserId, 'SubjectPart3');
    }

    try {
      const answers = await fetchRawAnswers(effectiveUserId, lastCompletedSessionIds.subjectpart3, "SubjectPart3");
      await saveRawAnswers(effectiveUserId, 'SubjectPart3', answers, lastCompletedSessionIds.subjectpart3);

      setRawAnswers((prev) => ({ ...prev, subjectpart3: answers }));
      setLoading((prev) => ({ ...prev, subjectPart3Visualizations: false }));
      setError((prev) => ({ ...prev, subjectPart3Visualizations: null }));
    } catch (err) {
      console.error("fetchSubjectPart3RawAnswers: Error:", err.message);
      setError((prev) => ({
        ...prev,
        subjectPart3Visualizations: err.message,
      }));
      setLoading((prev) => ({ ...prev, subjectPart3Visualizations: false }));
      if (err.message.includes("Unauthorized")) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  }, 300);

  if (
    (lastCompletionDates.subjectpart3 || location.state?.justSubmittedSubjectPart3) &&
    lastCompletedSessionIds.subjectpart3
  ) {
    fetchSubjectPart3RawAnswers();
  } else {
    setLoading((prev) => ({ ...prev, subjectPart3Visualizations: false }));
    setError((prev) => ({
      ...prev,
      subjectPart3Visualizations: "",
    }));
    setRawAnswers((prev) => ({ ...prev, subjectpart3: [] }));
  }
}, [
  effectiveUserId,
  navigate,
  location.state?.justSubmittedSubjectPart3,
  lastCompletionDates.subjectpart3,
  lastCompletedSessionIds.subjectpart3,
]);

// ── Career Map Modal ──────────────────────────────────────────────
const [careerMapSubject, setCareerMapSubject] = useState(null);
const [careerMapJobs, setCareerMapJobs]       = useState([]);
const [careerMapLoading, setCareerMapLoading] = useState(false);

const [superMapSubject,  setSuperMapSubject]  = useState(null);
const [superMapActivities, setSuperMapActivities] = useState([]);
const [superMapLoading,  setSuperMapLoading]  = useState(false);

  // Prepare chart data for Subject (Part II) scores
  const sortedScores = useMemo(() => {
    return [...scores].sort((a, b) => (b.averageScore || 0) - (a.averageScore || 0));
  }, [scores]);

  const topScores = useMemo(() => {
    const result = [];
    let i = 0;
    while (
      i < sortedScores.length &&
      (result.length < 3 ||
        sortedScores[i].averageScore === result[2].averageScore)
    ) {
      result.push(sortedScores[i]);
      i++;
    }
    return result;
  }, [sortedScores]);

  const chartData = useMemo(() => {
  return {
    labels: topScores.map((score) => score._id || "Unknown"),
    datasets: [
      {
        label: "Average Score",
        data: topScores.map((score) => score.averageScore || 0),
        backgroundColor: "rgba(75, 192, 192, 0.29)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
        facetNotes: topScores.map((score) => {
          const facetNote = score.facetNote;
          return !facetNote || typeof facetNote !== "string" || facetNote.trim() === ""
            ? "No description available for this facet."
            : facetNote;
        }),
      },
    ],
  };
}, [topScores]);

  // Prepare chart data for SubjectPart3 (Part III) scores
  const sortedPart3Scores = useMemo(() => {
    return [...subjectPart3Scores].sort(
      (a, b) => (b.averageScore || 0) - (a.averageScore || 0)
    );
  }, [subjectPart3Scores]);

  const topPart3Scores = useMemo(() => {
    const result = [];
    let j = 0;
    while (
      j < sortedPart3Scores.length &&
      (result.length < 3 ||
        sortedPart3Scores[j].averageScore === result[2].averageScore)
    ) {
      result.push(sortedPart3Scores[j]);
      j++;
    }
    return result;
  }, [sortedPart3Scores]);

 const chartDataPart3 = useMemo(() => {
  return {
    labels: topPart3Scores.map((score) => score._id || "Unknown"),
    datasets: [
      {
        label: "Average Score",
        data: topPart3Scores.map((score) => score.averageScore || 0),
        backgroundColor: "rgba(153, 102, 255, 0.29)",
        borderColor: "rgba(153, 102, 255, 1)",
        borderWidth: 1,
        facetNotes: topPart3Scores.map((score) => {
          const facetNote = score.facetNote;
          return !facetNote || typeof facetNote !== "string" || facetNote.trim() === ""
            ? "No description available for this facet."
            : facetNote;
        }),
      },
    ],
  };
}, [topPart3Scores]);

const JOBPOSTS_CACHE_TTL = 30 * 24 * 60 * 60 * 1000; // 7 days — same as CareerDashboard


// Key used by DashboardEnrich for supercurricular activities
const superCacheKey = `super_activities_all_${effectiveUserId}`;
const SUPER_CACHE_TTL = 30 * 24 * 60 * 60 * 1000; // 30 days (same as Enrich)
 
const readSuperCache = useCallback(async () => {
  return await getSuperActivities(effectiveUserId);
}, [effectiveUserId]);
 
const writeSuperCache = useCallback(async (data) => {
  await saveSuperActivities(effectiveUserId, data);
}, [effectiveUserId]);

// ── Background prefetch for all top subjects ──────────────────────
// Uses topScores / topPart3Scores (already defined above via useMemo)

useEffect(() => {
  if (!effectiveUserId) return;
 
  const now = Date.now();
 
  const subjectsToFetch = [
    ...(chosenTopSubject ? [chosenTopSubject] : []),
    ...topScores.map(s => s._id),
    ...topPart3Scores.map(s => s._id),
  ].filter(Boolean).filter((v, i, arr) => arr.indexOf(v) === i);
 
  if (subjectsToFetch.length === 0) return;
 
  let cancelled = false;
 
  const fetchNext = async () => {
    for (const subject of subjectsToFetch) {
      if (cancelled) break;
 
     // Check the shared per-subject entry
      const cachedRow = await getJobposts(effectiveUserId, subject);
      if (cachedRow && now - (cachedRow.timestamp || 0) < JOBPOSTS_CACHE_TTL) {
        continue; // still fresh
      }
 
      try {
        const response = await fetch(
          `/api/questions/jobposts/subject/${encodeURIComponent(subject)}`,
          { headers: getAuthHeaders() }
        );
        if (!response.ok || cancelled) continue;
        const data = await response.json();
        const flat = Array.isArray(data) ? data : [];
 
        await saveJobposts(effectiveUserId, subject, flat);
      } catch {
        // non-critical background fetch — skip silently
      }
 
      // Gentle stagger to avoid hammering the server
      await new Promise(r => setTimeout(r, 150));
    }
  };
 
  fetchNext();
  return () => { cancelled = true; };
}, [effectiveUserId, chosenTopSubject, topScores, topPart3Scores, JOBPOSTS_CACHE_TTL]);

useEffect(() => {
  if (scores.length > 0 || subjectPart3Scores.length > 0) {
    setCompletedAssessments(prev => ({
      ...prev,
      uniready: true
    }));
  }
}, [scores, subjectPart3Scores]);


useEffect(() => {
  if (!effectiveUserId || isParentView || topScores.length === 0) return;

  const hasSeenPrompt = localStorage.getItem(`has_seen_subject_reason_prompt_${effectiveUserId}`) === 'true';
  const alreadyHasSomeReasons = Object.keys(subjectReasons).length > 0;

  if (!hasSeenPrompt && !alreadyHasSomeReasons) {
    const timer = setTimeout(() => {
      isAnyModalOpenRef.current = true;   // guard against tooltip auto-close
      setIsAnyModalOpen(true);
      setReasonPromptIndex(0);
      setShowFirstTimeReasonPrompt(true);
      localStorage.setItem(`has_seen_subject_reason_prompt_${effectiveUserId}`, 'true');
    }, 1200);
    return () => clearTimeout(timer);
  }
}, [effectiveUserId, isParentView, topScores, subjectReasons]);

useEffect(() => {
  if (!effectiveUserId) return;
 
  const now = Date.now();
  const subjectsToFetch = [
    ...(chosenTopSubject ? [chosenTopSubject] : []),
    ...topScores.map(s => s._id),
    ...topPart3Scores.map(s => s._id),
  ].filter(Boolean).filter((v, i, arr) => arr.indexOf(v) === i);
 
  if (subjectsToFetch.length === 0) return;
 
  let cancelled = false;
 
  const fetchNext = async () => {
    // Read the shared cache (written by both Dashboard and DashboardEnrich)
    let cache = await getSuperActivities(effectiveUserId);
    if (!cache.data) cache = { userId: effectiveUserId, data: {}, timestamp: now };
 
    for (const subject of subjectsToFetch) {
      if (cancelled) break;
      const key = subject.toLowerCase();
 
      // Cache hit check
      if (
        cache.data[key] !== undefined &&
        now - (cache.timestamp || 0) < SUPER_CACHE_TTL
      ) continue;
 
      try {
        const response = await fetch(
          `/api/questions/supercurricular-activities?subjects=${encodeURIComponent(subject)}`,
          { headers: getAuthHeaders() }
        );
        if (!response.ok || cancelled) continue;
        const data = await response.json();
 
        // Store in the same grouped-by-subject structure DashboardEnrich uses
        cache.data[key] = Array.isArray(data) ? data : [];
        cache.timestamp = Date.now();
 
        // Persist
        await saveSuperActivities(effectiveUserId, cache.data);
      } catch {
        // non-critical background fetch — skip silently
      }
      await new Promise(r => setTimeout(r, 200)); // gentle stagger
    }
  };
 
  fetchNext();
  return () => { cancelled = true; };
}, [effectiveUserId, chosenTopSubject, topScores, topPart3Scores, superCacheKey]);

// ── openCareerMap: open the modal, serving from cache or fetching ──
const openCareerMap = useCallback(async (subject) => {
   isAnyModalOpenRef.current = true;  // sync, before any await
   setIsAnyModalOpen(true);
  if (!subject) return;
  setCareerMapSubject(subject);
 
 const now = Date.now();
 
  // Try the shared cache first
  const cachedRow = await getJobposts(effectiveUserId, subject);
  if (cachedRow && now - (cachedRow.timestamp || 0) < JOBPOSTS_CACHE_TTL && Array.isArray(cachedRow.data)) {
    // Instant serve — CareerDashboard already fetched this
    setCareerMapJobs(cachedRow.data);
    setCareerMapLoading(false);
    return;
  }
 
  // Cache miss or expired — fetch and write
  setCareerMapJobs([]);
  setCareerMapLoading(true);
  try {
    const response = await fetch(
      `/api/questions/jobposts/subject/${encodeURIComponent(subject)}`,
      { headers: getAuthHeaders() }
    );
    const data = response.ok ? await response.json() : [];
    const flat = Array.isArray(data) ? data : [];
    setCareerMapJobs(flat);
 
    await saveJobposts(effectiveUserId, subject, flat);
  } catch {
    setCareerMapJobs([]);
  } finally {
    setCareerMapLoading(false);
  }
}, [effectiveUserId, JOBPOSTS_CACHE_TTL]);


const openSuperMap = useCallback(async (subject) => {
  isAnyModalOpenRef.current = true;  // sync, before any await
  setIsAnyModalOpen(true); 
  if (!subject) return;
  setSuperMapSubject(subject);
 
 const now    = Date.now();
  const cache  = await getSuperActivities(effectiveUserId);
 
  const key    = subject.toLowerCase();
  const cached = cache.data?.[key];
  const fresh  = now - (cache.timestamp || 0) < SUPER_CACHE_TTL;
 
  if (cached !== undefined && fresh && Array.isArray(cached)) {
    setSuperMapActivities(cached);
    setSuperMapLoading(false);
    return;
  }
 
  // Cache miss — fetch
  setSuperMapActivities([]);
  setSuperMapLoading(true);
  try {
    const response = await fetch(
      `/api/questions/supercurricular-activities?subjects=${encodeURIComponent(subject)}`,
      { headers: getAuthHeaders() }
    );
    const data = response.ok ? await response.json() : [];
    const flat = Array.isArray(data) ? data : [];
    setSuperMapActivities(flat);
 
    // Update shared cache
    const updatedData = { ...(cache.data || {}), [key]: flat };
    await saveSuperActivities(effectiveUserId, updatedData);
  } catch {
    setSuperMapActivities([]);
  } finally {
    setSuperMapLoading(false);
  }
}, [superCacheKey, SUPER_CACHE_TTL]);

// ── AcadFeed: read shared IndexedDB cache, fetch only if stale ──────────────
const loadAcadFeedForSubject = useCallback(async (subject) => {
  if (!subject || !userId) return;

  // Session guard: only skip re-checking IndexedDB if we checked within the last hour.
  // This mirrors ProFeed's throttle and prevents permanently stale data once the
  // Dashboard (or deckSPACE modal) has been open/mounted for a long time.
  const sessionCheckedAt = acadFeedFetchedSubjects.get(subject);
  if (sessionCheckedAt && Date.now() - sessionCheckedAt < 60 * 60 * 1000) return;

  setAcadFeedLoading(true);

  const ONE_DAY_MS = 24 * 60 * 60 * 1000;
  const now = Date.now();

  try {
    // 1. Read from shared IndexedDB (same DB EnrichFeed writes to)
    const [allItems, fetchTimes] = await Promise.all([
      loadFeedItems(userId),
      loadFetchTimes(userId),
    ]);

    const lastFetch = fetchTimes[subject] || 0;
    const existingForSubject = Object.values(allItems).filter(
      (item) => item.subject === subject
    );

    // 2. If cache is fresh, use it directly — no network call
if (now - lastFetch < ONE_DAY_MS && existingForSubject.length > 0) {
      const recent = existingForSubject
        .sort((a, b) => new Date(b.pub_date) - new Date(a.pub_date))
        .slice(0, 5);
      setAcadFeedItems((prev) => ({ ...prev, [subject]: recent }));
      setAcadFeedFetchedSubjects((prev) => new Map([...prev, [subject, Date.now()]]));
      return;
    }

    // 3. Cache stale or empty — fetch incrementally
    let newestPubDate = null;
    for (const item of existingForSubject) {
      if (item.pub_date) {
        const d = new Date(item.pub_date);
        if (!isNaN(d.getTime()) && (!newestPubDate || d > newestPubDate)) {
          newestPubDate = d;
        }
      }
    }

    const token = localStorage.getItem('token');
    if (!token) return;

    const params = { subject };
    if (newestPubDate) {
      params.since = newestPubDate.toISOString();
    } else {
      params.limit = 250;
    }

    const res = await fetch(
      `/api/rss/items?${new URLSearchParams(params)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!res.ok) throw new Error('Feed fetch failed');

    const newArticles = await res.json();

    // 4. Write new articles to shared IndexedDB (EnrichFeed will pick them up)
    if (newArticles.length > 0) {
      await saveFeedItems(userId, newArticles);
    }
    await saveFetchTime(userId, subject, now);

    // 5. Re-read combined set for display
    const updatedAll = await loadFeedItems(userId);
    const combined = Object.values(updatedAll)
      .filter((item) => item.subject === subject)
      .sort((a, b) => new Date(b.pub_date) - new Date(a.pub_date))
      .slice(0, 5);

   setAcadFeedItems((prev) => ({ ...prev, [subject]: combined }));
    setAcadFeedFetchedSubjects((prev) => new Map([...prev, [subject, Date.now()]]));
  } catch (err) {
    console.warn('[Dashboard AcadFeed] fetch failed:', err.message);
    setAcadFeedItems((prev) => ({ ...prev, [subject]: [] }));
  } finally {
    setAcadFeedLoading(false);
  }
}, [userId, acadFeedFetchedSubjects]);




useEffect(() => {
  if (scores.length > 0 || subjectPart3Scores.length > 0) {
    setCompletedAssessments(prev => ({
      ...prev,
      uniready: true
    }));
  }
}, [scores, subjectPart3Scores]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: "UniReady Subject Scores",
        padding: 40,
        color: "white",
        align: "center",
        position: "top",
        font: { size: 20 },
      },
      tooltip: { enabled: false },
    },
    scales: {
      x: {
        beginAtZero: true,
        suggestedMax: 5,
        ticks: {
          color: "white",
          font: { size: 14 },
          callback: (value) => (Number.isInteger(value) ? value : null),
        },
      },
      y: {
        ticks: {
          color: "white",
          font: { size: 14 },
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
      },
    },
  onClick: (event, elements, chart) => {
  if (elements && Array.isArray(elements) && elements.length > 0) {
    const element = elements[0];
    const index = element.index;
    const label = chart.data.labels[index] || "Unknown";
    const facetNotes = chart.data.datasets[0].facetNotes || [];
    const facetNote = facetNotes[index] || "No description available for this facet.";

    // Close if same or different
    if (currentFacetUni !== label) {
      setActiveTabUni('A-Levels');
      setAcadFeedOpenUni(false);
    }

    // Trigger fetch via effect
    fetchFacetDataUni(label);

    const canvas = chart.canvas;
    const rect = canvas.getBoundingClientRect();
    const bar = chart.getDatasetMeta(0).data[index];

    const tooltipWidth = 550;
    const tooltipHeight = tooltipLoadingUni ? 100 : 200;

    let tooltipX = rect.left;
    let tooltipY = rect.bottom * 1.03;

    if (tooltipX + tooltipWidth > window.innerWidth) {
      tooltipX = tooltipX - tooltipWidth - 20;
    }
    if (tooltipY < 0) tooltipY = 10;
    if (tooltipY + tooltipHeight > window.innerHeight) tooltipY = window.innerHeight - tooltipHeight - 10;

    setTooltipUniReady({
      visible: true,
      content: null, // Will be set by effect
      x: tooltipX,
      y: tooltipY,
    });
  } else {
    setTooltipUniReady({ visible: false, content: null, x: 0, y: 0 });
    setCurrentFacetUni(null);
    setFacetDataUni({ note: '', options: [] });
    setTooltipContentUni(null);
    setActiveTabUni('A-Levels');
    setAcadFeedOpenUni(false); 
  }
},
    onHover: (event, elements, chart) => {
      chart.canvas.style.cursor =
        elements && Array.isArray(elements) && elements.length > 0
          ? "pointer"
          : "default";
    },
  };


  const chartOptionsPart3 = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: "Subject Exploration Scores",
        padding: 40,
        color: "white",
        align: "center",
        position: "top",
        font: { size: 20 },
      },
      tooltip: { enabled: false },
    },
    scales: {
      x: {
        beginAtZero: true,
        suggestedMax: 5,
        ticks: {
          color: "white",
          font: { size: 14 },
          callback: (value) => (Number.isInteger(value) ? value : null),
        },
      },
      y: {
        ticks: {
          color: "white",
          font: { size: 14 },
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
      },
    },
    onClick: (event, elements, chart) => {
  if (elements && Array.isArray(elements) && elements.length > 0) {
    const element = elements[0];
    const index = element.index;
    const label = chart.data.labels[index] || "Unknown";
    const facetNotes = chart.data.datasets[0].facetNotes || [];
    const facetNote = facetNotes[index] || "No description available for this facet.";

    // Close if same or different
    if (currentFacetPart3 !== label) {
      setActiveTabPart3('A-Levels');
      setAcadFeedOpenPart3(false);
    }

    // Trigger fetch via effect
    fetchFacetDataPart3(label);

    const canvas = chart.canvas;
    const rect = canvas.getBoundingClientRect();
    const bar = chart.getDatasetMeta(0).data[index];

    const tooltipWidth = 550;
    const tooltipHeight = tooltipLoadingPart3 ? 100 : 200;
  
    let tooltipX = rect.left;
    let tooltipY = rect.bottom * 1.03;

    if (tooltipX + tooltipWidth > window.innerWidth) {
      tooltipX = tooltipX - tooltipWidth - 20;
    }
    if (tooltipY < 0) tooltipY = 10;
    if (tooltipY + tooltipHeight > window.innerHeight) tooltipY = window.innerHeight - tooltipHeight - 10;

    setTooltipPart3({
      visible: true,
      content: null, // Will be set by effect
      x: tooltipX,
      y: tooltipY,
    });
  } else {
    setTooltipPart3({ visible: false, content: null, x: 0, y: 0 });
    setCurrentFacetPart3(null);
    setFacetDataPart3({ note: '', options: [] });
    setTooltipContentPart3(null);
    setActiveTabPart3('A-Levels');
    setAcadFeedOpenPart3(false);
  }
},
  onHover: (event, elements, chart) => {
    chart.canvas.style.cursor =
      elements && Array.isArray(elements) && elements.length > 0
        ? "pointer"
        : "default";
  },
};


const processRawAnswers = (answers, assessmentType) => {
  let visualizations = {};

  if (assessmentType === 'Subject') {
    const partIIAnswers = answers.filter((a) => a.category === 'Part II');
    visualizations = {
      partII: {
        scores: computePartIIScores(partIIAnswers),
      },
    };
  } else if (assessmentType === 'SubjectPart3') {
    const partIIIAnswers = answers.filter((a) => a.category === 'Part III');
    visualizations = {
      partIII: {
        scores: computePartIIIScores(partIIIAnswers),
      },
    };
  }

  return visualizations;
};


// New function to compute Part II scores
const computePartIIScores = (answers) => {
  const facetMap = answers.reduce((acc, answer) => {
    const facet = answer.facet || 'Unknown';
    if (!acc[facet]) {
      acc[facet] = {
        scores: [],
        taxonomy: new Set(),
        facetNote: answer.facet_note || null,
      };
    }
    acc[facet].scores.push(answer.score);
    if (answer.taxonomy && Array.isArray(answer.taxonomy)) {
      answer.taxonomy.forEach((tax) => acc[facet].taxonomy.add(tax));
    }
    return acc;
  }, {});

  return Object.entries(facetMap)
    .filter(([_, data]) => data.scores.length > 0)
    .map(([facet, data]) => ({
      _id: facet,
      averageScore: data.scores.reduce((sum, score) => sum + score, 0) / data.scores.length,
      totalScore: data.scores.reduce((sum, score) => sum + score, 0), // ← added
      count: data.scores.length, // ← also added, matches Part III shape and gives you the n for the 0.5-interval question from before
      taxonomy: Array.from(data.taxonomy),
      facetNote: data.facetNote,
    }));
};

const computePartIIIScores = (answers) => {
  const facetMap = answers.reduce((acc, answer) => {
    const facet = answer.facet || 'Unknown';
    if (!acc[facet]) {
      acc[facet] = {
        scores: [],
        facetNote: answer.facet_note || null, // Use facet_note from facets table
      };
    }
    acc[facet].scores.push(answer.score);
    return acc;
  }, {});

  return Object.entries(facetMap)
    .filter(([_, data]) => data.scores.length > 0)
    .map(([facet, data]) => ({
      _id: facet,
      averageScore: data.scores.reduce((sum, score) => sum + score, 0) / data.scores.length,
      totalScore: data.scores.reduce((sum, score) => sum + score, 0),
      count: data.scores.length,
      facetNote: data.facetNote,
    }))
    .sort((a, b) => a._id.localeCompare(b._id));
};

// Update scores and subjectPart3Scores state with computed values
useEffect(() => {
  if (rawAnswers.subject.length > 0) {
    const visualizations = processRawAnswers(rawAnswers.subject, 'Subject');
    setScores(visualizations.partII.scores);
    setLoading((prev) => ({ ...prev, scores: false }));
    setError((prev) => ({ ...prev, scores: null }));
  } else {
    setScores([]);
    setLoading((prev) => ({ ...prev, scores: false }));
    setError((prev) => ({ ...prev, scores: '' }));
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [rawAnswers.subject]);

 // Separate useEffect for saving top subjects
// ─────────────────────────────────────────────────────────────
// Save Top Subjects (Part II + Part III) - Fixed version
// ─────────────────────────────────────────────────────────────
useEffect(() => {
  if (!effectiveUserId) return;

  const saveTopSubjects = debounce(async () => {
    const isPart2Completion = !!location.state?.justSubmittedSubject;
    const isPart3Completion = !!location.state?.justSubmittedSubjectPart3;

    if (!isPart2Completion && !isPart3Completion) return;

    let topSubjects = { partII: [], partIII: [] };

    // ==================== LOAD EXISTING DATA FIRST ====================
    try {
      const userRes = await axios.get(`/api/users/user/${effectiveUserId}`, {
        headers: getAuthHeaders(),
      });
      const existing = userRes.data?.top_uniready_subjects || { partII: [], partIII: [] };
      
      topSubjects.partII = existing.partII || [];
      topSubjects.partIII = existing.partIII || [];
    } catch (e) {
      console.warn("Could not fetch existing top subjects, starting fresh", e);
    }

    // ==================== PART II ====================
    if (isPart2Completion) {
      if (location.state.topPartIISubjects?.length > 0) {
        topSubjects.partII = location.state.topPartIISubjects;
      } else if (topScores.length > 0) {
        topSubjects.partII = topScores
          .sort((a, b) => (b.averageScore || 0) - (a.averageScore || 0))
          .slice(0, 5)
          .map(score => ({
            subject: score._id,
            averageScore: Number(score.averageScore?.toFixed(2) || 0),
          }));
      }
    }

    // ==================== PART III ====================
    if (isPart3Completion) {
      if (location.state.topPart3Subjects?.length > 0) {
        topSubjects.partIII = location.state.topPart3Subjects;
      } else if (topPart3Scores.length > 0) {
        topSubjects.partIII = topPart3Scores
          .sort((a, b) => (b.averageScore || 0) - (a.averageScore || 0))
          .slice(0, 5)
          .map(score => ({
            subject: score._id,
            averageScore: Number(score.averageScore?.toFixed(2) || 0),
          }));
      }
    }

    if (topSubjects.partII.length === 0 && topSubjects.partIII.length === 0) {
      console.log('No top subjects to save');
      return;
    }

    try {
      await axios.post(
        `/api/users/save-top-subjects/${effectiveUserId}`,
        { topSubjects },
        { headers: getAuthHeaders() }
      );
      console.log('✅ Top subjects saved (merged)', topSubjects);
    } catch (err) {
      console.error('Error saving top subjects:', err.response?.data || err.message);
    }
  }, 600);

  saveTopSubjects();

  // Cleanup
  return () => {
    if (location.state?.justSubmittedSubject || location.state?.justSubmittedSubjectPart3) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  };
}, [
  effectiveUserId,
  location.state,
  topScores,
  topPart3Scores,
  navigate,
]);

useEffect(() => {
  if (rawAnswers.subjectpart3.length > 0) {
    const visualizations = processRawAnswers(rawAnswers.subjectpart3, 'SubjectPart3');
    setSubjectPart3Scores(visualizations.partIII.scores);
    setLoading((prev) => ({ ...prev, subjectPart3Scores: false }));
    setError((prev) => ({ ...prev, subjectPart3Scores: null }));
  } else {
    setSubjectPart3Scores([]);
    setLoading((prev) => ({ ...prev, subjectPart3Scores: false }));
    setError((prev) => ({ ...prev, subjectPart3Scores: '' }));
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [rawAnswers.subjectpart3]);


  
  // Handle clicks outside account menu
 // Replace the existing handleClickOutside useEffect with this:

useEffect(() => {
  const handleClickOutside = (event) => {
    // Account menu
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      const clickedAccountButton = event.target.closest('.account-icon');
      if (!clickedAccountButton) setShowAccountMenu(false);
    }

    // === MAIN FIX: Don't close tooltip if any modal is open ===
    if (isAnyModalOpenRef.current) return;

    const tooltip = document.querySelector('[role="tooltip"]');
    const clickedInsideTooltip = tooltip?.contains(event.target);

      const clickedInsideChart = 
      document.querySelector(".charts-container")?.contains(event.target) ||
      event.target.closest(".dash-rank-row") ||
      event.target.closest(".dash-chosen-card");

    if (!clickedInsideChart && !clickedInsideTooltip) {
      setTooltipUniReady({ visible: false, content: "", x: 0, y: 0 });
      setTooltipPart3({ visible: false, content: "", x: 0, y: 0 });
      setAcadFeedOpenUni(false);
      setAcadFeedOpenPart3(false);

      // Unselect any active RankedScoreRow / chosen-subject card
      setCurrentFacetUni(null);
      setFacetDataUni({ note: '', options: [] });
      setTooltipContentUni(null);
      setActiveTabUni('A-Levels');

      setCurrentFacetPart3(null);
      setFacetDataPart3({ note: '', options: [] });
      setTooltipContentPart3(null);
      setActiveTabPart3('A-Levels');
    }
  };

  const eventType = ('ontouchstart' in window || navigator.maxTouchPoints > 0) ? 'click' : 'mousedown';
  document.addEventListener(eventType, handleClickOutside);

  return () => document.removeEventListener(eventType, handleClickOutside);
}, []);   // ← important dependency

useEffect(() => {
  isAnyModalOpenRef.current = isAnyModalOpen;
}, []);

useEffect(() => {
  if (showKnowledgeUploadModal && knowledgeDeviceUrl) {
    loadDocuments(knowledgeDeviceUrl);
  }
}, [showKnowledgeUploadModal, knowledgeDeviceUrl]);

  const toggleAccountMenu = () => {
    setShowAccountMenu((prev) => !prev);
  };

const handleManageAccount = async () => {
  setShowAccountMenu(false);
  setShowManageModal(true);
  setModalAction(null);
  setPassword("");
  setNewEmail("");
  setPasswordError(null);
  setActionError(null);
};

const isActionAllowed = (action) => {
  if (isAdmin) return true;

  const oneMonthInMs = 30 * 24 * 60 * 60 * 1000;
  const now = Date.now();

  if (action === "email" && lastEmailChangeDate) {
    const timeSinceLast = now - new Date(lastEmailChangeDate).getTime();
    return timeSinceLast >= oneMonthInMs;
  }
  if (action === "download" && lastDataDownloadDate) {
    const timeSinceLast = now - new Date(lastDataDownloadDate).getTime();
    return timeSinceLast >= oneMonthInMs;
  }
  if (action === "delete" && lastAccountDeletionDate) {
    const timeSinceLast = now - new Date(lastAccountDeletionDate).getTime();
    return timeSinceLast >= oneMonthInMs;
  }
  if (action === "username" && lastUsernameChangeDate) {
    const timeSinceLast = now - new Date(lastUsernameChangeDate).getTime();
    return timeSinceLast >= oneMonthInMs;
  }
  return true;
};

const handleChangeUsername = async () => {
  if (!password) {
    setPasswordError("Password is required.");
    return;
  }
  if (!newUsername) {
    setUsernameError("New username is required.");
    return;
  }
  if (newUsername.length < 3 || newUsername.length > 50) {
    setUsernameError("Username must be between 3 and 50 characters.");
    return;
  }

  try {
    setUsernameError(null);
    setPasswordError(null);
    const isPasswordValid = await verifyPassword();
    if (!isPasswordValid) {
      setPasswordError("Incorrect password.");
      return;
    }

    const response = await axios.put(
      `/api/users/update-username`,
      { userId, username: newUsername },
      {
        headers: getAuthHeaders(),
      }
    );

    setUserUsername(response.data.username);
    setLastUsernameChangeDate(response.data.lastUsernameChangeDate);
    
    invalidateAccountCache();    

    setNewUsername("");
    setPassword("");
    setModalAction(null);
    setShowManageModal(false);
    showToast("Username updated successfully!", "success");
  } catch (err) {
    setUsernameError(err.response?.data?.error || "Failed to update username.");
  }
};

const verifyPassword = async () => {
  try {
    const response = await axios.post(
      `/api/users/verify-password`,
      { userId, password },
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data.isValid;
  } catch (err) {
    setPasswordError("Failed to verify password. Please try again.");
    return false;
  }
};



const applyAccountDates = (data) => {
  if (!isParentView) {
    setLastEmailChangeDate(data.lastEmailChangeDate || null);
    setLastDataDownloadDate(data.lastDataDownloadDate || null);
    setLastUsernameChangeDate(data.lastUsernameChangeDate || null);
    setLastAccountDeletionDate(data.lastAccountDeletionDate || null);
  }
  setLastSubjectChoiceDate(data.lastSubjectChoiceDate || null);
};

// Handle Action Initiation (Corrected Placement)
const initiateAction = async (action) => {
  if (!password) {
    setPasswordError("Password is required.");
    return;
  }
  const isPasswordValid = await verifyPassword();
  if (!isPasswordValid) {
    setPasswordError("Incorrect password.");
    return;
  }
  setPasswordError(null);

  let message = "";
  if (action === "email") {
    if (!newEmail) {
      setActionError("New email is required.");
      return;
    }
    message = isAdmin
      ? "Are you sure you want to change the email address?"
      : "You can only change your email once a month. Proceed?";
  } else if (action === "download") {
    message = isAdmin
      ? "Are you sure you want to download user data?"
      : "You can only download your data once a month. Proceed?";
  } else if (action === "delete") {
    message = "Deleting your account is irreversible and will remove all your data. Proceed?";
  }

  setConfirmMessage(message);
  setPendingAction(action);
  setShowConfirmModal(true);
};


const confirmAction = async () => {
  try {
    setActionError(null);
    if (pendingAction === "email") {
      await axios.post(
        `/api/users/change-email`,
        { userId, newEmail },
        {
          headers: getAuthHeaders(),
        }
      );

      invalidateAccountCache();  
      
      setShowConfirmModal(false);
      setShowVerificationModal(true);
    } else if (pendingAction === "download") {
      const response = await axios.get(
        `/api/users/download-data/${userId}`,
        {
          headers: getAuthHeaders(),
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `user_data_${userId}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLastDataDownloadDate(new Date().toISOString());
      setShowConfirmModal(false);
      setShowManageModal(false);
    } else if (pendingAction === "delete") {
      await axios.delete(`/api/users/delete/${userId}`, {
        headers: getAuthHeaders(),
      });
      setLastAccountDeletionDate(new Date().toISOString());
      setShowConfirmModal(false);
      setShowManageModal(false);
      handleLogoutClick();
    }
  } catch (err) {
    setActionError(`Failed to perform action: ${err.response?.data?.error || err.message}`);
  }
};

const handleLogoutClick = useCallback(() => {
  setShowAccountMenu(false);
  localStorage.removeItem("subjectSessionId");
  localStorage.removeItem("subjectpart3SessionId");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("role");
  localStorage.removeItem("userUsername");
  onLogout();
}, [onLogout]);


const handleAssessment = (type, path) => {
  const assessmentType = type.toLowerCase();
  if (!isAdmin && completionStatus[assessmentType]) {
    showToast(
      `You already completed ${type} — retake available from ${formatDate(lastCompletionDates[assessmentType])}.`,
      "info", 5000
    );
    return;
  }

  if (assessmentType === "subject") {
    setSubjectSessionId(null);
    localStorage.removeItem("subjectSessionId");
  } else if (assessmentType === "subjectpart3") {
    setSubjectPart3SessionId(null);
    localStorage.removeItem("subjectpart3SessionId");
  }

  navigate(path, { state: { startNewAssessment: true } });
};

const handleSubjectAssessment = () => {
  setActiveSidebarItem("uniready");
};


  const handlePart3Assessment = () => {
    setSubjectPart3SessionId(null);
    localStorage.removeItem("subjectpart3SessionId");
    navigate("/subjectpart3assessment", { state: { startNewAssessment: true } });
  };

  
 const renderAssessmentSection = (type) => {
  const assessmentName = 'UniReady';
  const path = '/subjectassessment';
  const hasResults =
    lastCompletedSessionIds.subject && scores.length > 0;
  const hasPart3Results =
    type === 'subject' &&
    lastCompletedSessionIds.subjectpart3 &&
    subjectPart3Scores.length > 0;

    const canRetakeSubject = () => {
  if (isAdmin) return true;
  if (!lastCompletionDates.subject) return true;

  try {
    const completion = new Date(lastCompletionDates.subject);
    if (isNaN(completion.getTime())) return true; // corrupt date → allow retake

    const threeMonthsLater = new Date(completion.getTime() + 3 * 30 * 24 * 60 * 60 * 1000);
return Date.now() >= threeMonthsLater.getTime();
  } catch (err) {
    console.warn("Invalid lastCompletionDate format:", lastCompletionDates.subject);
    return true; // safety fallback
  }
};

const hasAnyProgress = hasResults || chosenTopSubject || completionStatus.subject;

 if (!hasAnyProgress && !isParentView) {
    return (
    <div className="welcome-section-cyber">
  
        <div className="wc-icon-wrap">
        <div className="wc-icon-ring" />
        <div className="wc-icon-ring wc-ring-2" />
        <FaCircleNodes className="wc-icon-emoji" style={{ color: '#36a7f8' }} />
      </div>

      <div className="wc-eyebrow">
        <span className="wc-dot" /> Getting started
      </div>

      <h2 className="wc-title" style={{
        fontSize: '2.2rem',
        marginBottom: '16px',
        color: '#36a7f8',
        fontWeight: 700,
        letterSpacing: '-0.01em',
      }}>
        Welcome aboard to ASPIREdeck!
      </h2>

      <p className="wc-body" style={{
        fontSize: '1.22rem',
        lineHeight: 1.55,
        maxWidth: '680px',
        margin: '0 auto',
        color: '#ddd',
      }}>
        Start your journey by completing the <strong style={{ color: '#fff' }}>UniReady Assessment</strong> to
        discover your strongest subject interests, or directly choose your top higher education
        subject if you already know your focus.
      </p>

      <div className="wc-feature-row">
        <div className="wc-feature-chip"><FaRegLightbulb /> Enrich+</div>
        <div className="wc-feature-chip"><FaReact /> FutureLab</div>
        <div className="wc-feature-chip"><FaBurst /> SparkHub</div>
        <div className="wc-feature-chip"><FaChessKing /> Mastery</div>
      </div>

      <div className="wc-cta-row">
        <TooltipUI
          text={!isAdmin && !canRetakeSubject() ? `Retake available from ${formatDate(new Date(new Date(lastCompletionDates.subject).getTime() + 3 * 30 * 24 * 60 * 60 * 1000))}` : ''}
        >
          <button
            className="assessment-button welcome-button wc-btn-primary"
            onClick={() => handleAssessment(assessmentName, path)}
          >
            Take UniReady Assessment
          </button>
        </TooltipUI>

        <TooltipUI
text={!isAdmin && !isSubjectChoiceAllowed() ? `Top subject choice restricted once every 3 months.` : ''}
        >
          <button
            className="assessment-button welcome-button wc-btn-secondary"
            onClick={() => setShowChooseSubjectModal(true)}
          >
            Select Your Current Subject
          </button>
        </TooltipUI>
      </div>


      <p className="wc-footer">
        <FaCertificate className="wc-footer-certificate" style={{ color: '#36a7f8' }} />
Completing UniReady will unlock Enrich+, FutureLab and more personalised SparkHub.</p>
    </div>
  );
}

return (
    <div className="careerpage">
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
      }}
    >
      <div
        className="button-container"
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap', // Updated: Add wrap for 2x2 stacking
          gap: '20px',
          justifyContent: 'center',
        }}
      >
             {/* Hide these buttons completely in parent view */}
          {!isParentView && (
            <>
        <TooltipUI
  text={
    !isAdmin && !canRetakeSubject()
      ? `Last completed on ${formatDate(lastCompletionDates.subject)}. Retake available from ${formatDate(
          new Date(new Date(lastCompletionDates.subject).getTime() + 3 * 30 * 24 * 60 * 60 * 1000)
        )}.`
      : ''
  }
>
  <button
  className={`assessment-button ${isReadOnlyView || (!isAdmin && !canRetakeSubject()) ? 'disabled' : ''}`}
  onClick={() => {
    if (isReadOnlyView) return;
    handleAssessment(assessmentName, path)
     }}
  disabled={isReadOnlyView || (!isAdmin && !canRetakeSubject())}
  >
    Take {assessmentName} Assessment
  </button>
</TooltipUI>
          <TooltipUI
    text={
      !isAdmin && !isSubjectChoiceAllowed()
        ? `Top subject choice restricted to once every 3 months. Last changed on ${formatDate(
    lastSubjectChoiceDate
  )}. Next available after ${formatDate(
    new Date(new Date(lastSubjectChoiceDate).getTime() + 3 * 30 * 24 * 60 * 60 * 1000)
  )}.`
        : ''
    }
  >
<button 
  className={`assessment-button ${isReadOnlyView || (!isAdmin && !isSubjectChoiceAllowed()) ? 'disabled' : ''}`} 
  onClick={() => { if (isReadOnlyView) return; setShowChooseSubjectModal(true); }} 
  disabled={isReadOnlyView || (!isAdmin && !isSubjectChoiceAllowed())} 
>
  <span>Choose Your Top Subject</span>
</button>
  </TooltipUI>
        {type === 'subject' && isEligibleForPart3 && (
          <TooltipUI
            text={
              !isAdmin && completionStatus.subjectpart3
                ? `Last completed on ${formatDate(
                    lastCompletionDates.subjectpart3
                  )}. Retake available from ${formatDate(
                    new Date(
                      new Date(lastCompletionDates.subjectpart3).getTime() +
                        3 * 30 * 24 * 60 * 60 * 1000
                    )
                  )}.`
                : !isAdmin && completionStatus.subject
                ? `Proceed to Part III based on your UniReady results.`
                : ''
            }
          >
<button
  className={`assessment-button ${isReadOnlyView || (!isAdmin && completionStatus.subjectpart3) ? 'disabled' : ''}`}
  onClick={() => {
    if (isReadOnlyView) return;
    handlePart3Assessment();
  }}
  disabled={isReadOnlyView || (!isAdmin && completionStatus.subjectpart3)}
>
  Advanced Subject Exploration
</button>
          </TooltipUI>
        )}
         </>
        )}
        {hasResults && (
          <button
            className="scoring-details-button"
            onClick={() => {
  const params = viewingChildId
    ? `?viewingChildId=${encodeURIComponent(viewingChildId)}&childName=${encodeURIComponent(viewingChildName)}`
    : '';
  navigate(`/${type}-scores${params}`, {
    state: {
      sessionId: lastCompletedSessionIds[type],
      ...(type === 'subject' && {
        partIIScores: scores,
        partIIIScores: subjectPart3Scores,
      }),
      viewingChildId,
      childName: viewingChildName,
    },
  });
}}
          >
            {assessmentName} Scoring Details
          </button>
        )}
 
         {/* ── NEW SECOND ROW: What's Next? button (only shown after results) ── */}
        {hasResults && (

            <button
              className="whats-next-button insights-button whats-next-assessment"
              onClick={() => setShowWhatsNextModalUniReady(true)}
            >
              What's Next?
            </button>

        )}
             </div>
{chosenTopSubject && (
  <div
    className={`dash-chosen-card ${currentFacetUni === chosenTopSubject ? 'dash-chosen-card-active' : ''}`}
    ref={chosenSubjectRef}
    style={{
      ...gradientBorder,
      borderRadius: radius.lg,
      padding: `15px ${spacing.lg}`,
      maxWidth: "600px",
      margin: `${spacing.sm} auto 0`,
      textAlign: "center",
      cursor: "pointer",
      transition: `box-shadow ${transition.base}, transform ${transition.base}`,
    }}
    onClick={(e) => {
      e.stopPropagation();
      if (currentFacetUni === chosenTopSubject) {
        setTooltipUniReady({ visible: false, content: null, x: 0, y: 0 });
        setCurrentFacetUni(null);
        setFacetDataUni({ note: '', options: [] });
        setTooltipContentUni(null);
        setActiveTabUni('A-Levels');
      } else {
        openScoreTooltip(e, chosenTopSubject, 'uni');
      }
    }}
  >
    <div className="chosen-top-subject-card" style={{
      display: "inline-flex", alignItems: "center", gap: "6px",
      fontSize: fontSize.xs, fontWeight: 700, letterSpacing: "0.06em",
      textTransform: "uppercase", color: color.primaryLight, marginBottom: spacing.xs,
    }}>
      <FaGraduationCap size={25}/> Your Chosen Top Subject
    </div>

<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:'center'}}>
    <div style={{ fontSize: "1rem", fontWeight: 600, color: "white", marginBottom: '0px' }}>
      {chosenTopSubject}
    </div>


    <div style={{ display: "flex", gap: '0px', justifyContent: "center" }}>
      <button
        className="dash-icon-btn"
        onClick={(e) => { e.stopPropagation(); openCareerMap(chosenTopSubject); }}
        style={{ background: "none", border: "none", color: color.accent, fontSize: "18px", padding: "6px" }}
        title="Explore Career"
      >
        <FaRegCompass />
      </button>
      <button
        className="dash-icon-btn"
        onClick={(e) => {
          e.stopPropagation();
          const subjectToUse = currentFacetUni || chosenTopSubject;
          if (!subjectToUse) return;
          setActiveTabUni('A-Levels');
          fetchFacetDataUni(subjectToUse);
          const rect = e.currentTarget.getBoundingClientRect();
          setTooltipUniReady({ visible: true, content: null, x: Math.max(20, rect.left - 200), y: rect.bottom + 10 });
          setAcadFeedOpenUni(true);
          loadAcadFeedForSubject(subjectToUse);
        }}
        style={{ background: "none", border: "none", color: color.accent, fontSize: "18px", padding: "6px" }}
        title="Preview Academic Feed"
      >
        <FaRss />
      </button>
    </div>
     </div>

  </div>
)}
       {hasResults ? (
      (
          <div className="charts-row"> 
            <div className="chart-wrapper"> 
                <h3 style={{ textAlign: "center", color: color.textPrimary, fontSize: fontSize.lg, margin: `0 0 ${spacing.base}` }}>
    UniReady Subject Scores
  </h3>
         {topScores.map((s, i) => (
  <RankedScoreRow
    key={s._id}
    rank={i + 1}
    label={s._id}
    score={s.averageScore || 0}
    accent={color.primaryLight}
    isSelected={currentFacetUni === s._id}
    onClick={(e) => openScoreTooltip(e, s._id, 'uni')}
  />
))}
        {tooltipUniReady.visible && (
  <div
    role="tooltip"
    aria-live="polite"
    className="dash-tooltip-panel  "
    style={{
      position: 'fixed',
      left: `${tooltipUniReady.x}px`,
      top: `${tooltipUniReady.y}px`,
      background: color.bgPanelAlt,
      color: 'white',
      padding: spacing.base,
      border: '1px solid rgba(54,167,248,0.25)',
      borderRadius: radius.lg,
      maxWidth: 'min(550px, calc(100vw - 32px))',
      width: '500px',
      zIndex: 9999,
      pointerEvents: 'auto',
      boxShadow: '0 16px 44px rgba(0,0,0,0.5), 0 0 0 1px rgba(54,167,248,0.08)',
    }}
  >
    {tooltipContentUni ? (
      <>
        {/* Header row with title + two buttons */}
<div 
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px',
    flexWrap: 'nowrap',
    gap: '12px'
  }}
>
  <button
  className="dash-tooltip-close"
  onClick={(e) => {
    e.stopPropagation();
    setTooltipUniReady({ visible: false, content: null, x: 0, y: 0 });
    setCurrentFacetUni(null);
    setFacetDataUni({ note: '', options: [] });
    setTooltipContentUni(null);
    setActiveTabUni('A-Levels');
    setAcadFeedOpenUni(false);
  }}
  title="Close"
>
  ×
</button>
  {/* Left: Subject name link */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
    <a
      href={`https://www.bachelorsportal.com/search/bachelor?kw-what=${encodeURIComponent(currentFacetUni)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#36a7f8", textDecoration: "underline", cursor: 'pointer' }}
      onClick={(e) => e.stopPropagation()}
    >
      <strong>{currentFacetUni}</strong>
    </a>
  </div>

  {/* Right: Compass + AcadFeed buttons – aligned right */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    {/* Compass button – unchanged position & style */}
   <button
  onClick={(e) => {
    e.stopPropagation();
    openCareerMap(currentFacetUni);
  }}
  style={{
    background: "none", border: "none", color: "#ffaa00",
    cursor: "pointer", fontSize: "20px", padding: "4px", lineHeight: 1,
  }}
  title="View Career Map"
>
  <FaRegCompass />
</button>

    {/* New AcadFeed button – same style as Compass */}
   <button
  onClick={(e) => {
    e.stopPropagation();
    if (acadFeedOpenUni) {
      setAcadFeedOpenUni(false);
    } else {
      setAcadFeedOpenUni(true);
      loadAcadFeedForSubject(currentFacetUni);
    }
  }}
  style={{
    background: acadFeedOpenUni ? 'rgba(255,170,0,0.18)' : 'none',
    border: acadFeedOpenUni ? '1px solid #ffaa00' : 'none',
    borderRadius: '6px',
    color: '#ffaa00',
    cursor: 'pointer',
    fontSize: '20px',
    padding: '4px',
    lineHeight: 1,
  }}
  title={acadFeedOpenUni ? 'Hide Academic Feed' : 'Preview Academic Feed'}
>
  <FaRss />
</button>
<button
  onClick={(e) => {
    e.stopPropagation();
    openReasonEditor(currentFacetUni);
  }}
  style={{
    background: 'none',
    border: 'none',
    borderRadius: '6px',
    color: '#ffaa00',
    cursor: 'pointer',
    fontSize: '20px',
    padding: '4px',
    lineHeight: 1,
  }}
  title={subjectReasons[currentFacetUni] ? 'Edit your notes on this subject' : 'Add a note: why do you like this subject?'}
>
  <FaPenSquare />
</button>
  </div>
</div>
<p style={{
  margin: `0 0 ${spacing.base} 0`, wordWrap: "break-word",
  fontSize: fontSize.sm, color: color.textSecondary, lineHeight: 1.5,
  paddingBottom: spacing.sm, borderBottom: `1px solid ${color.border}`,
}}>
  {tooltipContentUni.note}
</p>        
        {tooltipContentUni.options.length > 0 ? (
          <>
 <div style={{ display: 'flex', gap: '5px', marginBottom: '10px', flexWrap: 'wrap' }}>
  {['A-Levels', 'IB', 'AP', 'Supercurricular'].map((tab) => (   // ← removed 'AcadFeed'
     <TabButton
      key={tab}
      tab={tab}
      chartType="uni"
      currentFacetUni={currentFacetUni}
      currentFacetPart3={currentFacetPart3}   // can be undefined — doesn't hurt
      topScores={topScores}
      topPart3Scores={topPart3Scores}
      chosenTopSubject={chosenTopSubject}
      userEmail={userEmail}
      navigate={navigate}
      navigateWithViewMode={navigateWithViewMode} 
    openSuperMap={openSuperMap}   
    />
  ))}
  {/* AI Era Button - Same style as other tabs */}
          <a
            href={getAISearchLink(currentFacetUni)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{
              padding: '5px 10px',
              backgroundColor: '#ffaa0002',
              color: 'white',
               border: '2px solid transparent',
    backgroundImage: 'linear-gradient(#1e1e2e, #1e1e2e), linear-gradient(90deg, rgb(0, 255, 183), rgb(0, 170, 255))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#ffaa0022';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ffaa0002';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            AI Era Relevance
          </a>
</div>
            <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
             {tooltipContentUni.options
  .filter(opt => opt.name === activeTabUni)
  .map((opt, optIdx) => {
    const link = getOptionLink(opt.name);
    return (
<div key={optIdx} className="dash-option-card">
          {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '14px', color: "#36a7f8", textDecoration: "underline", cursor: 'pointer' }}
          >
            <strong>{opt.name}</strong>
          </a>
        ) : (
          <strong>{opt.name}</strong>
        )}
        <div style={{ marginTop: '5px' }}>
          {opt.sub_options.map((sub, subIdx) => (
            <div key={subIdx} style={{ fontSize: '13px', marginBottom: '3px' }}>
              <span style={{ fontWeight: 'bold' }}>{sub.name}: </span>
              {sub.sub_sub_options.map((s, sIdx) => s.name).filter(Boolean).join(', ') || 'None'}
            </div>
          ))}
        </div>
      </div>
    );
  })}
            </div>
          </>
        ) : (
          <p style={{ margin: 0, fontStyle: 'italic' }}>No options available for this facet.</p>
        )}
      </>
    ) : tooltipLoadingUni ? (
      <p>Loading data...</p>
    ) : (
      <p>No data available.</p>
    )}
    {/* AcadFeed inline panel — toggled by FaRss button */}
{acadFeedOpenUni && (
  <div  style={{ marginTop: '12px', borderTop: '1px solid rgba(255,170,0,0.3)', paddingTop: '10px' }}>
    <div className="acadfeed-panel" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', color: '#ffaa00', fontWeight: 600, fontSize: '0.88rem' }}>
      <FaRss /> Latest Articles
    </div>
    {renderAcadFeedPanel(currentFacetUni)}
  </div>
)}
  </div>
)}
            </div>
              {hasPart3Results && isEligibleForPart3 && (
              <div className="chart-wrapper"> {/* Updated: Add className="chart-wrapper" */}
  <h3 style={{ textAlign: "center", color: color.textPrimary, fontSize: fontSize.lg, margin: `0 0 ${spacing.base}` }}>
    Advanced Subject Exploration Scores
  </h3>
{topPart3Scores.map((s, i) => (
  <RankedScoreRow
    key={s._id}
    rank={i + 1}
    label={s._id}
    score={s.averageScore || 0}
    accent="rgba(153,102,255,1)"
    isSelected={currentFacetPart3 === s._id}
    onClick={(e) => openScoreTooltip(e, s._id, 'part3')}
  />
))}
{tooltipPart3.visible && (
  <div
    role="tooltip"
    aria-live="polite"
    className="dash-tooltip-panel"
    style={{
      position: 'fixed',  // Changed from 'absolute'
      left: `${tooltipPart3.x}px`,
      top: `${tooltipPart3.y}px`,
      backgroundColor: 'rgba(50, 50, 50, 0.9)',
      color: 'white',
      padding: spacing.base,
      border: '1px solid rgba(54,167,248,0.25)',
      borderRadius: radius.lg,
      maxWidth: 'min(550px, calc(100vw - 32px))',
      width: '500px',
      zIndex: 9999,
      pointerEvents: 'auto',
      boxShadow: '0 16px 44px rgba(0,0,0,0.5), 0 0 0 1px rgba(54,167,248,0.08)',
    }}
  >
    {tooltipContentPart3 ? (
      <>
       <div 
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px',
    flexWrap: 'nowrap',
    gap: '12px'
  }}
>
  <button
  className="dash-tooltip-close"
  onClick={(e) => {
  e.stopPropagation();
    setTooltipPart3({ visible: false, content: null, x: 0, y: 0 });
    setCurrentFacetPart3(null);
    setFacetDataPart3({ note: '', options: [] });
    setTooltipContentPart3(null);
    setActiveTabPart3('A-Levels');
    setAcadFeedOpenPart3(false);
  }}
  title="Close"
>
  ×
</button>
  {/* Left: Subject name */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
    <a
      href={`https://www.bachelorsportal.com/search/bachelor?kw-what=${encodeURIComponent(currentFacetPart3)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#36a7f8", textDecoration: "underline", cursor: 'pointer' }}
      onClick={(e) => e.stopPropagation()}
    >
      <strong>{currentFacetPart3}</strong>
    </a>
  </div>

  {/* Right: Compass + AcadFeed */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    {/* Compass – unchanged */}
   <button
  onClick={(e) => {
    e.stopPropagation();
    openCareerMap(currentFacetPart3);
  }}
  style={{
    background: "none", border: "none", color: "#ffaa00",
    cursor: "pointer", fontSize: "20px", padding: "4px", lineHeight: 1,
  }}
  title="View Career Map"
>
  <FaRegCompass />
</button>

    {/* AcadFeed button */}
   <button
  onClick={(e) => {
    e.stopPropagation();
    if (acadFeedOpenPart3) {
      setAcadFeedOpenPart3(false);
    } else {
      setAcadFeedOpenPart3(true);
      loadAcadFeedForSubject(currentFacetPart3);
    }
  }}
  style={{
    background: acadFeedOpenPart3 ? 'rgba(255,170,0,0.18)' : 'none',
    border: acadFeedOpenPart3 ? '1px solid #ffaa00' : 'none',
    borderRadius: '6px',
    color: '#ffaa00',
    cursor: 'pointer',
    fontSize: '20px',
    padding: '4px',
    lineHeight: 1,
  }}
  title={acadFeedOpenPart3 ? 'Hide Academic Feed' : 'Preview Academic Feed'}
>
  <FaRss />
</button>
<button
  onClick={(e) => {
    e.stopPropagation();
    openReasonEditor(currentFacetPart3);
  }}
  style={{
    background: 'none',
    border: 'none',
    borderRadius: '6px',
    color: '#ffaa00',
    cursor: 'pointer',
    fontSize: '20px',
    padding: '4px',
    lineHeight: 1,
  }}
  title={subjectReasons[currentFacetPart3] ? 'Edit your notes on this subject' : 'Add a note: why do you like this subject?'}
>
  <FaPenSquare />
</button>
  </div>
</div>
<p style={{
  margin: `0 0 ${spacing.base} 0`, wordWrap: "break-word",
  fontSize: fontSize.sm, color: color.textSecondary, lineHeight: 1.5,
  paddingBottom: spacing.sm, borderBottom: `1px solid ${color.border}`,
}}>
  {tooltipContentPart3.note}
</p>
        {tooltipContentPart3.options.length > 0 ? (
          <>
       <div style={{ display: 'flex', gap: '5px', marginBottom: '10px', flexWrap: 'wrap' }}>
  {['A-Levels', 'IB', 'AP', 'Supercurricular'].map((tab) => (   // ← removed 'AcadFeed'
    <TabButton
      key={tab}
      tab={tab}
      chartType="part3"           // ← the only difference!
      currentFacetUni={currentFacetUni}
      currentFacetPart3={currentFacetPart3}
      topScores={topScores}
      topPart3Scores={topPart3Scores}
      chosenTopSubject={chosenTopSubject}
      userEmail={userEmail}
      navigate={navigate}
      navigateWithViewMode={navigateWithViewMode} 
    openSuperMap={openSuperMap}   
    />
  ))}

       {/* AI Era Button - Same style as other tabs */}
          <a
href={getAISearchLink(currentFacetPart3)} 
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{
              padding: '5px 10px',
              backgroundColor: '#ffaa0002',
              color: 'white',
               border: '2px solid transparent',
    backgroundImage: 'linear-gradient(#1e1e2e, #1e1e2e), linear-gradient(90deg, rgb(0, 255, 183), rgb(0, 170, 255))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#ffaa0022';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ffaa0002';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            AI Era Relevance
          </a>
          
</div>
            <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
             {tooltipContentPart3.options
  .filter(opt => opt.name === activeTabPart3)
  .map((opt, optIdx) => {
    const link = getOptionLink(opt.name);
    return (
<div key={optIdx} className="dash-option-card">
          {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '14px', color: "#36a7f8", textDecoration: "underline", cursor: 'pointer' }}
          >
            <strong>{opt.name}</strong>
          </a>
        ) : (
          <strong>{opt.name}</strong>
        )}
        <div style={{ marginTop: '5px' }}>
          {opt.sub_options.map((sub, subIdx) => (
            <div key={subIdx} style={{ fontSize: '13px', marginBottom: '3px' }}>
              <span style={{ fontWeight: 'bold' }}>{sub.name}: </span>
              {sub.sub_sub_options.map((s, sIdx) => s.name).filter(Boolean).join(', ') || 'None'}
            </div>
          ))}
        </div>
      </div>
    );
  })}
            </div>
          </>
        ) : (
          <p style={{ margin: 0, fontStyle: 'italic' }}>No options available for this facet.</p>
        )}
      </>
    ) : tooltipLoadingPart3 ? (
      <p>Loading data...</p>
    ) : (
      <p>No data available.</p>
    )}
    {acadFeedOpenPart3 && (
  <div style={{ marginTop: '12px', borderTop: '1px solid rgba(255,170,0,0.3)', paddingTop: '10px' }}>
    <div className="acadfeed-panel"  style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', color: '#ffaa00', fontWeight: 600, fontSize: '0.88rem' }}>
      <FaRss /> Latest Articles
    </div>
    {renderAcadFeedPanel(currentFacetPart3)}
  </div>
)}
  </div>
)}
              </div>
            )}
          </div>
        )
      ) : (
        <div style={{ color: 'white', fontSize: '14px' }}>
          ⚠️ Note: You can only submit {assessmentName} Assessment once every 3 months.
        </div>
      )}
    </div>
    </div>
  );
};

const loadDocuments = async (deviceUrl) => {
  if (!deviceUrl) return;
  setDocsLoading(true);
  try {
    const res = await fetch(`${deviceUrl}/api/documents`);
    if (!res.ok) throw new Error("Failed to load documents");
    const data = await res.json();
    setDocuments(data);
  } catch (err) {
    console.warn("Could not load documents:", err);
    setDocuments([]);
  } finally {
    setDocsLoading(false);
  }
};

const toggleSilence = async (docId, currentlySilenced) => {
  try {
    const res = await fetch(
      `${knowledgeDeviceUrl}/api/documents/${docId}/silence?silenced=${!currentlySilenced}`,
      { method: "PATCH" }
    );
    if (!res.ok) throw new Error("Failed to update");
    await loadDocuments(knowledgeDeviceUrl);
  } catch (err) {
    showToast("Failed to update document: " + err.message, "error");
  }
};

const deleteDocument = async (docId, name) => {
  const ok = await confirm(
    `Permanently delete "${name}"? This cannot be undone.`,
    { title: "Delete document?", confirmLabel: "Delete", danger: true }
  );
  if (!ok) return;

  try {
    const res = await fetch(`${knowledgeDeviceUrl}/api/documents/${docId}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Failed to delete");
    await loadDocuments(knowledgeDeviceUrl);
  } catch (err) {
    showToast("Failed to delete document: " + err.message, "error");
  }
};

const findKnowledgeDevice = async () => {
  setIsScanning(true);
  setScanStatus("Searching for your Knowledge Device...");

  // 1. Candidates to try (in order of priority)
  const candidates = [];

  // Last known good address
  const lastKnown = localStorage.getItem("knowledge_device_url");
  if (lastKnown) candidates.push(lastKnown);

  // Common mDNS / friendly names
  candidates.push(
    "http://aspire-knowledge.local:8000",
    "http://knowledge.local:8000",
    "http://aspirebox.local:8000",
    "http://localhost:8000"
  );

  // Try to guess local network and scan a small range
  // (This is a best-effort scan of the most common home ranges)
  const commonPrefixes = ["192.168.1.", "192.168.0.", "192.168.68.", "10.0.0."];
  for (const prefix of commonPrefixes) {
    // Only scan a few likely IPs to keep it fast
    for (const host of [50, 100, 101, 102, 20, 30, 10, 2, 5]) {
      candidates.push(`http://${prefix}${host}:8000`);
    }
  }

  // Remove duplicates
  const uniqueCandidates = [...new Set(candidates)];

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 1800); // 1.8s per try

  for (const url of uniqueCandidates) {
    try {
      const res = await fetch(`${url}/`, {
        method: "GET",
        signal: controller.signal,
        mode: "cors",
      });

      if (res.ok) {
        const data = await res.json().catch(() => ({}));
        // Optional: check if it really is our service
        if (data?.message?.includes("Knowledge") || data?.status === "running" || res.ok) {
          clearTimeout(timeout);
          setKnowledgeDeviceUrl(url);
          await loadDocuments(url);
          localStorage.setItem("knowledge_device_url", url);
          setScanStatus(`Found device at ${url}`);
          setIsScanning(false);
          return;
        }
      }
    } catch (err) {
      // ignore – just try next
    }
  }

  clearTimeout(timeout);
  setScanStatus("No device found. Make sure it is on the same Wi-Fi and the backend is running.");
  setIsScanning(false);
};

const handleConfirmSubjectChoice = async () => {
  if (!selectedSubject) return;
  if (!isSubjectChoiceAllowed()) {
   showToast(
  `You can only change your top subject once every 3 months. Next available after ${formatDate(
    new Date(new Date(lastSubjectChoiceDate).getTime() + 3 * 30 * 24 * 60 * 60 * 1000)
  )}.`,
  "error", 5000
);
    return;
  }
  try {
    await axios.post(
      `/api/users/choose-top-subject/${effectiveUserId}`,
      { subject: selectedSubject },
      { headers: getAuthHeaders() }
    );
    setLastSubjectChoiceDate(new Date().toISOString());
    await saveChosenTopSubject(effectiveUserId, selectedSubject);
    setChosenTopSubject(selectedSubject);

    invalidateAccountCache();

      setShowChooseSubjectModal(false);
    setSelectedSubject('');

    if (pendingSubjectDestination) {
      const { path, state } = pendingSubjectDestination;
      const subjectKey = path === '/dashboard_enrich' ? 'preselectedSuperSubject' : 'preselectedSubject';
      setPendingSubjectDestination(null);
      navigateWithViewMode(path, {
        ...state,
        [subjectKey]: selectedSubject,
        chosenTopSubject: selectedSubject,
      });
      return; // skip the generic toast — we're navigating away
    }

    showToast('Top subject updated successfully!', "success");
  } catch (err) {
    console.error('Error updating top subject:', err);
    showToast('Failed to update top subject.', "error");
  }
};

useEffect(() => {
  if (!effectiveUserId) return;
  ensureFacetNoteCacheFreshness(effectiveUserId).catch(() => {});
}, [effectiveUserId]);

useEffect(() => {
  // Register service worker if supported
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
}, []);

    useEffect(() => {
      document.body.classList.add('specific-page-uniready');
      return () => document.body.classList.remove('specific-page-uniready');
    });


return (
  <div className="dashboard-wrapper">
     <div className="rotate-overlay">
      <FaSyncAlt size={40} style={{ marginBottom: 16 }} />
      <h3>Please rotate your device</h3>
      <p>This experience works best in portrait mode.</p>
    </div>
{showManageModal && (
  <div
    className="modal"
    onClick={(e) => { if (e.target === e.currentTarget) setShowManageModal(false); }}
    style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "20px",
    }}
  >
    <div  className="new-manage-account-modal" style={{
      position: "relative", background: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
      border: "1px solid rgba(2,139,232,0.35)", borderRadius: "16px", color: "white",
      width: "460px", maxWidth: "94vw", maxHeight: "88vh", display: "flex", flexDirection: "column",
      boxShadow: "0 20px 60px rgba(0,0,0,0.6)", overflow: "hidden",
    }}>
      <button
        onClick={() => { setShowManageModal(false); setModalAction(null); }}
        style={{ position: "absolute", top: "14px", right: "16px", background: "none", border: "none", color: "#aaa", fontSize: "1.5rem", cursor: "pointer", zIndex: 1 }}
        aria-label="Close"
      >
        ×
      </button>

      {/* ── HEADER ── */}
      <div style={{ padding: "26px 26px 18px 26px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        {modalAction && (
          <button
            onClick={() => {
              setModalAction(null);
              setPassword(""); setNewEmail(""); setNewUsername(""); setNewWhitelistEmail("");
              setPasswordError(null); setActionError(null); setUsernameError(null); setWhitelistError(null);
            }}
            style={{
              display: "inline-flex", alignItems: "center", gap: "6px", background: "none", border: "none",
              color: "#36a7f8", fontSize: "13px", cursor: "pointer", padding: 0, marginBottom: "12px",
            }}
          >
            ← Back
          </button>
        )}
      
        <h2 style={{ margin: "0 0 4px 0", fontSize: "1.3rem" }}>
          {!modalAction ? "Manage Account"
            : modalAction === "email" ? "Change Email Address"
            : modalAction === "username" ? "Change Username"
            : modalAction === "whitelist" ? "Invite a Friend"
            : modalAction === "download" ? "Download Your Data"
            : "Delete This Account"}
        </h2>
        <p style={{ margin: 0, fontSize: "12.5px", color: "#888" }}>
          {!modalAction
            ? (loadingUsername ? "Loading…" : userUsername ? `Signed in as ${userUsername}` : "Unable to load username")
            : "Confirm with your password to continue."}
        </p>
      </div>

      {/* ── BODY ── */}
      <div style={{ padding: "20px 26px", overflowY: "auto", flex: 1 }}>
        {userUsername === null && !loadingUsername && !modalAction && (
          <p style={{ color: "#ff8080", fontSize: "12.5px", margin: "0 0 16px 0" }}>
            Failed to load username. Please try again later.
          </p>
        )}

        {!modalAction ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
            {/* Profile */}
            <div>
              <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>
                Profile
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <TooltipUI text={!isAdmin && !isActionAllowed("username") ? `Restricted to one change per month. Last changed on ${formatDate(lastUsernameChangeDate)}.` : ""}>
                  <AccountMenuRow
                    icon={<FaUser />}
                    title="Change Username"
                    subtitle={userUsername || undefined}
                    onClick={() => setModalAction("username")}
                    disabled={!isAdmin && !isActionAllowed("username")}
                  />
                </TooltipUI>

                <TooltipUI text={!isAdmin && !isActionAllowed("email") ? `Restricted to one change per month. Last registered on ${formatDate(lastEmailChangeDate)}.` : ""}>
                  <AccountMenuRow
                    icon={<FaEnvelope />}
                    title="Change Email Address"
                    subtitle={userEmail !== "User" ? userEmail : undefined}
                    onClick={() => setModalAction("email")}
                    disabled={!isAdmin && !isActionAllowed("email")}
                  />
                </TooltipUI>

                              {!isParentView && (
                  <AccountMenuRow
                    icon={<FaImage />}
                    title="Change Avatar"
                    subtitle="Customise your profile picture"
                    onClick={() => { setShowManageModal(false); setShowAvatarModal(true); }}
                  />
                )}
              </div>
            </div>

            {/* Community */}
            {!isParentView && !isAdmin && (
              <div>
                <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>
                  Community
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <AccountMenuRow
                    icon={<FaUserFriends />}
                    title="Manage Connections"
                    subtitle="Parents and mentors linked to your profile"
                    onClick={() => { setShowManageModal(false); setShowConnectionsModal(true); fetchConnections(); }}
                  />
                  <AccountMenuRow
                    icon={<FaUserFriends />}
                    title="Invite a Friend"
                    subtitle={inviteCredits !== null ? `${inviteCredits} invite${inviteCredits === 1 ? "" : "s"} remaining` : undefined}
                    onClick={openInviteModal}
                  />
                </div>
              </div>
            )}

            {/* Data */}
            <div>
              <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>
                Your Data
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <TooltipUI text={!isAdmin && !isActionAllowed("download") ? `Restricted to one download per month. Last downloaded on ${formatDate(lastDataDownloadDate)}.` : ""}>
                <AccountMenuRow
                  icon={<FaDownload />}
                  title="Download Your Data"
                  subtitle="Export a copy of your account data"
                  onClick={() => setModalAction("download")}
                  disabled={!isAdmin && !isActionAllowed("download")}
                />
              </TooltipUI>
            </div>
            </div>

            {/* Danger zone */}
            <div>
              <div style={{ fontSize: "11px", fontWeight: 700, color: "#ff8080", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>
                Danger Zone
              </div>
              <AccountMenuRow
                icon={<FaTrash />}
                title="Delete This Account"
                subtitle="This is permanent and cannot be undone"
                onClick={() => setModalAction("delete")}
                danger
              />
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {modalAction === "email" && (
              <div>
                <label style={{ display: "block", fontSize: "12.5px", color: "#ccc", marginBottom: "6px" }}>New Email Address</label>
                <input
                  type="email"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder="Enter new email address"
                  style={inputStyle}
                />
              </div>
            )}

            {modalAction === "username" && (
              <div>
                <label style={{ display: "block", fontSize: "12.5px", color: "#ccc", marginBottom: "6px" }}>New Username</label>
                <input
                  type="text"
                  value={newUsername}
                  onChange={(e) => {
                    setNewUsername(e.target.value);
                    setUsernameError(e.target.value.length < 3 || e.target.value.length > 50 ? "Username must be between 3 and 50 characters." : null);
                  }}
                  placeholder="Enter new username"
                  style={inputStyle}
                />
                {usernameError && <p style={{ color: "#ff8080", fontSize: "12px", margin: "6px 0 0 0" }}>{usernameError}</p>}
              </div>
            )}

            {modalAction === "whitelist" && (
              <div>
                <label style={{ display: "block", fontSize: "12.5px", color: "#ccc", marginBottom: "6px" }}>Friend's Email</label>
                <input
                  type="email"
                  value={newWhitelistEmail}
                  onChange={(e) => {
                    const input = e.target.value;
                    setNewWhitelistEmail(input);
                    setWhitelistError(input && !sanitizeEmail(input) ? "Invalid email format." : null);
                  }}
                  placeholder="Enter email"
                  style={inputStyle}
                />
                <p style={{ margin: "10px 0 0 0", fontSize: "12.5px", color: "#888" }}>
                  Invites remaining:{" "}
                  <strong style={{ color: inviteCredits === null ? "#888" : inviteCredits <= 0 ? "#ff6666" : "#4ade80" }}>
                    {inviteCredits === null ? "…" : inviteCredits}
                  </strong>
                  {isAdmin && <span style={{ color: "#666", fontSize: "11px", marginLeft: "6px" }}>(Admin: unlimited)</span>}
                </p>
                {whitelistError && <p style={{ color: "#ff8080", fontSize: "12px", margin: "6px 0 0 0" }}>{whitelistError}</p>}
              </div>
            )}

            {modalAction === "download" && (
              <p style={{ color: "#ccc", fontSize: "13.5px", lineHeight: 1.5, margin: 0 }}>
                This will export a copy of your account data as a CSV file. You can do this once per month.
              </p>
            )}

            {modalAction === "delete" && (
              <div style={{
                display: "flex", gap: "10px", alignItems: "flex-start",
                background: "rgba(255,102,102,0.08)", border: "1px solid rgba(255,102,102,0.3)",
                borderRadius: "8px", padding: "12px 14px",
              }}>
                <FaInfoCircle style={{ color: "#ff6666", fontSize: "14px", marginTop: "2px", flexShrink: 0 }} />
                <p style={{ margin: 0, color: "#ffb3b3", fontSize: "12.5px", lineHeight: 1.5 }}>
                  Deleting your account is irreversible and will remove all your data. This cannot be undone.
                </p>
              </div>
            )}

            <div>
              <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12.5px", color: "#ccc", marginBottom: "6px" }}>
                <FaLock style={{ fontSize: "11px", color: "#888" }} /> Account Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                style={inputStyle}
              />
              {passwordError && <p style={{ color: "#ff8080", fontSize: "12px", margin: "6px 0 0 0" }}>{passwordError}</p>}
            </div>

            {actionError && <p style={{ color: "#ff8080", fontSize: "12.5px", margin: 0 }}>{actionError}</p>}
          </div>
        )}
      </div>

      {/* ── FOOTER ── */}
      {modalAction && (
        <div style={{ padding: "18px 26px 26px 26px", borderTop: "1px solid rgba(255,255,255,0.08)", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button
            onClick={() => {
              setModalAction(null);
              setPassword(""); setNewEmail(""); setNewUsername(""); setNewWhitelistEmail("");
              setPasswordError(null); setActionError(null); setUsernameError(null); setWhitelistError(null);
            }}
            style={{ padding: "10px 20px", background: "none", border: "1px solid rgba(255,255,255,0.2)", color: "#ccc", borderRadius: "8px", cursor: "pointer", fontSize: "14px" }}
          >
            Cancel
          </button>
          <button
            onClick={() =>
              modalAction === "whitelist" ? handleAddWhitelistEmail()
              : modalAction === "username" ? handleChangeUsername()
              : initiateAction(modalAction)
            }
            disabled={modalAction === "username" && (newUsername.length < 3 || newUsername.length > 50 || usernameError)}
            style={{
              padding: "10px 24px",
              background: modalAction === "delete" ? "#ff4d4d" : "#028be8",
              color: "white", border: "none", borderRadius: "8px", fontWeight: 600,
              fontSize: "14px", cursor: "pointer",
              opacity: (modalAction === "username" && (newUsername.length < 3 || newUsername.length > 50 || usernameError)) ? 0.5 : 1,
            }}
          >
            {modalAction === "delete" ? "Delete Account" : "Proceed"}
          </button>
        </div>
      )}
    </div>
  </div>
)}

{/* ── Local Knowledge Device Upload Modal ── */}
{showKnowledgeUploadModal && (
  <div
    className="modal"
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1300,
    }}
  >
    <div
      style={{
        background: "#0f1629",
        padding: "28px",
        borderRadius: "14px",
        width: "820px",
        maxWidth: "95%",
        minHeight: "90vh",
        overflowY: "auto",
        color: "white",
        position: "relative",
        border: "1px solid rgba(54,167,248,0.35)",
        boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
      }}
    >
      <button
        onClick={() => setShowKnowledgeUploadModal(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "14px",
          background: "none",
          border: "none",
          color: "#aaa",
          fontSize: "28px",
          cursor: "pointer",
        }}
      >
        ×
      </button>



<h2 style={{ margin: "0 0 8px", color: "#36a7f8", textAlign: "center", marginBottom: "30px" }}>
        AspireAI Device Manager
      </h2>
      <p style={{ color: "#828282", textAlign: "center", marginBottom: "18px", fontSize: "0.85rem" }}>
      </p>

      {/* ===== Tabs ===== */}
       <div style={{ display: "flex", gap: "8px", marginBottom: "22px", justifyContent: "center", flexWrap: "wrap" }}>
        {[
{ key: 'sync', label: 'Sync Intelligence' },
{ key: 'materials', label: 'Add Knowledge' },
{ key: 'runtime', label: 'Update Personalisation' },
{ key: 'backup', label: 'Backup & Restore' },
        ].map((t) => (
          <button
            key={t.key}
            onClick={() => setUploadModalTab(t.key)}
            style={{
              padding: '8px 16px',
              borderRadius: '999px',
              border: '1px solid #36a7f834',
              background: uploadModalTab === t.key ? '#36a7f8' : 'transparent',
              color: uploadModalTab === t.key ? '#0b1021' : '#36a7f8',
              fontWeight: 600,
              fontSize: '0.85rem',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* ===== Device Address (shared by both tabs) ===== */}
      <div style={{ marginBottom: "18px" }}>
        <label style={{ display: "block", marginBottom: "6px", fontWeight: "200", fontSize: '16px', color: "#b0b0b0" }}>
          Device Address
        </label>
        <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
          <input
            type="text"
            value={knowledgeDeviceUrl}
            onChange={(e) => {
              setKnowledgeDeviceUrl(e.target.value);
              localStorage.setItem("knowledge_device_url", e.target.value);
            }}
            placeholder="Will try to find automatically..."
            style={{
              flex: 1, padding: "10px 12px", background: "#1a1a2e",
              border: "1px solid #444", borderRadius: "8px", color: "white", fontSize: "0.95rem",
            }}
          />
          <button
            onClick={findKnowledgeDevice}
            disabled={isScanning}
            style={{
              padding: "0 16px", background: isScanning ? "#555" : "#028be8",
              color: "white", border: "none", borderRadius: "8px", fontWeight: 600,
              cursor: isScanning ? "not-allowed" : "pointer", whiteSpace: "nowrap",
            }}
          >
            {isScanning ? "Scanning..." : "Find Device"}
          </button>
        </div>
        {scanStatus && (
          <p style={{ margin: "6px 0 0", fontSize: "0.88rem", color: scanStatus.startsWith("Found") ? "#4ade80" : "#fbbf24" }}>
            {scanStatus}
          </p>
        )}
      </div>

      {/* ===== Upload Materials tab ===== */}
      {uploadModalTab === 'materials' && (
        <>
          <KnowledgeUploadForm
            deviceUrl={knowledgeDeviceUrl}
            onUploadSuccess={() => loadDocuments(knowledgeDeviceUrl)}
          />

          <div style={{ marginTop: "28px", borderTop: "1px solid #333", paddingTop: "20px" }}>
            <h3 style={{ margin: "0 0 14px", color: "#e0f2fe", fontSize: "1.1rem" }}>
              Your Materials
            </h3>

            {docsLoading ? (
              <p style={{ color: "#888" }}>Loading documents...</p>
            ) : documents.length === 0 ? (
              <p style={{ color: "#666", fontStyle: "italic" }}>No documents uploaded yet.</p>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {documents.map((doc) => (
                  <div
                    key={doc.id}
                    style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      padding: "12px 14px",
                      background: doc.silenced ? "rgba(100,100,100,0.15)" : "rgba(54,167,248,0.08)",
                      border: `1px solid ${doc.silenced ? "#555" : "rgba(54,167,248,0.3)"}`,
                      borderRadius: "10px", gap: "12px",
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{
                        fontWeight: 600, color: doc.silenced ? "#999" : "#e0f7ff",
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                      }}>
                        {doc.original_name}
                      </div>
                      <div style={{ fontSize: "0.82rem", color: "#888", marginTop: "3px" }}>
                        {doc.subject} · {doc.level} · {doc.silenced ? "Silenced" : "Active"}
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
                      <button
                        onClick={() => toggleSilence(doc.id, !!doc.silenced)}
                        style={{
                          padding: "6px 12px",
                          background: doc.silenced ? "rgba(74,222,128,0.15)" : "rgba(251,191,36,0.15)",
                          border: `1px solid ${doc.silenced ? "#4ade80" : "#fbbf24"}`,
                          borderRadius: "6px", color: doc.silenced ? "#4ade80" : "#fbbf24",
                          fontSize: "0.82rem", fontWeight: 600, cursor: "pointer",
                        }}
                      >
                        {doc.silenced ? "Activate" : "Silence"}
                      </button>
                      <button
                        onClick={() => deleteDocument(doc.id, doc.original_name)}
                        style={{
                          padding: "6px 12px", background: "rgba(248,113,113,0.15)",
                          border: "1px solid #f87171", borderRadius: "6px", color: "#f87171",
                          fontSize: "0.82rem", fontWeight: 600, cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}

      {/* ===== Sync Intelligence Data tab ===== */}
      {uploadModalTab === 'sync' && (
        <div>
          <p style={{ color: "#9e9e9e", fontSize: "0.9rem", lineHeight: 1.5, marginBottom: "18px" }}>
            Sync your scores, notes, reflections, and journals to your device so AspireAI can give advice based on your history. Your data stays on your device and never leaves your network.
          </p>

          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "12px 14px", background: "rgba(54,167,248,0.08)",
            border: "1px solid rgba(54,167,248,0.25)", borderRadius: "10px", marginBottom: "16px",
          }}>
            <div>
              <div style={{ fontSize: "0.8rem", color: "#888" }}>Last synced</div>
              <div style={{ fontWeight: 600, color: "#e0f7ff" }}>{formatSyncDate(lastSyncDate)}</div>
            </div>
            {lastSyncDate && (
              <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "0.82rem", color: "#aaa", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={syncMode === 'full'}
                  onChange={(e) => setSyncMode(e.target.checked ? 'full' : 'incremental')}
                  disabled={isSyncingIntelligence}
                />
                Full re-sync
              </label>
            )}
          </div>

          <button
            onClick={handleSyncEducationIntelligence}
            disabled={isSyncingIntelligence || !knowledgeDeviceUrl}
            style={{
              width: "100%", padding: "13px",
              background: isSyncingIntelligence || !knowledgeDeviceUrl ? "#555" : "#028be8",
              color: "white", border: "none", borderRadius: "10px", fontWeight: 700,
              fontSize: "0.98rem",
              cursor: isSyncingIntelligence || !knowledgeDeviceUrl ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
            }}
          >
            {isSyncingIntelligence ? (syncStage || "Syncing…") : (syncMode === 'full' ? "Sync All Data" : "Sync New Data")}
          </button>

          {!knowledgeDeviceUrl && (
            <p style={{ margin: "8px 0 0", fontSize: "0.82rem", color: "#fbbf24" }}>
              Set your device address above first.
            </p>
          )}

          {syncError && (
            <div style={{
              marginTop: "14px", padding: "12px 14px", background: "rgba(248,113,113,0.1)",
              border: "1px solid #f87171", borderRadius: "8px", color: "#f87171", fontSize: "0.88rem",
            }}>
              {syncError}
            </div>
          )}

          {syncResult && !syncError && (
            <div style={{
              marginTop: "14px", padding: "12px 14px", background: "rgba(74,222,128,0.1)",
              border: "1px solid #4ade80", borderRadius: "8px", color: "#4ade80", fontSize: "0.88rem",
            }}>
              {syncResult.nothingNew
                ? "You're already up to date — nothing new to sync."
                : `Synced ${syncResult.recordCount} records across ${syncResult.sectionCount} categories.`}
            </div>
          )}
        </div>
      )}

{uploadModalTab === 'runtime' && (
  <div>
    <p style={{ color: "#9e9e9e", fontSize: "0.9rem", lineHeight: 1.5, marginBottom: "18px" }}>
      The Personalised Intelligence Runtime turns your interactions into a learner model. Keep it updated for the latest personalisation and pattern recognition improvements.
    </p>

    {/* Current version card */}
    <div style={{
      padding: "14px 16px", background: "rgba(54,167,248,0.06)",
      border: "1px solid rgba(54,167,248,0.2)", borderRadius: "10px", marginBottom: "16px",
    }}>
      {runtimeInfoLoading ? (
        <p style={{ color: "#888", margin: 0, fontSize: "0.88rem" }}>Checking installed version…</p>
      ) : runtimeInfoError ? (
        <p style={{ color: "#fbbf24", margin: 0, fontSize: "0.85rem" }}>{runtimeInfoError}</p>
      ) : runtimeInfo ? (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
          <div>
            <div style={{ fontSize: "0.8rem", color: "#888" }}>Installed runtime</div>
            <div style={{ fontWeight: 700, color: "#e0f7ff", fontSize: "1.05rem" }}>
              v{runtimeInfo.runtime_version}
            </div>
            <div style={{ fontSize: "0.78rem", color: "#777", marginTop: "2px" }}>
              Algorithm {runtimeInfo.algorithm_version} · Schema {runtimeInfo.schema_version}
            </div>
          </div>
          {updateCheck.status === 'up_to_date' && (
            <span style={{
              display: "inline-flex", alignItems: "center", gap: "6px",
              padding: "5px 12px", background: "rgba(74,222,128,0.12)",
              border: "1px solid rgba(74,222,128,0.35)", borderRadius: "999px",
              color: "#4ade80", fontSize: "0.8rem", fontWeight: 600,
            }}>
              ✓ Up to date
            </span>
          )}
        </div>
      ) : (
        <p style={{ color: "#888", margin: 0, fontSize: "0.85rem" }}>
          Set your device address above, then check for updates.
        </p>
      )}
    </div>

    {updateInstall.status === 'idle' && (
      <>
        {updateCheck.status !== 'available' && (
          <button
            onClick={handleCheckForUpdates}
            disabled={updateCheck.status === 'checking' || !knowledgeDeviceUrl}
            style={{
              width: "100%", padding: "12px",
              background: updateCheck.status === 'checking' || !knowledgeDeviceUrl ? "#444" : "#028be8",
              color: "white", border: "none", borderRadius: "8px", fontWeight: 600,
              fontSize: "0.92rem",
              cursor: updateCheck.status === 'checking' || !knowledgeDeviceUrl ? "not-allowed" : "pointer",
            }}
          >
            {updateCheck.status === 'checking' ? 'Checking…' : 'Check for Updates'}
          </button>
        )}

        {!knowledgeDeviceUrl && (
          <p style={{ margin: "8px 0 0", fontSize: "0.82rem", color: "#fbbf24" }}>
            Set your device address above first.
          </p>
        )}

        {updateCheck.status === 'error' && (
          <div style={{
            marginTop: "12px", padding: "10px 14px", borderRadius: "8px", fontSize: "0.85rem",
            background: "rgba(248,113,113,0.1)", border: "1px solid #f87171", color: "#f87171",
          }}>
            {updateCheck.error}
          </div>
        )}

        {/* Update available card */}
        {updateCheck.status === 'available' && updateCheck.data && (
          <div style={{
            marginTop: "4px", padding: "16px", borderRadius: "12px",
            background: "rgba(255,170,0,0.08)", border: "1px solid rgba(255,170,0,0.35)",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
              <span style={{
                padding: "3px 10px", background: "#ffaa00", color: "#1a1a1a",
                borderRadius: "999px", fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.02em",
              }}>
                UPDATE AVAILABLE
              </span>
              <span style={{ color: "#ffaa00", fontWeight: 700 }}>
                v{runtimeInfo?.runtime_version} → v{updateCheck.data.latest_version}
              </span>
            </div>

            {updateCheck.data.release_notes && (
              <p style={{ color: "#ddd", fontSize: "0.87rem", lineHeight: 1.5, margin: "0 0 10px" }}>
                {updateCheck.data.release_notes}
              </p>
            )}

            {updateCheck.data.size_mb && (
              <p style={{ color: "#999", fontSize: "0.8rem", margin: "0 0 10px" }}>
                Download size: {updateCheck.data.size_mb} MB
              </p>
            )}

            <p style={{ color: "#999", fontSize: "0.8rem", margin: "0 0 14px" }}>
              Keep your device powered on and connected while it updates.
            </p>

            <button
              onClick={handleInstallUpdate}
              style={{
                width: "100%", padding: "13px", background: "#ffaa00", color: "#1a1a1a",
                border: "none", borderRadius: "8px", fontWeight: 700, fontSize: "0.95rem", cursor: "pointer",
              }}
            >
              Update Now
            </button>
          </div>
        )}
      </>
    )}

    {/* In-progress / done / error install states */}
    {updateInstall.status !== 'idle' && (
      <div style={{
        padding: "18px", borderRadius: "12px",
        background: updateInstall.status === 'error' ? "rgba(248,113,113,0.08)" : "rgba(54,167,248,0.06)",
        border: `1px solid ${updateInstall.status === 'error' ? "#f87171" : "rgba(54,167,248,0.25)"}`,
      }}>
        {updateInstall.status === 'error' ? (
          <>
            <p style={{ color: "#f87171", fontWeight: 600, margin: "0 0 6px" }}>Update failed</p>
            <p style={{ color: "#ddd", fontSize: "0.85rem", margin: "0 0 14px" }}>{updateInstall.error}</p>
            <button
              onClick={() => setUpdateInstall({ status: 'idle', progress: 0, stage: '', error: null })}
              style={{ padding: "9px 18px", background: "#444", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "0.88rem" }}
            >
              Dismiss
            </button>
          </>
        ) : updateInstall.status === 'done' ? (
          <>
            <p style={{ color: "#4ade80", fontWeight: 700, margin: "0 0 6px" }}>
              ✓ Updated to v{runtimeInfo?.runtime_version}
            </p>
            <p style={{ color: "#ccc", fontSize: "0.85rem", margin: 0 }}>
              Your AI companion is running the latest runtime.
            </p>
          </>
        ) : (
          <>
            <p style={{ color: "#e0f7ff", fontWeight: 600, margin: "0 0 10px", fontSize: "0.92rem" }}>
              {updateInstall.stage || ({
                downloading: 'Downloading update…',
                verifying: 'Verifying signature…',
                installing: 'Installing…',
              }[updateInstall.status] || 'Updating…')}
            </p>
            <div style={{ width: "100%", height: "8px", background: "#1a1a2e", borderRadius: "999px", overflow: "hidden" }}>
              <div style={{
                width: `${Math.max(4, updateInstall.progress)}%`, height: "100%",
                background: "linear-gradient(90deg, #028be8, #00e1ff)",
                borderRadius: "999px", transition: "width 0.4s ease",
              }} />
            </div>
            <p style={{ color: "#888", fontSize: "0.78rem", margin: "8px 0 0" }}>
              Please keep this device powered on and connected.
            </p>
          </>
        )}
      </div>
    )}
  </div>
)}

{/* ===== Backup & Restore tab ===== */}
      {uploadModalTab === 'backup' && (
        <div>
          <p style={{ color: "#9e9e9e", fontSize: "0.9rem", lineHeight: 1.5, marginBottom: "18px" }}>
            A secure local backup of your notes, journals, feed comments, and scores on your AspireAI device, keeping your data recoverable even if your browser data is cleared.
          </p>

          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "12px 14px", background: "rgba(54,167,248,0.06)",
            border: "1px solid rgba(54,167,248,0.2)", borderRadius: "10px", marginBottom: "16px",
          }}>
            <div>
              <div style={{ fontSize: "0.8rem", color: "#888" }}>Last backup</div>
              <div style={{ fontWeight: 600, color: "#e0f7ff" }}>{formatSyncDate(lastBackupDate)}</div>
            </div>
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={handleBackupToDevice}
              disabled={backupState.status === 'working' || !knowledgeDeviceUrl}
              style={{
                flex: 1, padding: "12px",
                background: backupState.status === 'working' || !knowledgeDeviceUrl ? "#444" : "#028be8",
                color: "white", border: "none", borderRadius: "8px", fontWeight: 600,
                fontSize: "0.9rem",
                cursor: backupState.status === 'working' || !knowledgeDeviceUrl ? "not-allowed" : "pointer",
              }}
            >
              {backupState.status === 'working' ? (backupState.message || 'Backing up…') : 'Backup Now'}
            </button>

            <button
              onClick={() => setShowRestoreConfirm(true)}
              disabled={restoreState.status === 'working' || !knowledgeDeviceUrl}
              style={{
                flex: 1, padding: "12px", background: "transparent",
                color: restoreState.status === 'working' || !knowledgeDeviceUrl ? "#666" : "#ffaa00",
                border: `1px solid ${restoreState.status === 'working' || !knowledgeDeviceUrl ? "#555" : "#ffaa00"}`,
                borderRadius: "8px", fontWeight: 600, fontSize: "0.9rem",
                cursor: restoreState.status === 'working' || !knowledgeDeviceUrl ? "not-allowed" : "pointer",
              }}
            >
              {restoreState.status === 'working' ? (restoreState.message || 'Restoring…') : 'Restore from Device'}
            </button>
          </div>

          {!knowledgeDeviceUrl && (
            <p style={{ margin: "8px 0 0", fontSize: "0.82rem", color: "#fbbf24" }}>
              Set your device address above first.
            </p>
          )}

          {backupState.status !== 'idle' && backupState.status !== 'working' && (
            <div style={{
              marginTop: "12px", padding: "10px 14px", borderRadius: "8px", fontSize: "0.85rem",
              background: backupState.status === 'error' ? "rgba(248,113,113,0.1)" : "rgba(74,222,128,0.1)",
              border: `1px solid ${backupState.status === 'error' ? "#f87171" : "#4ade80"}`,
              color: backupState.status === 'error' ? "#f87171" : "#4ade80",
            }}>
              {backupState.message}
            </div>
          )}

          {restoreState.status !== 'idle' && restoreState.status !== 'working' && (
            <div style={{
              marginTop: "12px", padding: "10px 14px", borderRadius: "8px", fontSize: "0.85rem",
              background: restoreState.status === 'error' ? "rgba(248,113,113,0.1)" : "rgba(74,222,128,0.1)",
              border: `1px solid ${restoreState.status === 'error' ? "#f87171" : "#4ade80"}`,
              color: restoreState.status === 'error' ? "#f87171" : "#4ade80",
            }}>
              {restoreState.message}
            </div>
          )}
        </div>
      )}

        {/* ── Restore confirmation now lives HERE, nested in the same modal ── */}
      {showRestoreConfirm && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1301, // one above the device manager modal it belongs to
          }}
        >
          <div style={{ background: "#1a1a1a", padding: "26px", borderRadius: "12px", color: "white", width: "420px", maxWidth: "90%", border: "1px solid rgba(255,170,0,0.3)" }}>
            <h3 style={{ margin: "0 0 12px", color: "#ffaa00" }}>Restore from device?</h3>
            <p style={{ color: "#ccc", fontSize: "0.92rem", lineHeight: 1.5, marginBottom: "22px" }}>
              This will overwrite your current notes, journals, feed comments, and scores in this
              browser with the backup stored on your device. This can't be undone.
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                onClick={() => setShowRestoreConfirm(false)}
                style={{ padding: "10px 18px", background: "#444", color: "white", border: "none", borderRadius: "8px", cursor: "pointer" }}
              >
                Cancel
              </button>
              <button
                onClick={handleRestoreFromDevice}
                style={{ padding: "10px 18px", background: "#ffaa00", color: "#1a1a1a", border: "none", borderRadius: "8px", fontWeight: 700, cursor: "pointer" }}
              >
                Yes, Restore
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
)}

{showConfirmModal && (
  <div
    className="modal"
    onClick={(e) => { if (e.target === e.currentTarget) setShowConfirmModal(false); }}
    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: "20px" }}
  >
    <div style={{
      background: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
      border: `1px solid ${pendingAction === "delete" ? "rgba(255,102,102,0.4)" : "rgba(2,139,232,0.35)"}`,
      borderRadius: "16px", color: "white", width: "420px", maxWidth: "92vw", padding: "28px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
    }}>
      <h3 style={{ margin: "0 0 12px 0", color: pendingAction === "delete" ? "#ff6666" : "#36a7f8", fontSize: "1.15rem" }}>
        {pendingAction === "delete" ? "Delete your account?" : "Please confirm"}
      </h3>
      <p style={{ color: "#ccc", fontSize: "14px", lineHeight: 1.55, margin: "0 0 22px 0" }}>
        {confirmMessage}
      </p>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <button
          onClick={() => setShowConfirmModal(false)}
          style={{ padding: "10px 18px", background: "none", border: "1px solid rgba(255,255,255,0.2)", color: "#ccc", borderRadius: "8px", cursor: "pointer", fontSize: "14px" }}
        >
          Cancel
        </button>
        <button
          onClick={confirmAction}
          style={{
            padding: "10px 22px", background: pendingAction === "delete" ? "#ff4d4d" : "#028be8",
            color: "white", border: "none", borderRadius: "8px", fontWeight: 600, cursor: "pointer", fontSize: "14px",
          }}
        >
          {pendingAction === "delete" ? "Yes, Delete" : "Confirm"}
        </button>
      </div>
    </div>
  </div>
)}

{showVerificationModal && (
  <div
    className="modal"
    onClick={(e) => { if (e.target === e.currentTarget) setShowVerificationModal(false); }}
    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: "20px" }}
  >
    <div style={{
      background: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
      border: "1px solid rgba(2,139,232,0.35)", borderRadius: "16px", color: "white",
      width: "420px", maxWidth: "92vw", padding: "30px", textAlign: "center",
      boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
    }}>
      <div style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        width: "48px", height: "48px", borderRadius: "50%", background: "rgba(2,139,232,0.15)", marginBottom: "16px",
      }}>
        <FaEnvelope style={{ color: "#36a7f8", fontSize: "20px" }} />
      </div>
      <h2 style={{ margin: "0 0 10px 0", fontSize: "1.2rem" }}>Check Your Email</h2>
      <p style={{ color: "#ccc", fontSize: "14px", lineHeight: 1.55, margin: "0 0 24px 0" }}>
        A verification link has been sent to <strong style={{ color: "#fff" }}>{newEmail}</strong>.
        Click the link in that email to confirm your new address.
      </p>
      <button
        onClick={() => setShowVerificationModal(false)}
        style={{ width: "100%", padding: "11px", background: "#028be8", color: "white", border: "none", borderRadius: "8px", fontWeight: 600, cursor: "pointer", fontSize: "14px" }}
      >
        Got it
      </button>
    </div>
  </div>
)}


{showConnectionsModal && (
  <div
    className="modal"
    onClick={(e) => { if (e.target === e.currentTarget) setShowConnectionsModal(false); }}
    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200, padding: "20px" }}
  >
    <div style={{
      position: "relative", background: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
      border: "1px solid rgba(2,139,232,0.35)", borderRadius: "16px", color: "white",
      width: "480px", maxWidth: "94vw", maxHeight: "86vh", display: "flex", flexDirection: "column",
      boxShadow: "0 20px 60px rgba(0,0,0,0.6)", overflow: "hidden",
    }}>
       <button
        onClick={() => setShowConnectionsModal(false)}
        style={{ position: "absolute", top: "14px", right: "16px", background: "none", border: "none", color: "#aaa", fontSize: "1.5rem", cursor: "pointer" }}
      >
        ×
      </button>

      <div style={{ padding: "26px 26px 18px 26px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <button
          onClick={() => { setShowConnectionsModal(false); setShowManageModal(true); }}
          style={{
            display: "inline-flex", alignItems: "center", gap: "6px", background: "none", border: "none",
            color: "#36a7f8", fontSize: "13px", cursor: "pointer", padding: 0, marginBottom: "12px",
          }}
        >
          ← Back
        </button>
        <h2 style={{ margin: "0 0 4px 0", fontSize: "1.3rem" }}>Manage Connections</h2>
        <p style={{ margin: 0, color: "#888", fontSize: "12.5px" }}>Parents and mentors connected to your profile</p>
      </div>
      <div style={{ padding: "18px 26px", overflowY: "auto", flex: 1 }}>
        {connectionsLoading && <p style={{ textAlign: "center", color: "#888", fontSize: "13.5px" }}>Loading…</p>}
        {connectionsError && <p style={{ textAlign: "center", color: "#ff8080", fontSize: "13.5px" }}>{connectionsError}</p>}

        {!connectionsLoading && !connectionsError && connections.length === 0 && (
          <p style={{ textAlign: "center", color: "#666", fontStyle: "italic", fontSize: "13.5px", padding: "20px 0" }}>
            No active connections or pending invitations.
          </p>
        )}

        {!connectionsLoading && connections.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {connections.map((conn) => {
              const displayName = conn.parent_username || conn.parent_email || conn.invited_email;
              const isPending = conn.status === "pending";
              return (
                <div
                  key={conn.id}
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "13px 14px", background: isPending ? "rgba(255,170,0,0.06)" : "rgba(255,255,255,0.03)",
                    border: `1px solid ${isPending ? "rgba(255,170,0,0.25)" : "rgba(255,255,255,0.08)"}`,
                    borderRadius: "10px", gap: "12px",
                  }}
                >
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: "14px", color: isPending ? "#ffaa00" : "#eee", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {displayName}
                    </div>
                    <div style={{ fontSize: "11.5px", color: "#888", marginTop: "3px" }}>
                      {conn.relationship_type.charAt(0).toUpperCase() + conn.relationship_type.slice(1)}
                      {" · "}
                      <span style={{ color: isPending ? "#ffaa00" : "#4ade80" }}>{isPending ? "Pending" : "Connected"}</span>
                      {conn.accepted_at && ` · Since ${new Date(conn.accepted_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}`}
                    </div>
                  </div>
                  <button
                    onClick={() => handleDisconnect(conn.id, displayName)}
                    disabled={disconnectingId === conn.id}
                    style={{
                      padding: "7px 13px", background: "rgba(255,102,102,0.1)", border: "1px solid rgba(255,102,102,0.3)",
                      borderRadius: "7px", color: "#ff8080", cursor: disconnectingId === conn.id ? "not-allowed" : "pointer",
                      fontSize: "12.5px", fontWeight: 600, flexShrink: 0, opacity: disconnectingId === conn.id ? 0.5 : 1,
                    }}
                  >
                    {disconnectingId === conn.id ? "…" : isPending ? "Cancel" : "Disconnect"}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div style={{ padding: "18px 26px 26px 26px", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <button
          onClick={() => {
            setShowConnectionsModal(false);
            setShowInviteModal(true);
            setInviteError(""); setInviteSuccess(""); setInviteEmail("");
          }}
          style={{ width: "100%", padding: "11px", background: "#028be8", color: "white", border: "none", borderRadius: "8px", fontWeight: 600, cursor: "pointer", fontSize: "14px" }}
        >
          + Invite New
        </button>
      </div>
    </div>
  </div>
)}

{showInviteModal && (
  <div
    className="modal"
    onClick={(e) => { if (e.target === e.currentTarget && !inviteLoading) setShowInviteModal(false); }}
    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200, padding: "20px" }}
  >
    <div style={{
      position: "relative", background: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
      border: "1px solid rgba(2,139,232,0.35)", borderRadius: "16px", color: "white",
      width: "440px", maxWidth: "92vw", padding: "28px", boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
    }}>
      <button
        onClick={() => !inviteLoading && setShowInviteModal(false)}
        style={{ position: "absolute", top: "14px", right: "16px", background: "none", border: "none", color: "#aaa", fontSize: "1.5rem", cursor: "pointer" }}
      >
        ×
      </button>

      <div style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        width: "44px", height: "44px", borderRadius: "12px", background: "rgba(2,139,232,0.15)", marginBottom: "14px",
      }}>
        <FaUserFriends style={{ color: "#36a7f8", fontSize: "18px" }} />
      </div>
      <h2 style={{ margin: "0 0 6px 0", fontSize: "1.25rem" }}>Invite a Parent or Mentor</h2>
      <p style={{ color: "#888", fontSize: "12.5px", lineHeight: 1.5, margin: "0 0 22px 0" }}>
        They'll receive an email with a secure link to register and connect to your profile.
      </p>

      <div style={{ marginBottom: "16px" }}>
        <label style={{ display: "block", fontSize: "12.5px", color: "#ccc", marginBottom: "6px" }}>Email Address</label>
        <input
          type="email"
          value={inviteEmail}
          onChange={(e) => { setInviteEmail(e.target.value); setInviteError(""); }}
          placeholder="parent@example.com"
          disabled={inviteLoading}
          style={{ ...inputStyle, borderColor: inviteError ? "rgba(255,102,102,0.5)" : "rgba(255,255,255,0.15)" }}
        />
      </div>

      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", fontSize: "12.5px", color: "#ccc", marginBottom: "6px" }}>Relationship Type</label>
        <select
          value={inviteRelationshipType}
          onChange={(e) => setInviteRelationshipType(e.target.value)}
          disabled={inviteLoading}
          style={inputStyle}
        >
          <option value="parent" style={{ background: "#16213e" }}>Parent</option>
          <option value="mentor" style={{ background: "#16213e" }}>Mentor</option>
        </select>
      </div>

      {inviteError && <p style={{ color: "#ff8080", fontSize: "12.5px", margin: "0 0 14px 0", textAlign: "center" }}>{inviteError}</p>}
      {inviteSuccess && <p style={{ color: "#4ade80", fontSize: "12.5px", margin: "0 0 14px 0", textAlign: "center" }}>{inviteSuccess}</p>}

      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <button
          onClick={() => setShowInviteModal(false)}
          disabled={inviteLoading}
          style={{ padding: "10px 20px", background: "none", border: "1px solid rgba(255,255,255,0.2)", color: "#ccc", borderRadius: "8px", cursor: inviteLoading ? "not-allowed" : "pointer", fontSize: "14px", opacity: inviteLoading ? 0.6 : 1 }}
        >
          Cancel
        </button>
        <button
          onClick={handleSendInvite}
          disabled={inviteLoading || !sanitizeEmail(inviteEmail)}
          style={{
            padding: "10px 24px",
            background: inviteLoading || !sanitizeEmail(inviteEmail) ? "#444" : "#028be8",
            color: "white", border: "none", borderRadius: "8px", fontWeight: 600, fontSize: "14px",
            cursor: inviteLoading || !sanitizeEmail(inviteEmail) ? "not-allowed" : "pointer",
          }}
        >
          {inviteLoading ? "Sending…" : "Send Invite"}
        </button>
      </div>
    </div>
  </div>
)}



{showChooseSubjectModal && (
  <div
    className="modal"
    onClick={(e) => { if (e.target === e.currentTarget) setShowChooseSubjectModal(false); }}
    style={{
      position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.75)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "20px",
    }}
  >
    <div
    className="choose-your-top-subject-modal"
      style={{
        position: "relative",
        background: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
        border: "1px solid rgba(2,139,232,0.35)",
        borderRadius: "16px",
        color: "white",
        width: "480px",
        maxWidth: "94vw",
        maxHeight: "88vh",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
        overflow: "hidden",
      }}
    >
      <button
        className="modal-close-button"
        onClick={() => setShowChooseSubjectModal(false)}
        style={{
          position: "absolute", top: "14px", right: "16px", background: "none",
          border: "none", color: "#aaa", fontSize: "1.5rem", cursor: "pointer", zIndex: 1,
        }}
        aria-label="Close modal"
      >
        ×
      </button>

      {!showConfirmation ? (
        <>
          {/* ── Header ── */}
          <div className="choose-your-top-subject-top-section" style={{ padding: "26px 26px 18px 26px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
            <div className="choose-your-top-subject" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
            <div style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              width: "44px", height: "44px", borderRadius: "12px",
              background: "rgba(2,139,232,0.15)", marginBottom: "14px",
            }}>
              <FaGraduationCap style={{ color: "#36a7f8", fontSize: "20px" }} />
            </div>
            <h2 style={{ margin: "0 0 8px 0", fontSize: "1.35rem", color: "#fff" }}>
              Choose Your Top Subject
            </h2>
            </div>
            <p className="choose-your-top-subject-p" style={{ margin: 0, color: "#9aa4bd", fontSize: "0.9rem", lineHeight: 1.55 }}>
              Already applying for or studying a university subject? Pick it directly below to
              unlock Enrich+ and FutureLab right away.
            </p>
            <p style={{ margin: "10px 0 0 0", color: "#7a879e", fontSize: "0.82rem", lineHeight: 1.5 }}>
              Not sure yet which subject fits you best?{" "}
              <br/>Take the 
              <button
                onClick={() => {
                  setShowChooseSubjectModal(false);
                  handleAssessment("UniReady", "/subjectassessment");
                }}
                style={{
                  background: "none", border: "none", padding: 0, color: "#36a7f8",
                  textDecoration: "none", cursor: "pointer", fontSize: "0.82rem",
                }}
              >
{"\u00a0"}UniReady{"\u00a0"}
              </button>
               assessment instead.
            </p>
          </div>

          {/* ── Search ── */}
          <div style={{ padding: "16px 26px 0 26px" }}>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                value={subjectSearchTerm}
                onChange={(e) => setSubjectSearchTerm(e.target.value)}
                placeholder="Search subjects…"
                style={{
                  width: "100%", boxSizing: "border-box", padding: "10px 14px 10px 38px",
                  background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.15)",
                  borderRadius: "8px", color: "white", fontSize: "14px", outline: "none",
                }}
              />
              <span style={{ position: "absolute", left: "13px", top: "50%", transform: "translateY(-50%)", color: "#666", fontSize: "13px" }}>
                🔍
              </span>
            </div>
          </div>

          {/* ── Subject list ── */}
          <div className="scroll-hidden" style={{ padding: "12px 26px 0 26px", flex: 1, overflowY: "auto", minHeight: "180px", maxHeight: "300px" }}>
            {availableSubjects.length === 0 ? (
              <p style={{ color: "#666", fontStyle: "italic", fontSize: "13.5px", textAlign: "center", padding: "30px 0" }}>
                Loading subjects…
              </p>
            ) : (
              (() => {
                const filtered = availableSubjects.filter((s) =>
                  s.facet.toLowerCase().includes(subjectSearchTerm.trim().toLowerCase())
                );
                if (filtered.length === 0) {
                  return (
                    <p style={{ color: "#666", fontStyle: "italic", fontSize: "13.5px", textAlign: "center", padding: "30px 0" }}>
                      No subjects match "{subjectSearchTerm}".
                    </p>
                  );
                }
                return (
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px", paddingBottom: "6px" }}>
                    {filtered.map((subject) => {
                      const isSelected = selectedSubject === subject.facet;
                      return (
                        <button
                          key={subject.facet}
                          onClick={() => setSelectedSubject(subject.facet)}
                          style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            width: "100%", textAlign: "left", padding: "11px 14px",
                            borderRadius: "8px", cursor: "pointer",
                            background: isSelected ? "rgba(2,139,232,0.18)" : "rgba(255,255,255,0.03)",
                            border: isSelected ? "1px solid #028be8" : "1px solid rgba(255,255,255,0.08)",
                            color: isSelected ? "#fff" : "#ccc",
                            fontSize: "14px", fontWeight: isSelected ? 600 : 400,
                            transition: "all 0.12s ease",
                          }}
                        >
                          {subject.facet}
                          {isSelected && <span style={{ color: "#36a7f8", fontSize: "15px" }}>✓</span>}
                        </button>
                      );
                    })}
                  </div>
                );
              })()
            )}
          </div>

          {/* ── Warning + actions ── */}
          <div className="choose-your-top-subject-warning"  style={{ padding: "18px 26px 26px 26px", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
            <div style={{
              display: "flex", gap: "10px", alignItems: "flex-start",
              background: "rgba(255,170,0,0.08)", border: "1px solid rgba(255,170,0,0.25)",
              borderRadius: "8px", padding: "10px 14px", marginBottom: "18px",
            }}>
              <FaInfoCircle style={{ color: "#ffaa00", fontSize: "14px", marginTop: "2px", flexShrink: 0 }} />
            <p style={{ margin: 0, color: "#ffcc80", fontSize: "12.5px", lineHeight: 1.5 }}>
  This can only be changed once every 3 months, and FutureLab insights will be based only on
  this subject.
</p>
            </div>

            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                onClick={() => setShowChooseSubjectModal(false)}
                style={{
                  padding: "10px 20px", background: "none", border: "1px solid rgba(255,255,255,0.2)",
                  color: "#ccc", borderRadius: "8px", cursor: "pointer", fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (selectedSubject && isSubjectChoiceAllowed()) {
                    setShowConfirmation(true);
                  }
                }}
                disabled={!selectedSubject || !isSubjectChoiceAllowed()}
                style={{
                  padding: "10px 24px",
                  background: (!selectedSubject || !isSubjectChoiceAllowed()) ? "#444" : "#028be8",
                  color: "white", border: "none", borderRadius: "8px", fontWeight: 600,
                  fontSize: "14px",
                  cursor: (!selectedSubject || !isSubjectChoiceAllowed()) ? "not-allowed" : "pointer",
                }}
              >
                Continue
              </button>
            </div>

          {!isSubjectChoiceAllowed() && lastSubjectChoiceDate && (
  <p style={{ margin: "10px 0 0 0", color: "#888", fontSize: "12px", textAlign: "right" }}>
    Next available {formatDate(new Date(new Date(lastSubjectChoiceDate).getTime() + 3 * 30 * 24 * 60 * 60 * 1000))}
  </p>
)}
          </div>
        </>
      ) : (
        <div style={{ padding: "34px 30px" }}>
          <div style={{ textAlign: "center", marginBottom: "22px" }}>
            <div style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              width: "52px", height: "52px", borderRadius: "50%",
              background: "rgba(2,139,232,0.15)", marginBottom: "16px",
            }}>
              <FaGraduationCap style={{ color: "#36a7f8", fontSize: "22px" }} />
            </div>
            <h2 style={{ margin: "0 0 10px 0", fontSize: "1.25rem" }}>Confirm Your Choice</h2>
            <p style={{ margin: 0, color: "#ccc", fontSize: "15px", lineHeight: 1.5 }}>
              Set <strong style={{ color: "#fff" }}>{selectedSubject}</strong> as your top subject?
            </p>
          </div>

          <div style={{
            background: "rgba(255,170,0,0.08)", border: "1px solid rgba(255,170,0,0.25)",
            borderRadius: "8px", padding: "12px 16px", marginBottom: "24px",
            color: "#ffcc80", fontSize: "12.5px", textAlign: "center", lineHeight: 1.5,
          }}>
  This can only be changed once every 3 months.
          </div>

          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button
              onClick={() => setShowConfirmation(false)}
              style={{
                flex: 1, maxWidth: "160px", padding: "11px 20px", background: "none",
                border: "1px solid rgba(255,255,255,0.2)", color: "#ccc", borderRadius: "8px",
                cursor: "pointer", fontSize: "14px",
              }}
            >
              Back
            </button>
            <button
              onClick={() => {
                handleConfirmSubjectChoice();
                setShowChooseSubjectModal(false);
                setShowConfirmation(false);
              }}
              style={{
                flex: 1, maxWidth: "160px", padding: "11px 20px", background: "#028be8",
                color: "white", border: "none", borderRadius: "8px", fontWeight: 600,
                cursor: "pointer", fontSize: "14px",
              }}
            >
              Yes, Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
)}

{reasonEditorSubject && (
  <div
    className="modal"
    style={{
      position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300,
    }}
  >
    <div className="first-time-reason-prompt" style={{
      backgroundColor: "#050f27c9", padding: "34px", borderRadius: "14px",
      color: "white", width: "580px", maxWidth: "92%",
      border: "1px solid #ffaa007d",
    }}>
      <h3 style={{ margin: "0 0 6px", color: "#ffaa00" }}>
        What draws you to {reasonEditorSubject}?
      </h3>
      <p style={{ margin: "0 0 26px", fontSize: "0.88rem", color: "#aaa" }}>
        Optional — helps personalise your learning journey. Stored only on this device.
      </p>

         <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '26px' }}>
        {SUBJECT_REASON_TAGS.map((tag) => {
          const active = reasonDraftTags.includes(tag);
          return (
            <button
              key={tag}
              type="button"
              onClick={() => {
                setReasonDraftTags((prev) => {
                  const updated = prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag];
                  saveSubjectReason(reasonEditorSubject, updated, reasonDraftText);
                  return updated;
                });
              }}
              style={{
                padding: '6px 11px', fontSize: '12.5px', borderRadius: '999px',
                border: '1px solid #ffaa00',
 background: active
    ? '#ffaa00'
    : 'transparent',
                    color: active ? '#0b1021' : '#ffaa00',
                cursor: 'pointer',
              }}
            >
              {tag}
            </button>
          );
        })}
      </div>

      <textarea
      className='space-scroll'
        value={reasonDraftText}
        onChange={(e) => setReasonDraftText(e.target.value)}
        onBlur={() => saveSubjectReason(reasonEditorSubject, reasonDraftTags, reasonDraftText)}
        placeholder={`What's one thing you'd love to learn or achieve through ${reasonEditorSubject}?`}
        rows={3}
        style={{
          width: '100%', resize: 'vertical', padding: '10px', borderRadius: '8px',
          border: '1px solid #444', background: '#1a1a1a', color: 'white', fontSize: '0.9rem',
        }}
      />

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
        <button
          onClick={() => {
            // Everything is already autosaved as you type/select — this just closes.
            saveSubjectReason(reasonEditorSubject, reasonDraftTags, reasonDraftText);
            setReasonEditorSubject(null);
            setTimeout(() => {
    isAnyModalOpenRef.current = false;
    setIsAnyModalOpen(false);
  }, 0);
          }}
          style={{ padding: "9px 20px", background: "#028be8", color: "#ffffff", border: "none", borderRadius: "8px", fontWeight: 600, cursor: "pointer" }}
        >
          Done
        </button>
      </div>
    </div>
  </div>
)}

{showFirstTimeReasonPrompt && topScores[reasonPromptIndex] && (
  <div
    className="modal"
    style={{
      position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.75)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300,
    }}
  >
    <div className="first-time-reason-prompt" style={{
      backgroundColor: "#0f1629", padding: "28px", borderRadius: "16px",
      color: "white", width: "560px", maxWidth: "92%", textAlign: "center",
      border: "1px solid rgba(0,225,255,0.28)",
    }}>
      <p style={{ fontSize: "0.85rem", color: "#888", margin: "0 0 8px" }}>
        {reasonPromptIndex + 1} of {topScores.length}
      </p>
      <h2 style={{ margin: "0 0 8px", color: "#36a7f8" }}>Nice results!</h2>
      <p style={{ margin: "0 0 26px", color: "#ccc" }}>
        <strong>{topScores[reasonPromptIndex]._id}</strong> came out as one of your top matches.
        Want to note down why it interests you? It's just for you, saved on this device — you can always come back to it.
      </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', justifyContent: 'center', marginBottom: '26px' }}>
        {SUBJECT_REASON_TAGS.map((tag) => {
          const active = reasonDraftTags.includes(tag);
          return (
            <button
              key={tag}
              type="button"
              onClick={() => {
                // Autosave on every toggle — no separate Save step needed.
                setReasonDraftTags((prev) => {
                  const updated = prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag];
                  saveSubjectReason(topScores[reasonPromptIndex]._id, updated, reasonDraftText);
                  return updated;
                });
              }}
              style={{
                padding: '6px 11px', fontSize: '12.5px', borderRadius: '999px',
                border: '1px solid #36a7f8',
                background: active ? '#36a7f8' : 'transparent',
                color: active ? '#0b1021' : '#36a7f8',
                cursor: 'pointer',
              }}
            >
              {tag}
            </button>
          );
        })}
      </div>

      <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
        <button
            onClick={() => {
            setReasonDraftTags([]);
            setReasonDraftText('');
            setShowFirstTimeReasonPrompt(false);
            isAnyModalOpenRef.current = false;
            setIsAnyModalOpen(false);
          }}
          style={{
            padding: "10px 18px", background: "none", border: "1px solid rgba(255,255,255,0.2)",
            color: "#888", borderRadius: "8px", cursor: "pointer", fontSize: "13px",
          }}
        >
          Skip all
        </button>
        <button
        onClick={() => {
            setReasonDraftTags([]);
            setReasonDraftText('');
            const next = reasonPromptIndex + 1;
            if (next < topScores.length) {
              setReasonPromptIndex(next);
            } else {
              setShowFirstTimeReasonPrompt(false);
              isAnyModalOpenRef.current = false;
              setIsAnyModalOpen(false);
            }
          }}
          style={{ padding: "10px 22px", background: "#028be8", color: "white", border: "none", borderRadius: "8px", fontWeight: 600, cursor: "pointer" }}
        >
          {reasonPromptIndex + 1 < topScores.length ? "Next" : "Finish"}
        </button>
      </div>
    </div>
  </div>
)}

    <div className="sidebar">
  <div className="sidebar-header">
    <button
      className={`OG-logo sidebar-item-logo sidebar-item-dashboard ${activeSidebarItem === "uniready" ? "selected" : ""}`}
      onClick={() => navigate('/dashboard')}
      aria-current={activeSidebarItem === "uniready" ? "page" : undefined}
    >
      <span className="aspire">ASPIREdeck</span>
    </button>
    {isAdmin && <p className="admin-status">Admin</p>}
    {role === "subject_consultant" && <p className="admin-status">Subject Consultant</p>}

{/* Mobile version */}
<div className="account-icon-container account-icon-mobile">
  <button className="account-icon" onClick={toggleAccountMenu} aria-label="Account menu">
    {/* Avatar display */}
    <div
      style={{
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        overflow: "hidden",
        background: "#222",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid #444",
        flexShrink: 0,
      }}
    >
      {currentAvatar?.startsWith("fa-avatar-") ? (
        (() => {
          const index = parseInt(currentAvatar.split("-")[2], 10) - 1;
          const style = avatarStyles[index] || avatarStyles[0];
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: style.bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `2.5px solid ${style.color}`,
              }}
            >
              <i
                className={`fas fa-${style.icon}`}
                style={{
                  fontSize: "20px",
                  color: style.color,
                }}
              />
            </div>
          );
        })()
      ) : (
        <img
          src={`/avatars/${currentAvatar}`}
          alt="User avatar"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          onError={(e) => {
            e.target.src = "/avatars/default.png"; // fallback
          }}
        />
      )}
    </div>

<span className="account-username" style={{ marginLeft: "10px" }}>{displayName}</span>
  </button>

  {showAccountMenu && (
    <div className="account-menu" ref={menuRef}>
      <div className="account-menu-header">
        <span>{userEmail}</span>
      </div>
{!isParentView && (
<button
  className="account-menu-item"
  onMouseEnter={prewarmDeckSpace}
  onTouchStart={prewarmDeckSpace}
  onClick={() => { setShowAccountMenu(false); openModal('deckspace'); }}
>My deckSPACE</button>
)}
{!isParentView && (
<button
  className={`account-menu-item ${openModalName === 'calendar' ? 'selected' : ''}`}
onClick={() => openModal('calendar')}
  aria-label="View My Calendar"
  title="View planned SuperCurricular activities"
>
 My Calendar
</button>
)}
{!isParentView && (
    <button 
      className="account-menu-item"
onClick={() => { setShowAccountMenu(false); openModal('pathways'); }}
    >
      Pathways
    </button>
    )}
 {/* {!isParentView && (
  <button
    className="account-menu-item"
    onClick={(e) => {
      e.stopPropagation();
      setShowAccountMenu(false);
      setShowKnowledgeUploadModal(true);
    }}
  >
    Manage AspireAI
  </button>
)} */}
      <button className="account-menu-item" onClick={(e) => {
        e.stopPropagation();
        handleManageAccount();
      }}>
        Manage Account
      </button>
      <button
        className="account-menu-item logout"
        onClick={(e) => {
          e.stopPropagation();
          handleLogoutClick();
        }}
      >
        Log out
      </button>
    </div>
  )}
</div>
  </div>

  <nav className="sidebar-nav-dashboard">
        {role !== "subject_consultant" && (
      <>
       {/* ─── UniReady ─── */}
      <button
        className={`sidebar-item sidebar-item-dashboard ${activeSidebarItem === "uniready" ? "selected" : ""}`}
        onClick={() => {
          setActiveSidebarItem("uniready");
          navigateWithViewMode("/dashboard"); // ← or whatever path UniReady lives on
        }}
        aria-current={activeSidebarItem === "uniready" ? "page" : undefined}
      >
        <FaGraduationCap className="sidebar-icon icon-uniready" />
        <span className="sidebar-text">UniReady</span>
      </button>

         <TooltipUI2
        text={
          !(isAdmin || completionStatus.subject || chosenTopSubject)
            ? ""
            : ""
        }
      >
    {/* ─── Enrich+ ─── */}
        <button
          className={`sidebar-item sidebar-item-dashboard ${activeSidebarItem === "enrich" ? "selected" : ""}`}
         onClick={() => {
  const hasSubjectData = isAdmin || isParentView || completionStatus.subject || chosenTopSubject;
  if (!hasSubjectData) {
    // Don't navigate to a page that has nothing to show — send them to the
    // fast path (pick a subject directly) instead of a dead end.
    setShowChooseSubjectModal(true);
    return;
  }
  setActiveSidebarItem("enrich");
  navigateWithViewMode("/dashboard_enrich", {
    sortedScores: topScores,
    sortedPart3Scores: topPart3Scores,
    userEmail,
    userUsername,
    chosenTopSubject,
    fullSortedScores: sortedScores,          
    fullSortedPart3Scores: sortedPart3Scores
  });
}}
          style={
            !(isAdmin || completionStatus.subject || chosenTopSubject)
              ? { opacity: 0.6 }
              : undefined
          }
          aria-current={activeSidebarItem === "enrich" ? "page" : undefined}
        >
          <FaRegLightbulb className="sidebar-icon" />
          <span className="sidebar-text">Enrich+</span>
        </button>
      </TooltipUI2>
    </>
  )}
<TooltipUI2
  text={
    !(isAdmin || completionStatus.subject || chosenTopSubject)
      ? "Complete UniReady to enable Engage"
      : ""
  }
>
</TooltipUI2>
  {role !== "subject_consultant" && (
    <>
          <TooltipUI2
        text={
          !(isAdmin || completionStatus.subject || chosenTopSubject)
            ? ""
            : ""
        }
      >
        {/* ─── FutureLab ─── */}
        <button
          className="sidebar-item sidebar-item-dashboard"
          onClick={() => {
            const hasSubjectData = isAdmin || isParentView || completionStatus.subject || chosenTopSubject;
            if (!hasSubjectData) {
              setShowChooseSubjectModal(true);
              return;
            }
            navigateWithViewMode("/CareerDashboard", {
            sortedScores: topScores,
            sortedPart3Scores: topPart3Scores,
            userEmail,
            userUsername, 
            chosenTopSubject,
            });
          }}
          style={
            !(isAdmin || completionStatus.subject || chosenTopSubject)
              ? { opacity: 0.6 }
              : undefined
          }
        >
          <FaReact className="sidebar-icon" />
          <span className="sidebar-text">FutureLab</span>
        </button>
      </TooltipUI2>
    </>
  )}
   {role !== "subject_consultant" && (
    <>
{/* ─── SparkHub Button ─── */}
<TooltipUIViewOnly
  text=""
>
  <button
    className={`sidebar-item sidebar-item-dashboard ${activeSidebarItem === "sparkhub" ? "selected" : ""}`}
    onClick={() => {
      navigateWithViewMode("/LeaderDashboard", {
        sortedScores: topScores || [],
        sortedPart3Scores: topPart3Scores || [],
        chosenTopSubject: chosenTopSubject,
        userEmail: userEmail,
        userUsername: userUsername, 
      });
    }}
  >
    <FaBurst className="sidebar-icon" />
    <div><span className="sidebar-text">SparkHub</span></div>
  </button>
</TooltipUIViewOnly>

<TooltipUIViewOnly
 text=""
>
  <button
    className={`sidebar-item sidebar-item-dashboard ${activeSidebarItem === "mastery" ? "selected" : ""}`}
    onClick={() => {
      setActiveSidebarItem("mastery");
    }}
      disabled={isReadOnlyView}
  >
    <FaChessKing className="sidebar-icon" />
    <span className="sidebar-text">Mastery</span>
  </button>
</TooltipUIViewOnly>

{/* ─── AspireAI Button — admin & beta only ─── */}
{(isAdmin || userType === "beta") && (
  <TooltipUIViewOnly
    text="Ask questions and have them answered by your local AI device."
  >
    <button
      className={`sidebar-item sidebar-item-dashboard ${activeSidebarItem === "askai" ? "selected" : ""}`}
      onClick={() => setActiveSidebarItem("askai")}
      aria-current={activeSidebarItem === "askai" ? "page" : undefined}
    >
      <FaCircleNodes className="sidebar-icon" />
      <span className="sidebar-text">AspireAI</span>
    </button>
  </TooltipUIViewOnly>
)}

</>
 )}
        <div className="account-icon-container account-icon-desktop">
  <button className="account-icon" onClick={toggleAccountMenu} aria-label="Account menu">
    {/* Same avatar display code as above */}
    <div
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        overflow: "hidden",
        background: "#222",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid #444",
        flexShrink: 0,
      }}
    >
      {currentAvatar?.startsWith("fa-avatar-") ? (
        (() => {
          const index = parseInt(currentAvatar.split("-")[2], 10) - 1;
          const style = avatarStyles[index] || avatarStyles[0];
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: style.bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `2.5px solid ${style.color}`,
              }}
            >
              <i
                className={`fas fa-${style.icon}`}
                style={{
                  fontSize: "22px",
                  color: style.color,
                }}
              />
            </div>
          );
        })()
      ) : (
        <img
          src={`/avatars/${currentAvatar}`}
          alt="User avatar"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          onError={(e) => {
            e.target.src = "/avatars/default.png";
          }}
        />
      )}
    </div>

<span className="account-username" style={{ marginLeft: "10px" }}>{displayName}</span>
  </button>

  {showAccountMenu && (
    <div className="account-menu" ref={menuRef}>
          <div className="account-menu-header">
            <span>{userEmail}</span>
          </div>
          {!isParentView && (
<button
  className="account-menu-item"
  onMouseEnter={prewarmDeckSpace}
  onTouchStart={prewarmDeckSpace}
  onClick={() => { setShowAccountMenu(false); openModal('deckspace'); }}
>My deckSPACE</button>
)}
{!isParentView && (
<button
  className={`account-menu-item ${openModalName === 'calendar' ? 'selected' : ''}`}
onClick={() => openModal('calendar')}
  aria-label="View My Calendar"
  title="View planned SuperCurricular activities"
>
 My Calendar
</button>
)}
{!isParentView && (
    <button 
      className="account-menu-item"
   onClick={() => { setShowAccountMenu(false); openModal('pathways'); }}
    >
      Pathways
    </button>
    )}
   {/* {!isParentView && (
  <button
    className="account-menu-item"
    onClick={(e) => {
      e.stopPropagation();
      setShowAccountMenu(false);
      setShowKnowledgeUploadModal(true);
    }}
  >
    Manage AspireAI
  </button>
)}*/}
          <button className="account-menu-item" onClick={handleManageAccount}>
            Manage Account
          </button>
         <button 
  className="account-menu-item logout" 
  onClick={(e) => {
    e.stopPropagation();           // This is now REQUIRED
    handleLogoutClick();
  }}
>
  Log out
</button>
        </div>
      )}
    </div>
  </nav>
</div>

    <div className="main-content main-content-dashboard">
       {viewModeBannerText && (
  <div
    className="view-mode-banner banner-content banner-text"
    style={{
      backgroundColor: "rgba(30, 58, 138, 0.15)", // subtle dark blue tint
      border: "1px solid rgba(96, 165, 250, 0.3)",
      borderRadius: "8px",
      paddingLeft: "150x",
      fontSize: "1rem",
      lineHeight: 1.5,
      boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
    }}
  >
    {viewModeBannerText}
  </div>
)}
 {role === "subject_consultant" ? (
  <div style={{ color: "white", fontSize: "24px", textAlign: "center", marginTop: "20px" }}>
    Welcome to Subject Consultant console.
  </div>
) : (
  <div className="charts-container">
 {activeSidebarItem === "mastery" ? (
   /* ==================== MASTERY PAGE ==================== */
  <div className="mst-wrap">
    <style>{`
      .mst-wrap { padding: 50px 24px 60px; max-width: 1140px; margin: 0 auto; }
      .mst-eyebrow {
        display: flex; align-items: center; justify-content: center; gap: 8px;
        font-size: 0.74rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase;
        color: #36a7f8; margin-bottom: 10px;
      }
      .mst-eyebrow .line { width: 22px; height: 1px; background: rgba(54,167,248,0.4); }
      .mst-title { text-align: center; color: #f2f6ff; font-size: 2rem; font-weight: 700;
        letter-spacing: -0.01em; margin: 0 0 12px; }
      .mst-sub { text-align: center; color: #9aa4bd; font-size: 1.05rem; line-height: 1.55;
        max-width: 560px; margin: 0 auto 48px; }

      .mst-grid {
        display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 26px;
      }

      @keyframes mst-rise { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }

      .mst-card {
        position: relative; text-align: left; border-radius: 18px; padding: 34px 28px;
        background: linear-gradient(160deg, #161d38, #0e1428);
        border: 1px solid rgba(255,255,255,0.08);
        cursor: pointer; overflow: hidden;
        animation: mst-rise 0.35s ease both;
        transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
      }
      .mst-card:nth-child(2) { animation-delay: 0.06s; }
      .mst-card:nth-child(3) { animation-delay: 0.12s; }
      .mst-card.locked { cursor: not-allowed; }
      .mst-card.unlocked.accent-blue:hover { transform: translateY(-6px); border-color: rgba(54,167,248,0.6); box-shadow: 0 18px 46px rgba(54,167,248,0.22); }
      .mst-card.unlocked.accent-amber:hover { transform: translateY(-6px); border-color: rgba(245,158,11,0.6); box-shadow: 0 18px 46px rgba(245,158,11,0.2); }
      .mst-card.locked:hover { transform: translateY(-2px); }

      .mst-glow {
        position: absolute; top: -60px; right: -60px; width: 180px; height: 180px;
        border-radius: 50%; filter: blur(40px); opacity: 0.35; pointer-events: none;
      }
      .accent-blue .mst-glow { background: #028be8; }
      .accent-amber .mst-glow { background: #f59e0b; }
      .mst-card.locked .mst-glow { opacity: 0.1; }

      .mst-lock-badge {
        position: absolute; top: 18px; right: 18px; display: flex; align-items: center; gap: 5px;
        font-size: 0.68rem; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
        color: #9aa4bd; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);
        padding: 5px 10px; border-radius: 999px;
      }

      .mst-icon-badge {
        width: 56px; height: 56px; border-radius: 14px; display: flex; align-items: center;
        justify-content: center; font-size: 24px; margin-bottom: 22px; position: relative;
      }
      .accent-blue .mst-icon-badge { background: rgba(54,167,248,0.14); color: #36a7f8; }
      .accent-amber .mst-icon-badge { background: rgba(245,158,11,0.14); color: #f59e0b; }
      .mst-card.locked .mst-icon-badge { background: rgba(255,255,255,0.06); color: #555; }

      .mst-card h3 { color: #f2f6ff; margin: 0 0 10px; font-size: 1.32rem; font-weight: 700; }
      .mst-card p.mst-desc { color: #9aa4bd; line-height: 1.55; margin: 0 0 26px; font-size: 0.93rem; min-height: 44px; }

      .mst-cta {
        display: inline-flex; align-items: center; gap: 7px; font-weight: 700; font-size: 0.9rem;
      }
      .accent-blue .mst-cta { color: #36a7f8; }
      .accent-amber .mst-cta { color: #f59e0b; }
      .mst-card.locked .mst-cta { color: #6b7590; }
      .mst-card.unlocked:hover .mst-cta .mst-arrow { transform: translateX(4px); }
      .mst-arrow { display: inline-block; transition: transform 0.18s ease; }

      .mst-ghost-card {
        border-radius: 18px; border: 1.5px dashed rgba(255,255,255,0.14);
        display: flex; flex-direction: column; align-items: center; justify-content: center;
        gap: 10px; padding: 34px 28px; color: #555; text-align: center; min-height: 100%;
        animation: mst-rise 0.35s ease 0.18s both;
      }
      .mst-ghost-card .mst-ghost-icon {
        width: 44px; height: 44px; border-radius: 12px; border: 1.5px dashed rgba(255,255,255,0.18);
        display: flex; align-items: center; justify-content: center; font-size: 18px; color: #555;
      }
      .mst-ghost-card span { font-size: 0.88rem; }
    `}</style>

    <h2 style={{marginTop: '-30px', color: '#36a7f8 ', fontWeight: 100}} className="mst-title">Mastery Pathways</h2>
    <p className="mst-sub">Explore specialised domains and build real-world expertise, one structured pathway at a time.</p>

    <div className="mst-grid">
      {/* ==================== CoachPlus ==================== */}
      <TooltipUIViewOnly
        text={
          !(isAdmin || userType === "coachplus")
            ? "CoachPlus is only available to higher education students or professional coaches. Please contact Oxbridge Gateway for access."
            : ""
        }
      >
        <div
          className={`mst-card accent-blue ${isAdmin || userType === "coachplus" ? "unlocked" : "locked"}`}
          onClick={() => {
            if (isAdmin || userType === "coachplus") {
              navigate("/CoachTheCoachDashboard", { state: { ...location.state, fromMastery: true } });
            }
          }}
        >
          <div className="mst-glow" />
          {!(isAdmin || userType === "coachplus") && (
            <span className="mst-lock-badge">🔒 Locked</span>
          )}
          <div className="mst-icon-badge"><FaChalkboardTeacher /></div>
          <h3>CoachPlus</h3>
          <p className="mst-desc">A behavioural coaching mastery platform for professional coaches and mentors.</p>
          <span className="mst-cta">
            {isAdmin || userType === "coachplus" ? <>Enter CoachPlus <span className="mst-arrow">→</span></> : "Contact Oxbridge Gateway for access"}
          </span>
        </div>
      </TooltipUIViewOnly>

      {/* ==================== LeaderPlus ==================== */}
      <TooltipUIViewOnly
        text={
          !(isAdmin || userType === "leaderplus")
            ? "LeaderPlus is only available to business school students and startup founders. Please contact Oxbridge Gateway for access."
            : ""
        }
      >
        <div
          className={`mst-card accent-amber ${isAdmin || userType === "leaderplus" ? "unlocked" : "locked"}`}
          onClick={() => {
            if (isAdmin || userType === "leaderplus") {
              navigate("/LeadershipDashboard", { state: { ...location.state, fromMastery: true } });
            }
          }}
        >
          <div className="mst-glow" />
          {!(isAdmin || userType === "leaderplus") && (
            <span className="mst-lock-badge">🔒 Locked</span>
          )}
          <div className="mst-icon-badge"><FaUserTie /></div>
          <h3>LeaderPlus</h3>
          <p className="mst-desc">A leadership mastery platform for founders, managers, and business students.</p>
          <span className="mst-cta">
            {isAdmin || userType === "leaderplus" ? <>Enter LeaderPlus <span className="mst-arrow">→</span></> : "Contact Oxbridge Gateway for access"}
          </span>
        </div>
      </TooltipUIViewOnly>

      {/* ==================== Coming soon ghost slot ==================== */}
      <div className="mst-ghost-card">
        <div className="mst-ghost-icon">+</div>
        <span>More mastery pathways coming soon</span>
      </div>
    </div>
  </div>
) : activeSidebarItem === "askai" ? (
  /* ==================== ASK AI PAGE ==================== */
  <div style={{ height: "95vh", display: "flex", width: '1500px',  marginTop: '-30px', marginBottom: '-500px' }}>
    <AskAIWorkspace
      deviceUrl={knowledgeDeviceUrl}
      userId={effectiveUserId}
      isReadOnly={isReadOnlyView}
      onOpenDeviceManager={() => setShowKnowledgeUploadModal(true)}
    />
  </div>
) : (
      /* ==================== ORIGINAL UNIREADY CONTENT ==================== */
      <>
     {loading.scores ||
 loading.subjectPart3Scores ||
 loading.part3Eligibility ? (
  <div style={{ color: "white", fontSize: "14px" }}>Loading...</div>
) : (
          <>
            {renderAssessmentSection("subject")}
            {error.scores && (
              <div style={{ color: "white", fontSize: "14px", marginTop: "20px" }}>
                {error.scores}
              </div>
            )}
            {error.subjectPart3Scores && (
              <div style={{ color: "white", fontSize: "14px", marginTop: "20px" }}>
                {error.subjectPart3Scores}
              </div>
            )}
            {error.part3Eligibility && (
              <div style={{ color: "white", fontSize: "14px", marginTop: "20px" }}>
                {error.part3Eligibility}
              </div>
            )}
          </>
        )}
      </>
    )}
  </div>
)}
    </div>
{/* ─── Progress Celebration Modal ─── */}
{showProgressModal && justCompleted && (
  <div
    className="progress-modal-overlay"
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    }}
  >
    <div
      style={{
        background: "linear-gradient(135deg, #0f1629, #1a2342)",
        color: "white",
        padding: "2.6rem 2.4rem",
        borderRadius: "16px",
        maxWidth: "520px",
        width: "90%",
        textAlign: "center",
        boxShadow: "0 12px 50px rgba(0,225,255,0.35)",
        border: "1px solid rgba(0,225,255,0.28)",
      }}
    >
      <h2 style={{ margin: "0 0 1.6rem", color: "#00e1ff", fontSize: "2.3rem" }}>
        Well Done!
      </h2>

      <p style={{ fontSize: "1.25rem", margin: "0 0 2.2rem", lineHeight: 1.5 }}>
        You just completed the{" "}
        <strong style={{ color: "#36a7f8" }}>
          {justCompleted === "uniready"
            ? "UniReady"
            : justCompleted === "studystyle"
            ? "StudyStyle"
            : "FutureReady"}{" "}
        </strong>{" "}
        assessment!
      </p>

      {/* ── Three Star Icons with Labels Below ── */}
      <div
      className="completion-progress-stars"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "20px",
          margin: "2.2rem 0 2.8rem",
          padding: "0 20px",
        }}
      >
        {[
          { key: "uniready",    label: "UniReady",    completed: completedAssessments.uniready    },
          { key: "studystyle",  label: "StudyStyle",  completed: completedAssessments.studystyle  },
          { key: "futureready", label: "FutureReady", completed: completedAssessments.futureready },
        ].map((item) => (
          <div
            key={item.key}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span
              style={{
                fontSize: "3.8rem",
                lineHeight: 1,
                color: item.completed ? "#ffd700" : "#555",
                textShadow: item.completed ? "0 0 14px #ffd700aa" : "none",
                filter: item.completed ? "drop-shadow(0 0 12px #ffd700)" : "none",
                transition: "all 0.4s ease",
              }}
              title={item.label + (item.completed ? " – Completed" : " – Pending")}
            >
              {item.completed ? "★" : "☆"}
            </span>
            <span
              style={{
                fontSize: "1.05rem",
                fontWeight: item.completed ? 600 : 400,
                color: item.completed ? "#ffd700" : "#aaa",
                textAlign: "center",
              }}
            >
              {item.label}
            </span>
          </div>
        ))}
      </div>

      <button
        onClick={() => setShowProgressModal(false)}
        className="completion-progress-button"
        style={{
          padding: "1.1rem 2.8rem",
          background: "linear-gradient(90deg, #028be8, #00e1ff)",
          color: "white",
          border: "none",
          borderRadius: "12px",
          fontSize: "1.25rem",
          fontWeight: "bold",
          cursor: "pointer",
          boxShadow: "0 5px 18px rgba(2,139,232,0.45)",
          transition: "all 0.25s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 10px 28px rgba(2,139,232,0.6)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 5px 18px rgba(2,139,232,0.45)";
        }}
      >
        Continue
      </button>
    </div>
  </div>
)}

{/* ─── Avatar Selection Modal ─── */}
{showAvatarModal && !isParentView && (
  <div
    className="avatar-modal-overlay"
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2100,
    }}
  >
    <div
      style={{
        position: "relative",
        background: "#0f1629",
        color: "white",
        padding: "2.4rem 2rem",
        borderRadius: "16px",
        width: "92%",
        maxWidth: "820px",
        maxHeight: "88vh",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 15px 60px rgba(0,225,255,0.35)",
        border: "1px solid rgba(0,225,255,0.3)",
      }}
    >
      <button
        onClick={() => {
          setShowAvatarModal(false);
          localStorage.setItem(`has_seen_avatar_modal_${userId}`, "true");
          setShowManageModal(true);
        }}
        style={{
          display: "inline-flex", alignItems: "center", gap: "6px",
          background: "none", border: "none", color: "#36a7f8",
          fontSize: "13px", cursor: "pointer", padding: 0, marginBottom: "10px",
          alignSelf: "flex-start",
        }}
      >
        ← Back
      </button>

      <h2 className="avatar-modal-title"
        style={{
          margin: "0 0 1.2rem",
          textAlign: "center",
          color: "#00e1ff",
          fontSize: "2.1rem",
        }}
      >
        Choose Your Avatar
      </h2>

      {/* ─── 3-star progress with labels below each star ─── */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          marginBottom: "1rem",
          fontSize: "1.3rem",
        }}
      >
        {[
          { name: "UniReady", completed: completedAssessments.uniready },
          { name: "StudyStyle", completed: completedAssessments.studystyle },
          { name: "FutureReady", completed: completedAssessments.futureready },
        ].map((assess, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: "80px",
            }}
          >
            <span
              style={{
                color: assess.completed ? "#ffd700" : "#555",
                fontSize: "2.2rem",
                marginBottom: "6px",
                textShadow: assess.completed ? "0 0 12px #ffd700aa" : "none",
              }}
              title={assess.name + (assess.completed ? " – Completed" : " – Pending")}
            >
              {assess.completed ? "★" : "☆"}
            </span>
            <span
              style={{
                fontSize: "0.9rem",
                color: assess.completed ? "#ffd700" : "#aaa",
                fontWeight: assess.completed ? "600" : "normal",
                textAlign: "center",
              }}
            >
              {assess.name}
            </span>
          </div>
        ))}
      </div>

 {/* Cooldown message */}
      {!isAdmin && lastAvatarChangeDate && !isAvatarChangeAllowed() && (
        <div
          style={{
            textAlign: "center",
            margin: "1rem 0 1.5rem",
            padding: "12px 20px",
            background: "rgba(255, 193, 7, 0.15)",
            border: "1px solid rgba(255, 193, 7, 0.4)",
            borderRadius: "12px",
            maxWidth: "480px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <p style={{ color: "#ffca28", fontWeight: 600, margin: "0 0 6px 0" }}>
            Avatar change on cooldown
          </p>
          <p style={{ color: "#ddd", fontSize: "0.95rem", margin: 0 }}>
            You can change your avatar again after{" "}
            {(() => {
              const next = new Date(new Date(lastAvatarChangeDate).getTime() + 24*60*60*1000);
              return next.toLocaleString([], {
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              });
            })()}
          </p>
        </div>
      )}

      {/* Conditional message based on completion */}
      {completedAssessments.uniready &&
      completedAssessments.studystyle &&
      completedAssessments.futureready ? (
        <p className="avatar-modal-message"
          style={{
            textAlign: "center",
            color: "#a0e7ff",
            margin: "0 0 1.8rem 0",
            fontSize: "1.1rem",
          }}
        >
          All assessments completed — change your avatar!
        </p>
      ) : (
        <div
          style={{
            textAlign: "center",
            marginBottom: "1.8rem",
            padding: "12px 20px",
            background: "rgba(255, 193, 7, 0.12)",
            border: "1px solid rgba(255, 193, 7, 0.3)",
            borderRadius: "12px",
            maxWidth: "480px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <p style={{ color: "#ffca28", fontWeight: "600", margin: "0 0 8px 0" }}>
            Avatar change is locked
          </p>
          <p style={{ color: "#ccc", fontSize: "0.95rem", margin: 0 }}>
            Complete all 3 assessments to unlock avatar customisation.
          </p>
        </div>
      )}
           <div className="all-answers-saved-note" style={{fontStyle: 'normal', marginTop: '-20px',  marginBottom: '0px', textAlign: 'center', color: '#b6b6b6', fontSize: '14px' }}>
                          <p>Your Avatar is saved locally in this browser only.</p>
                        </div>

      {/* Scrollable avatar grid */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingRight: "8px",
          margin: "0 -8px 1.5rem -8px",
          scrollbarWidth: "thin",
          scrollbarColor: "#028be8 #1e2a44",
          pointerEvents:
            completedAssessments.uniready &&
            completedAssessments.studystyle &&
            completedAssessments.futureready
              ? "auto"
              : "none",
          opacity:
            completedAssessments.uniready &&
            completedAssessments.studystyle &&
            completedAssessments.futureready
              ? 1
              : 0.5,
        }}
        className="custom-scrollbar"
      >
        <div className="avatar-modal-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "1.2rem",
            padding: "10px 8px",
          }}
        >
          {avatarStyles.map((style, index) => {
            const avatarId = `fa-avatar-${index + 1}`;
            const isSelected = selectedAvatar === avatarId;
            const isCurrent = currentAvatar === avatarId;

            return (
              <div
                key={index}
                onClick={() => {
                  if (
                    completedAssessments.uniready &&
                    completedAssessments.studystyle &&
                    completedAssessments.futureready
                  ) {
                    setSelectedAvatar(avatarId);
                  }
                }}
                style={{
                  border: isSelected
                    ? "4px solid #028be8"
                    : isCurrent
                    ? "4px solid #ffaa00"
                    : "2px solid #444",
                  borderRadius: "14px",
                  padding: "10px",
                  cursor:
                    completedAssessments.uniready &&
                    completedAssessments.studystyle &&
                    completedAssessments.futureready
                      ? "pointer"
                      : "not-allowed",
                  background: isSelected ? "rgba(2,139,232,0.15)" : "transparent",
                  textAlign: "center",
                  transition: "all 0.25s ease",
                  transform: isSelected ? "scale(1.06)" : "scale(1)",
                  boxShadow: isCurrent ? "0 6px 20px rgba(255,170,0,0.3)" : "none",
                  opacity:
                    completedAssessments.uniready &&
                    completedAssessments.studystyle &&
                    completedAssessments.futureready
                      ? 1
                      : 0.65,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    borderRadius: "50%",
                    backgroundColor: style.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: `3.5px solid ${style.color}`,
                    boxShadow: "inset 0 2px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <i
                    className={`fas fa-${style.icon}`}
                    style={{
                      fontSize: "2.4rem",
                      color: style.color,
                    }}
                  />
                </div>

                <div
                  style={{
                    marginTop: "8px",
                    fontSize: "0.82rem",
                    color: isCurrent ? "#ffaa00" : isSelected ? "#028be8" : "#bbb",
                    fontWeight: isCurrent || isSelected ? "600" : "normal",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {style.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          gap: "1.5rem",
          justifyContent: "center",
          marginTop: "1.5rem",
          paddingTop: "1rem",
          borderTop: "1px solid rgba(255,255,255,0.12)",
        }}
      >
        <button
 onClick={() => {
          setShowAvatarModal(false);
          localStorage.setItem(`has_seen_avatar_modal_${userId}`, "true");
      
        }}
style={{ padding: "10px 20px", background: "none", minWidth: "120px", border: "1px solid rgba(255,255,255,0.2)", color: "#ccc", borderRadius: "8px", cursor: "pointer", fontSize: "14px" }}
>
  Cancel
</button>

      <button
onClick={() => {
  if (!selectedAvatar) return;

  if (!isAdmin && !isAvatarChangeAllowed()) {
    showToast("You can only change your avatar once every 24 hours.", "error");
    return;
  }

  localStorage.setItem(`user_avatar_${userId}`, selectedAvatar);
  setCurrentAvatar(selectedAvatar);

  const now = new Date().toISOString();
  setLastAvatarChangeDate(now);

  setShowAvatarModal(false);
  showToast("Avatar updated successfully! (Stored locally)", "success");
}}
  disabled={
    !selectedAvatar ||
    !(
      completedAssessments.uniready &&
      completedAssessments.studystyle &&
      completedAssessments.futureready
    ) ||
    (!isAdmin && !isAvatarChangeAllowed())
  }
  style={{
    padding: "0.9rem 2rem",
    background:
      selectedAvatar &&
      completedAssessments.uniready &&
      completedAssessments.studystyle &&
      completedAssessments.futureready &&
      (isAdmin || isAvatarChangeAllowed())
        ? "#028be8"
        : "#555",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "1.05rem",
    cursor:
      selectedAvatar &&
      completedAssessments.uniready &&
      completedAssessments.studystyle &&
      completedAssessments.futureready &&
      (isAdmin || isAvatarChangeAllowed())
        ? "pointer"
        : "not-allowed",
    minWidth: "120px",
    opacity:
      selectedAvatar &&
      completedAssessments.uniready &&
      completedAssessments.studystyle &&
      completedAssessments.futureready &&
      (isAdmin || isAvatarChangeAllowed())
        ? 1
        : 0.6,
  }}
>
  Save
</button>
      </div>
    </div>
  </div>
)}


{showWhatsNextModalUniReady && (
  <div
    className="modal"
    style={{
      position: "fixed",
      backgroundColor: "rgba(0, 0, 0, 0.79)",
      zIndex: 1000,
    }}
  >
    <div
      className="modal-insights modal-uniready"
      style={{
        backgroundColor: "#0b1021",
        marginTop: "200px",
        padding: "20px",
        borderRadius: "10px",
        color: "white",
        width: "600px",
        maxWidth: "90%",
        position: "relative",
        top: "-20%",
        left: "7.5%",
      }}
    >
      <button
        className="modal-close-button"
        onClick={() => setShowWhatsNextModalUniReady(false)}
        aria-label="Close What's Next modal"
      >
        ×
      </button>

      <h4 style={{ color: "#028be8" }}>What's Next?</h4>

      <p>
        <br />
Your UniReady subject scores provide a strong indication of your higher education subject passions and preferences. They help you understand which areas you are most motivated by and rank subjects based on your interest and commitment levels. However, these scores should be used as guidance rather than a definitive decision-making tool. Students are encouraged to consider their higher education choices holistically, taking into account academic ability, long-term goals, and personal circumstances.        
</p>
         <p>
The next step is to explore each individual subject. By clicking on a subject, you can identify the relevant secondary education subject requirements and access curated pathways, including super-curricular activities, potential career routes, and subject-specific news. This deeper exploration helps you make informed and confident decisions about your future studies.
</p>

      {/* Subtly highlighted consultation section */}
      <div
      className="modal-whatsnext-consultation"
        style={{
          marginTop: "28px",
          padding: "16px 20px",
          backgroundColor: "rgba(2, 139, 232, 0.08)", // very subtle blue tint
          borderLeft: "4px solid #028be8",
          borderRadius: "6px",
          fontSize: "0.98rem",
          lineHeight: "1.45",
        }}
      >
        <p style={{ margin: "0 0 12px 0", fontWeight: "bold" }}>
Ready to take the next step in shaping your academic future?
        </p>
        <p style={{ margin: "0 0 16px 0", opacity: 0.92 }}>
          Contact Oxbridge Gateway for expert consultation — our advisors advisors can help you interpret your UniReady subject insights, refine your subject choices, and develop study strategies aligned with your long-term university goals. You’ll also receive support in understanding entry requirements, strengthening your academic profile, and exploring the right super-curricular opportunities.
        </p>
        <div className="report-book">
  <button
    onClick={handleDownloadFullReportFromDashboard}
    className="full-report"
    style={{
      display: "inline-block",
      backgroundColor: "transparent",
      color: "#00e1ff",
      border: "1px solid #00e1ff",
      padding: "10px 22px",
      borderRadius: "6px",
      fontWeight: "bold",
      fontSize: "0.97rem",
      cursor: "pointer",
      marginBottom: "12px",
      transition: "all 0.2s ease",
      height: "45px",
    }}
    onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "rgba(0,225,255,0.12)"; }}
    onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
  >
    <FaDownload style={{ marginRight: '10px' }} /> Full Report
  </button>
  <br />
               <a
          href="https://www.oxbridgegateway.com/aspiredeck"
          target="_blank"
          rel="noopener noreferrer"
          className="modal-whatsnext-consultation"
          style={{
            display: "inline-block",
            backgroundColor: "#028be8",
            color: "white",
            padding: "12px 22px",
            borderRadius: "6px",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "0.97rem",
            transition: "background-color 0.2s ease",
            height: "45px"
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0270c0")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#028be8")}
        >
          Book Consultation →
        </a>
      </div>
    </div>
    </div>
  </div>
)}


{/* ── Subject Career Map Modal ── */}
{careerMapSubject && (
  <SubjectCareerMapModal
    subject={careerMapSubject}
    jobposts={careerMapJobs}
    loading={careerMapLoading}
    onClose={() => {
      setCareerMapSubject(null);
      setCareerMapJobs([]);
      setCareerMapLoading(false);
  setTimeout(() => {
    isAnyModalOpenRef.current = false;
    setIsAnyModalOpen(false);
  }, 0);
    }}
    onJobClick={(job) => {
      navigateWithViewMode("/CareerDashboard", {
        sidebarItem: "compass",
        directToCompass: true,
        preselectedSubject: careerMapSubject,
        preselectedJobId: job.jobpost_id,
        sortedScores: topScores || [],
        sortedPart3Scores: topPart3Scores || [],
        chosenTopSubject: chosenTopSubject,
        userEmail: userEmail,
        userUsername: userUsername, 
      });
    }}
  />
)}

{/* ── Subject Super-Curricular Map Modal ── */}
{superMapSubject && (
  <SubjectSuperCurricularMapModal
    subject={superMapSubject}
    activities={superMapActivities}
    loading={superMapLoading}
  onClose={() => {
      setSuperMapSubject(null);
      setSuperMapActivities([]);
      setSuperMapLoading(false);
  setTimeout(() => {
    isAnyModalOpenRef.current = false;
    setIsAnyModalOpen(false);
  }, 0);
    }}
    onActivityClick={(activity) => {
      // Navigate to Enrich+ > SuperCurricular tab, pre-selecting this activity
      navigateWithViewMode("/dashboard_enrich", {
        sidebarItem: "supercurricular",
        preselectedSuperSubject: superMapSubject,
        preselectedCategory: activity.category,
        preselectedActivityId: activity.supercurricular_id,
        scrollToActivity: true,
        sortedScores: topScores || [],
        sortedPart3Scores: topPart3Scores || [],
        chosenTopSubject: chosenTopSubject,
        userEmail: userEmail,
        userUsername: userUsername, 
      });
    }}
  />
)}
  </div>
);
}

